import * as Types from '@coverright/data-access/types/enrollment';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UniqueClosesByAgentQueryVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
  currentRange: Types.DateRangeInput;
  previousRange: Types.DateRangeInput;
}>;


export type UniqueClosesByAgentQuery = { __typename?: 'Query', previous: { __typename?: 'PageableClientViewListRepresentationOutput', totalElements: any }, current: { __typename?: 'PageableClientViewListRepresentationOutput', totalElements: any } };

export type CalendlyAppointmentsByAgentQueryVariables = Types.Exact<{
  filter: Types.CalendlyAppointmentsFilterInput;
  pageInput: Types.PageInput;
  sort: Types.CalendlyAppointmentsSortInput;
  agentId: Types.Scalars['UUID']['input'];
}>;


export type CalendlyAppointmentsByAgentQuery = { __typename?: 'Query', calendlyAppointmentsByAgent: { __typename?: 'PageableCalendlyAppointmentsOutput', hasNext: boolean, number: number, totalElements: any, data: Array<{ __typename?: 'AppointmentOutput', createdBy?: string | null, createdAt: any, endTime?: any | null, noShow?: boolean | null, name: string, startTime?: any | null, status: string, updatedAt: any, url: string, agent: { __typename?: 'AgentOutput', lastName: string, firstName: string, email: string, picUrl?: string | null, id: any }, invitee: { __typename?: 'AppointmentInviteeOutput', url: string, lastName?: string | null, firstName?: string | null, clientId?: any | null, email: string, name?: string | null } }> } };

export type AgentCurrentClientsMetricsQueryVariables = Types.Exact<{
  filter: Types.AgentCurrentClientsMetricsFilterInput;
}>;


export type AgentCurrentClientsMetricsQuery = { __typename?: 'Query', agentCurrentClientsMetrics: Array<{ __typename?: 'AgentCurrentClientsMetricsOutput', agentEmail: string, agentEnabled: boolean, agentId: any, agentName: string, followUpFuture: number, followUpNotFuture: number, followUpOutdated: number, sqlNotFuture: number, sqlOutdated: number, sqlUpFuture: number }> };

export type TestSubscriptionErrorSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type TestSubscriptionErrorSubscription = { __typename?: 'Subscription', testSubscriptionError: any };

export type AllSalesQualifiedQueryVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
}>;


export type AllSalesQualifiedQuery = { __typename?: 'Query', allSalesQualified: { __typename?: 'PageableClientViewListRepresentationOutput', data: Array<{ __typename?: 'ClientViewListRepresentationOutput', clientId?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumber2?: string | null, birthDate?: any | null, userId?: any | null, state?: string | null, agentName?: string | null, agentId?: any | null, callsCount: string, lastCallDate?: any | null, status: Types.StatusDto, createdAt?: any | null, followUpDate?: any | null, expectedCloseDate?: any | null, urgentCallType?: Types.UrgentCallTypeDto | null, affiliationPartnershipSource?: string | null, profileSource?: Types.ProfileSource | null, latestNote?: string | null, latestNoteId?: any | null, managerNote?: string | null, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string } }> }> } };

export type AllFollowUpsQueryVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
  excludedTagsIds?: Types.InputMaybe<Array<Types.Scalars['UUID']['input']> | Types.Scalars['UUID']['input']>;
  includedTagsIds?: Types.InputMaybe<Array<Types.Scalars['UUID']['input']> | Types.Scalars['UUID']['input']>;
}>;


export type AllFollowUpsQuery = { __typename?: 'Query', allFollowUps: { __typename?: 'PageableClientViewListRepresentationOutput', data: Array<{ __typename?: 'ClientViewListRepresentationOutput', clientId?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumber2?: string | null, birthDate?: any | null, userId?: any | null, state?: string | null, agentName?: string | null, agentId?: any | null, callsCount: string, lastCallDate?: any | null, status: Types.StatusDto, createdAt?: any | null, followUpDate?: any | null, expectedCloseDate?: any | null, urgentCallType?: Types.UrgentCallTypeDto | null, affiliationPartnershipSource?: string | null, profileSource?: Types.ProfileSource | null, latestNote?: string | null, latestNoteId?: any | null, managerNote?: string | null, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string } }> }> } };

export type SaveManagerNoteMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  managerNote: Types.Scalars['String']['input'];
}>;


export type SaveManagerNoteMutation = { __typename?: 'Mutation', saveManagerNote: boolean };

export type AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation = { __typename?: 'Mutation', appointmentReminderCSRAcknowledgedAgentWillBeLateConfirmByAgent: boolean };

export type AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation = { __typename?: 'Mutation', appointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsr: boolean };

export type AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation = { __typename?: 'Mutation', appointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgent: boolean };

export type AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation = { __typename?: 'Mutation', appointmentReminderSuggestedToRescheduleAppointmentConfirmByAgent: boolean };

export type AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation = { __typename?: 'Mutation', appointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsr: boolean };

export type AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation = { __typename?: 'Mutation', appointmentReminderAgentConfirmedButWillBeLateConfirmByCsr: boolean };

export type AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation = { __typename?: 'Mutation', appointmentReminderAgentIsMissingAppointmentConfirmByCsr: boolean };

export type AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation = { __typename?: 'Mutation', appointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgent: boolean };

export type AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation = { __typename?: 'Mutation', appointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTime: boolean };

export type AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation = { __typename?: 'Mutation', appointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgent: boolean };

export type AppointmentReminderRequiredAgentConfirmationWillBeLateMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type AppointmentReminderRequiredAgentConfirmationWillBeLateMutation = { __typename?: 'Mutation', appointmentReminderRequiredAgentConfirmationWillBeLate: boolean };

export type AppointmentReminderRequiredAgentConfirmationConfirmMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type AppointmentReminderRequiredAgentConfirmationConfirmMutation = { __typename?: 'Mutation', appointmentReminderRequiredAgentConfirmationConfirm: boolean };

export type RequiredActionsSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type RequiredActionsSubscription = { __typename?: 'Subscription', requiredActions: Array<{ __typename?: 'RequiredActionOutput', createdAt: any, detailsJson: string, done: boolean, id: string, type: string, updatedAt: any }> };

export type AgentGmailAuthUrlQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentGmailAuthUrlQuery = { __typename?: 'Query', agentGmailAuthUrl: string };

export type ClientCommunicationNoShowMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ClientCommunicationNoShowMutation = { __typename?: 'Mutation', clientCommunicationNoShow: boolean };

export type DeleteActionItemMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type DeleteActionItemMutation = { __typename?: 'Mutation', deleteActionItem: boolean };

export type AgentCallAgendaWholeStateSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentCallAgendaWholeStateSubscription = { __typename?: 'Subscription', agentCallAgendaWholeState: { __typename?: 'CurrentAgentCallAgendaStateOutput', rrView: { __typename?: 'RRViewOutput', inActiveQueue: Array<any>, offline: Array<any>, busy: Array<{ __typename?: 'RRViewBusyAgentOutput', agentId: any, assignedToClient: boolean, dontDisturb: boolean, excluded: boolean, onACall: boolean }>, tasksWaitingPool: Array<{ __typename?: 'AgentCallAgendaTaskInPoolOutput', clientId: any, inPoolUntil: any }> }, agentsSorted: Array<{ __typename?: 'AgentAvailabilityStateOutput', agentEmail: string, agentId: any, agentName: string, availabilityIsUpdatedAt?: any | null, csr: boolean, dontDisturb: boolean, excludedFromRoundRobin: boolean, isAvailableForNewLeads: boolean, licensedStates?: string | null, picUrl?: string | null, onCall: boolean, airCallAvailabilityStatus?: string | null, online: boolean, onCallWithClient?: { __typename?: 'AgentAvailabilityStateCallDetails', clientEmail: string, clientId: any, clientName: string } | null }>, tasks: Array<{ __typename?: 'AgentCallAgendaTaskOutput', clientEmail: string, clientId: any, clientName: string, completed: boolean, createdAt: any, isNew: boolean, priorityReason?: string | null, state?: string | null, assignmentHistory: Array<{ __typename?: 'AgentCallAgendaTaskHistoryItemOutput', agentEmail?: string | null, agentId?: any | null, agentName?: string | null, type: Types.AgentCallAgendaTaskAssignmentTypeOutput }>, currentAssignment?: { __typename?: 'AgentCallAgendaTaskCurrentAssignmentOutput', assignedAgentEmail?: string | null, assignedAgentId?: any | null, assignedAgentName?: string | null, assignedUntil?: any | null, scheduledReassignAt?: any | null, type: Types.AgentCallAgendaTaskAssignmentTypeOutput } | null }> } };

export type SaveActionItemMutationVariables = Types.Exact<{
  input: Types.ActionItemInput;
}>;


export type SaveActionItemMutation = { __typename?: 'Mutation', saveActionItem: { __typename?: 'ActionItemOutput', id: any, clientId?: any | null, clientName?: string | null, createdAt: any, title: string, assigneeAgentId?: any | null, assigneeAgentName?: string | null, done: boolean, updatedAt: any, dueDate?: any | null, aiGenerated?: boolean | null } };

export type ActionItemsByClientIdQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ActionItemsByClientIdQuery = { __typename?: 'Query', actionItemsByClientId: Array<{ __typename?: 'ActionItemOutput', id: any, clientId?: any | null, clientName?: string | null, createdAt: any, title: string, assigneeAgentId?: any | null, assigneeAgentName?: string | null, done: boolean, updatedAt: any, dueDate?: any | null, aiGenerated?: boolean | null }> };

export type ActionItemsQueryVariables = Types.Exact<{
  filter: Types.ActionItemFilterInput;
  pageInput: Types.PageInput;
  sort?: Types.InputMaybe<Types.ActionItemSortInput>;
}>;


export type ActionItemsQuery = { __typename?: 'Query', actionItems: { __typename?: 'PageableActionItemOutput', totalElements: any, hasNext: boolean, number: number, data: Array<{ __typename?: 'ActionItemOutput', id: any, clientId?: any | null, clientName?: string | null, createdAt: any, title: string, assigneeAgentId?: any | null, assigneeAgentName?: string | null, done: boolean, updatedAt: any, dueDate?: any | null, aiGenerated?: boolean | null }> } };

export type ActionItemFieldsFragment = { __typename?: 'ActionItemOutput', id: any, clientId?: any | null, clientName?: string | null, createdAt: any, title: string, assigneeAgentId?: any | null, assigneeAgentName?: string | null, done: boolean, updatedAt: any, dueDate?: any | null, aiGenerated?: boolean | null };

export type CallHistoryAiAnalysisByClientQueryVariables = Types.Exact<{
  client: Types.Scalars['UUID']['input'];
}>;


export type CallHistoryAiAnalysisByClientQuery = { __typename?: 'Query', callHistoryAIAnalysisByClient: Array<{ __typename?: 'CallHistoryAIAnalysisOutput', callHistoryId: any, airCallTimeline?: string | null, aiAnalysis: string }> };

export type SaveTagMutationVariables = Types.Exact<{
  input: Types.TagInput;
}>;


export type SaveTagMutation = { __typename?: 'Mutation', saveTag: any };

export type DeleteTagMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: boolean };

export type TagsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'TagOutput', color?: string | null, id: any, name: string, aiEnabled?: boolean | null, aiDescription?: string | null }> };

export type SaveAgentGmailCodeMutationVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
}>;


export type SaveAgentGmailCodeMutation = { __typename?: 'Mutation', saveAgentGmailCode: boolean };

export type IsAgentGmailSetUpQueryVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
}>;


export type IsAgentGmailSetUpQuery = { __typename?: 'Query', isAgentGmailSetUp: boolean };

export type SetDefaultAgentMutationVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
}>;


export type SetDefaultAgentMutation = { __typename?: 'Mutation', setDefaultAgent: boolean };

export type UrgentCallRequestsSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type UrgentCallRequestsSubscription = { __typename?: 'Subscription', urgentCallRequests: Array<{ __typename?: 'UrgentRequestCallOutput', clientId: any, email?: string | null, firstName?: string | null, lastName?: string | null, urgentCallType?: Types.UrgentCallTypeDto | null }> };

export type UploadAgentAvatarMutationVariables = Types.Exact<{
  img: Types.Scalars['Upload']['input'];
}>;


export type UploadAgentAvatarMutation = { __typename?: 'Mutation', uploadAgentAvatar: string };

export type SaveAgentMutationVariables = Types.Exact<{
  input: Types.AgentInput;
}>;


export type SaveAgentMutation = { __typename?: 'Mutation', saveAgent: any };

export type AgentDashboardCountersQueryVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
  missingAppsTagId: Types.Scalars['UUID']['input'];
}>;


export type AgentDashboardCountersQuery = { __typename?: 'Query', salesQualified: { __typename?: 'PageableClientViewListRepresentationOutput', totalElements: any }, salesQualifiedFuture: { __typename?: 'PageableClientViewListRepresentationOutput', totalElements: any }, followUps: { __typename?: 'PageableClientViewListRepresentationOutput', totalElements: any }, followUpsFuture: { __typename?: 'PageableClientViewListRepresentationOutput', totalElements: any }, missingApps: { __typename?: 'PageableClientViewListRepresentationOutput', totalElements: any }, contacted: { __typename?: 'PageableClientViewListRepresentationOutput', totalElements: any } };

export type TwoHrCallbackSubscriptionVariables = Types.Exact<{
  filter: Types.SlaFilterInput;
}>;


export type TwoHrCallbackSubscription = { __typename?: 'Subscription', slas: { __typename?: 'PageableSLAOutput', totalElements: any, data: Array<{ __typename?: 'SLAOutput', createdAt?: any | null }> } };

export type NewLeadsStatisticsSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type NewLeadsStatisticsSubscription = { __typename?: 'Subscription', newLeadsStatistics: { __typename?: 'NewLeadsStatisticsOutput', count: number, nerdWalletCount: number, oldestCreatedAt?: any | null } };

export type DeleteClientFileMutationVariables = Types.Exact<{
  link: Types.Scalars['String']['input'];
  clientId: Types.Scalars['UUID']['input'];
}>;


export type DeleteClientFileMutation = { __typename?: 'Mutation', deleteClientFile: boolean };

export type AddClientFilesMutationVariables = Types.Exact<{
  clientFiles: Array<Types.ClientFileInput> | Types.ClientFileInput;
  clientId: Types.Scalars['UUID']['input'];
}>;


export type AddClientFilesMutation = { __typename?: 'Mutation', addClientFiles: boolean };

export type UpdateClientNoteMutationVariables = Types.Exact<{
  noteId: Types.Scalars['UUID']['input'];
  note: Types.Scalars['String']['input'];
}>;


export type UpdateClientNoteMutation = { __typename?: 'Mutation', updateClientNote: boolean };

export type CreateClientNoteMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  note: Types.Scalars['String']['input'];
  isManagerNote?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type CreateClientNoteMutation = { __typename?: 'Mutation', createClientNote: boolean };

export type SaveChannelAttributionMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  marketingCampaign?: Types.InputMaybe<Types.Scalars['String']['input']>;
  marketingSource?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SaveChannelAttributionMutation = { __typename?: 'Mutation', saveChannelAttribution: boolean };

export type SearchForClientGroupQueryVariables = Types.Exact<{
  pageInput: Types.PageInput;
  filterInput?: Types.InputMaybe<Types.ClientViewFilterInput>;
}>;


export type SearchForClientGroupQuery = { __typename?: 'Query', clientViews: { __typename?: 'PageableClientViewListRepresentationOutput', totalElements: any, data: Array<{ __typename?: 'ClientViewListRepresentationOutput', clientId?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null }> } };

export type DeleteClientNoteMutationVariables = Types.Exact<{
  noteId: Types.Scalars['UUID']['input'];
}>;


export type DeleteClientNoteMutation = { __typename?: 'Mutation', deleteClientNote: boolean };

export type SetClientUserIdMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  userId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type SetClientUserIdMutation = { __typename?: 'Mutation', setClientUserId: boolean };

export type CheckUserExistenceByEmailQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type CheckUserExistenceByEmailQuery = { __typename?: 'Query', checkUserExistenceByEmail: boolean };

export type SaveClientTagMutationVariables = Types.Exact<{
  input: Types.ClientTagInput;
}>;


export type SaveClientTagMutation = { __typename?: 'Mutation', saveClientTag: boolean };

export type SlasSubscriptionVariables = Types.Exact<{
  pageInput: Types.PageInput;
  filter: Types.SlaFilterInput;
}>;


export type SlasSubscription = { __typename?: 'Subscription', slas: { __typename?: 'PageableSLAOutput', totalElements: any, data: Array<{ __typename?: 'SLAOutput', firstCallAgentName?: string | null, secondCallAgentName?: string | null, callsCount: number, state?: string | null, clientId: any, createdAt?: any | null, firstCallAt?: any | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, secondCallAt?: any | null, status: Types.StatusDto, successfulCallsCount: number, agent?: { __typename?: 'AgentViewOutput', email: string, firstName: string, id: any, lastName: string } | null, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string } }> }> } };

export type AttemptedLeadsQueryVariables = Types.Exact<{
  filter: Types.AttemptedLeadFilterInput;
  pageInput: Types.PageInput;
  sort?: Types.InputMaybe<Types.AttemptedLeadSortInput>;
}>;


export type AttemptedLeadsQuery = { __typename?: 'Query', attemptedLeads: { __typename?: 'PageableAttemptedLeadOutput', totalElements: any, data: Array<{ __typename?: 'AttemptedLeadOutput', birthDate?: any | null, callsCount: number, clientId: any, firstName?: string | null, email?: string | null, iepFlag?: boolean | null, lastCallDate?: any | null, lastName?: string | null, leadDate: any, leadGroup?: Types.AttemptedLeadGroupDto | null, phoneNumber?: string | null, state?: string | null, status: Types.Status, urgent: boolean, lastCallAgentFullName?: string | null, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string } }> }> } };

export type AvailableAgentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AvailableAgentsQuery = { __typename?: 'Query', availableAgents: Array<{ __typename?: 'AgentViewOutput', email: string, firstName: string, lastName: string, id: any }> };

export type PatchClientPersonalInfoMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  preferredDrugs?: Types.InputMaybe<Array<Types.PreferredDrugInput> | Types.PreferredDrugInput>;
  preferredPharmacies?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  drugDeliveryType?: Types.InputMaybe<Types.ClientDrugDeliveryType>;
}>;


export type PatchClientPersonalInfoMutation = { __typename?: 'Mutation', patchClientPersonalInfo: boolean };

export type SetRecordedLineAgreementCheckMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type SetRecordedLineAgreementCheckMutation = { __typename?: 'Mutation', setRecordedLineAgreementCheck: boolean };

export type SetTpmoAgreementCheckMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type SetTpmoAgreementCheckMutation = { __typename?: 'Mutation', setTPMOAgreementCheck: boolean };

export type SetSoaAgreementCheckMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type SetSoaAgreementCheckMutation = { __typename?: 'Mutation', setSOAAgreementCheck: boolean };

export type AgentsQueryVariables = Types.Exact<{
  page: Types.PageInput;
  filter: Types.AgentFilterInput;
  sort?: Types.InputMaybe<Types.AgentSortInput>;
}>;


export type AgentsQuery = { __typename?: 'Query', agents: { __typename?: 'PageableAgentOutput', totalElements: any, data: Array<{ __typename?: 'AgentOutput', consultationUrl?: string | null, email: string, enabled: boolean, enrollmentMeetingUrl?: string | null, firstName: string, id: any, lastName: string, phone?: string | null, picUrl?: string | null, planReviewUrl?: string | null, receiveEmails: boolean, isDefault: boolean, isCSR: boolean, enabledForRoundRobin?: boolean | null, role: string }> } };

export type AgentCallAgendaSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentCallAgendaSubscription = { __typename?: 'Subscription', agentCallAgenda: { __typename?: 'AgentCallAgendaOutput', assignedClientsCallTasks: Array<any>, dontDisturb: boolean, scheduledReassignAt?: any | null } };

export type StartTestCallFor30SecondsMutationVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
  clientId: Types.Scalars['UUID']['input'];
}>;


export type StartTestCallFor30SecondsMutation = { __typename?: 'Mutation', startTestCallFor30Seconds: boolean };

export type SetDontDisturbMutationVariables = Types.Exact<{
  dontDisturb: Types.Scalars['Boolean']['input'];
}>;


export type SetDontDisturbMutation = { __typename?: 'Mutation', setDontDisturb: boolean };

export type AgentByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type AgentByIdQuery = { __typename?: 'Query', agentById: { __typename?: 'AgentOutput', consultationUrl?: string | null, email: string, enabled: boolean, enrollmentMeetingUrl?: string | null, b2bMeetingUrl?: string | null, firstName: string, id: any, lastName: string, phone?: string | null, picUrl?: string | null, planReviewUrl?: string | null, receiveEmails: boolean, isDefault: boolean, isCSR: boolean, role: string } };

export type CsrTrackingReportQueryVariables = Types.Exact<{
  from: Types.Scalars['LocalDate']['input'];
  to: Types.Scalars['LocalDate']['input'];
}>;


export type CsrTrackingReportQuery = { __typename?: 'Query', csrTrackingReport: Array<{ __typename?: 'CsrTrackingReportOutput', bookedCallsCount: number, email: string, agentId: any, nonWarmTransfersAttendedCount: number, nonWarmTransfersCount: number, warmTransfersCount: number, futureAppointmentsCount: number, undispositionedAppointmentsCount: number, nonWarmTransfersNotAttendedCount: number }> };

export type SaveStatusMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  status: Types.StatusDto;
  agentId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  followUpDate?: Types.InputMaybe<Types.Scalars['LocalDate']['input']>;
}>;


export type SaveStatusMutation = { __typename?: 'Mutation', saveStatus: boolean };

export type SaveExpectedCloseDateMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  expectedCloseDate: Types.Scalars['LocalDate']['input'];
}>;


export type SaveExpectedCloseDateMutation = { __typename?: 'Mutation', saveExpectedCloseDate: boolean };

export type SaveDisqualifiedReasonMutationVariables = Types.Exact<{
  disqualifiedReason: Types.DisqualifiedReasonDto;
  id: Types.Scalars['UUID']['input'];
}>;


export type SaveDisqualifiedReasonMutation = { __typename?: 'Mutation', saveDisqualifiedReason: boolean };

export type CsrCalendlyAppointmentsQueryVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
  from: Types.Scalars['LocalDate']['input'];
  to: Types.Scalars['LocalDate']['input'];
}>;


export type CsrCalendlyAppointmentsQuery = { __typename?: 'Query', csrCalendlyAppointments: Array<{ __typename?: 'AppointmentOutput', createdBy?: string | null, createdAt: any, endTime?: any | null, noShow?: boolean | null, name: string, startTime?: any | null, status: string, updatedAt: any, url: string, agent: { __typename?: 'AgentOutput', lastName: string, firstName: string, email: string, picUrl?: string | null, id: any }, invitee: { __typename?: 'AppointmentInviteeOutput', url: string, lastName?: string | null, firstName?: string | null, clientId?: any | null, email: string, name?: string | null } }> };

export type ClientCalendlyAppointmentsQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ClientCalendlyAppointmentsQuery = { __typename?: 'Query', clientCalendlyAppointments: Array<{ __typename?: 'AppointmentOutput', createdBy?: string | null, createdAt: any, endTime?: any | null, noShow?: boolean | null, name: string, startTime?: any | null, status: string, updatedAt: any, url: string, agent: { __typename?: 'AgentOutput', lastName: string, firstName: string, email: string, picUrl?: string | null, id: any }, invitee: { __typename?: 'AppointmentInviteeOutput', url: string, lastName?: string | null, firstName?: string | null, clientId?: any | null, email: string, name?: string | null } }> };

export type AppointmentFieldsFragment = { __typename?: 'AppointmentOutput', createdBy?: string | null, createdAt: any, endTime?: any | null, noShow?: boolean | null, name: string, startTime?: any | null, status: string, updatedAt: any, url: string, agent: { __typename?: 'AgentOutput', lastName: string, firstName: string, email: string, picUrl?: string | null, id: any }, invitee: { __typename?: 'AppointmentInviteeOutput', url: string, lastName?: string | null, firstName?: string | null, clientId?: any | null, email: string, name?: string | null } };

export type SetCalendlyAppointmentNoShowMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  noShow: Types.Scalars['Boolean']['input'];
}>;


export type SetCalendlyAppointmentNoShowMutation = { __typename?: 'Mutation', setCalendlyAppointmentNoShow: boolean };

export type ChangeEnrollmentStatusMutationVariables = Types.Exact<{
  enrollmentId: Types.Scalars['UUID']['input'];
  status: Types.EnrollmentStatusInput;
}>;


export type ChangeEnrollmentStatusMutation = { __typename?: 'Mutation', changeEnrollmentStatus?: any | null };

export type ChangeMedigapEnrollmentStatusMutationVariables = Types.Exact<{
  enrollmentId: Types.Scalars['UUID']['input'];
  status: Types.MedigapEnrollmentStatus;
}>;


export type ChangeMedigapEnrollmentStatusMutation = { __typename?: 'Mutation', changeMedigapEnrollmentStatus: boolean };

export type SaveMedigapEnrollmentMutationVariables = Types.Exact<{
  input: Types.MedigapEnrollmentInput;
}>;


export type SaveMedigapEnrollmentMutation = { __typename?: 'Mutation', saveMedigapEnrollment: any };

export type DeletePdpEnrollmentMutationVariables = Types.Exact<{
  enrollmentId: Types.Scalars['UUID']['input'];
}>;


export type DeletePdpEnrollmentMutation = { __typename?: 'Mutation', deletePdpEnrollment: boolean };

export type ChangePdpEnrollmentStatusMutationVariables = Types.Exact<{
  enrollmentId: Types.Scalars['UUID']['input'];
  status: Types.PdpEnrollmentStatus;
}>;


export type ChangePdpEnrollmentStatusMutation = { __typename?: 'Mutation', changePdpEnrollmentStatus: boolean };

export type AgentByContextQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentByContextQuery = { __typename?: 'Query', agentByContext: { __typename?: 'AgentOutput', consultationUrl?: string | null, email: string, enabled: boolean, enrollmentMeetingUrl?: string | null, firstName: string, id: any, lastName: string, phone?: string | null, picUrl?: string | null, planReviewUrl?: string | null, receiveEmails: boolean, isDefault: boolean, isCSR: boolean, enabledForRoundRobin?: boolean | null } };

export type SaveEnrollmentMutationVariables = Types.Exact<{
  input: Types.EnrollmentInput;
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  userId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type SaveEnrollmentMutation = { __typename?: 'Mutation', saveEnrollment: any };

export type SavePdpEnrollmentMutationVariables = Types.Exact<{
  input: Types.PdpEnrollmentInput;
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type SavePdpEnrollmentMutation = { __typename?: 'Mutation', savePdpEnrollment: { __typename?: 'PdpEnrollmentOutput', id: any } };

export type DeleteMedigapEnrollmentMutationVariables = Types.Exact<{
  medigapEnrollmentId: Types.Scalars['UUID']['input'];
}>;


export type DeleteMedigapEnrollmentMutation = { __typename?: 'Mutation', deleteMedigapEnrollment: boolean };

export type DeleteEnrollmentMutationVariables = Types.Exact<{
  enrollmentId: Types.Scalars['UUID']['input'];
}>;


export type DeleteEnrollmentMutation = { __typename?: 'Mutation', deleteEnrollment: boolean };

export type AllEnrollmentsQueryVariables = Types.Exact<{
  filter: Types.AllEnrollmentsFilterInput;
  page: Types.PageInput;
}>;


export type AllEnrollmentsQuery = { __typename?: 'Query', allEnrollments: { __typename?: 'PageableEnrollmentListItemOutput', totalElements: any, data: Array<{ __typename?: 'EnrollmentListItemOutput', age?: number | null, agentId?: any | null, approvedAt?: any | null, bidId?: string | null, birthDate?: any | null, clientId?: any | null, county?: string | null, mgPlanKey?: string | null, createdAt?: any | null, effectiveDate?: any | null, applicationDate?: any | null, firstName?: string | null, gender?: Types.Gender | null, email?: string | null, id: any, lastName?: string | null, mgPlanName?: string | null, planYear?: string | null, naic?: string | null, phoneNumber?: string | null, carrierName?: string | null, planName?: string | null, started?: any | null, status: string, tobacco?: boolean | null, type: Types.EnrollmentType, zip?: string | null, pdpQuoteId?: any | null, enrollmentType?: string | null }> } };

export type ClientGroupByClientIdQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ClientGroupByClientIdQuery = { __typename?: 'Query', clientGroupByClientId?: { __typename?: 'ClientGroupOutput', id: any, clients: Array<{ __typename?: 'ClientGroupItemOutput', clientId: any, email?: string | null, firstName?: string | null, lastName?: string | null }> } | null };

export type MergeClientsInOneGroupMutationVariables = Types.Exact<{
  clientIds: Array<Types.Scalars['UUID']['input']> | Types.Scalars['UUID']['input'];
}>;


export type MergeClientsInOneGroupMutation = { __typename?: 'Mutation', mergeClientsInOneGroup: boolean };

export type DeleteClientsFromAnyGroupMutationVariables = Types.Exact<{
  clientIds: Array<Types.Scalars['UUID']['input']> | Types.Scalars['UUID']['input'];
}>;


export type DeleteClientsFromAnyGroupMutation = { __typename?: 'Mutation', deleteClientsFromAnyGroup: boolean };

export type ShortenedCostActivationLinkQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ShortenedCostActivationLinkQuery = { __typename?: 'Query', shortenedCostActivationLink?: string | null };

export type UpdateLeadSourcesMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type UpdateLeadSourcesMutation = { __typename?: 'Mutation', updateSources: Array<{ __typename?: 'LeadSourceOutput', campaign: string }> };

export type ClientLeadSourcesQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ClientLeadSourcesQuery = { __typename?: 'Query', clientLeadSources: Array<{ __typename?: 'LeadSourceOutput', campaign: string, eventDate: any, medium: string, source: string, term?: string | null, content?: string | null }> };

export type SendComparisonEmailMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  link: Types.Scalars['String']['input'];
}>;


export type SendComparisonEmailMutation = { __typename?: 'Mutation', sendComparisonEmail: boolean };

export type DeleteEmailTemplateMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type DeleteEmailTemplateMutation = { __typename?: 'Mutation', deleteEmailTemplate: boolean };

export type SaveEmailTemplateMutationVariables = Types.Exact<{
  emailTemplate: Types.EmailTemplateDtoInput;
}>;


export type SaveEmailTemplateMutation = { __typename?: 'Mutation', saveEmailTemplate: any };

export type EmailTemplateQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type EmailTemplateQuery = { __typename?: 'Query', emailTemplate: { __typename?: 'EmailTemplateDto', title: string, template: string, id?: any | null } };

export type EmailTemplatesQueryVariables = Types.Exact<{
  pageInput: Types.PageInput;
}>;


export type EmailTemplatesQuery = { __typename?: 'Query', emailTemplates: { __typename?: 'PageableEmailTemplateOutput', totalElements: any, data: Array<{ __typename?: 'EmailTemplateDto', id?: any | null, template: string, title: string }> } };

export type SaveUserProfileMutationVariables = Types.Exact<{
  data: Types.UserProfileInput;
}>;


export type SaveUserProfileMutation = { __typename?: 'Mutation', saveUserProfile: { __typename?: 'UserProfileSaveOutput', enrollmentId?: any | null, profileId: any, userId?: any | null, clientId?: any | null, userToken?: { __typename?: 'UserToken', accessToken: string, idToken: string, refreshToken: string } | null } };

export type SaveCallHistoryMutationVariables = Types.Exact<{
  input: Types.CallHistoryInput;
}>;


export type SaveCallHistoryMutation = { __typename?: 'Mutation', saveCallHistory: any };

export type CallHistoryAiAnalysisQueryVariables = Types.Exact<{
  callHistory: Types.Scalars['UUID']['input'];
}>;


export type CallHistoryAiAnalysisQuery = { __typename?: 'Query', callHistoryAIAnalysis?: { __typename?: 'CallHistoryAIAnalysisOutput', aiAnalysis: string, airCallTimeline?: string | null, callHistoryId: any } | null };

export type CallQaFieldsFragment = { __typename?: 'CallQaOutput', qaScore?: number | null, overriddenScore?: number | null, effectiveScore?: number | null, wasOverridden: boolean, applicableMax?: number | null, pointsLost?: number | null, dispositionClass: string, isEnrollmentCall: boolean, overallAssessment?: string | null, coachingRecommendations?: string | null, rubricVersion?: string | null, scoredAt?: any | null, reviewedBy?: any | null, reviewedAt?: any | null, reviewNote?: string | null, questions: Array<{ __typename?: 'QaQuestionOutput', id: string, category: string, question: string, answer: string, evidence?: string | null, sourceAirCallId?: string | null, maxDeduction: number, deductionApplied: number }> };

export type CallHistoryFieldsFragment = { __typename?: 'CallHistoryOutput', callType?: Types.CallHistoryCallType | null, clientId: any, createdAt?: any | null, id?: any | null, airCallId?: any | null, phoneNumber: string, result?: string | null, audioRecordId?: any | null, transcription?: string | null, hasAIAnalysis: boolean, maskedTranscript?: string | null, callHistoryAnalysis?: { __typename?: 'CallHistoryAnalysisOutput', topics?: Array<string> | null, summary?: string | null, sentiment?: string | null } | null, agent?: { __typename?: 'AgentViewOutput', firstName: string, lastName: string, id: any, picUrl?: string | null, email: string } | null, callQa?: { __typename?: 'CallQaOutput', qaScore?: number | null, overriddenScore?: number | null, effectiveScore?: number | null, wasOverridden: boolean, applicableMax?: number | null, pointsLost?: number | null, dispositionClass: string, isEnrollmentCall: boolean, overallAssessment?: string | null, coachingRecommendations?: string | null, rubricVersion?: string | null, scoredAt?: any | null, reviewedBy?: any | null, reviewedAt?: any | null, reviewNote?: string | null, questions: Array<{ __typename?: 'QaQuestionOutput', id: string, category: string, question: string, answer: string, evidence?: string | null, sourceAirCallId?: string | null, maxDeduction: number, deductionApplied: number }> } | null };

export type CallHistoryItemsQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  page: Types.PageInput;
}>;


export type CallHistoryItemsQuery = { __typename?: 'Query', callHistoryItems: { __typename?: 'PageableCallHistoryOutput', totalElements: any, data: Array<{ __typename?: 'CallHistoryOutput', callType?: Types.CallHistoryCallType | null, clientId: any, createdAt?: any | null, id?: any | null, airCallId?: any | null, phoneNumber: string, result?: string | null, audioRecordId?: any | null, transcription?: string | null, hasAIAnalysis: boolean, maskedTranscript?: string | null, callHistoryAnalysis?: { __typename?: 'CallHistoryAnalysisOutput', topics?: Array<string> | null, summary?: string | null, sentiment?: string | null } | null, agent?: { __typename?: 'AgentViewOutput', firstName: string, lastName: string, id: any, picUrl?: string | null, email: string } | null, callQa?: { __typename?: 'CallQaOutput', qaScore?: number | null, overriddenScore?: number | null, effectiveScore?: number | null, wasOverridden: boolean, applicableMax?: number | null, pointsLost?: number | null, dispositionClass: string, isEnrollmentCall: boolean, overallAssessment?: string | null, coachingRecommendations?: string | null, rubricVersion?: string | null, scoredAt?: any | null, reviewedBy?: any | null, reviewedAt?: any | null, reviewNote?: string | null, questions: Array<{ __typename?: 'QaQuestionOutput', id: string, category: string, question: string, answer: string, evidence?: string | null, sourceAirCallId?: string | null, maxDeduction: number, deductionApplied: number }> } | null }> } };

export type CallHistoryByAirCallIdQueryVariables = Types.Exact<{
  airCallId: Types.Scalars['Long']['input'];
}>;


export type CallHistoryByAirCallIdQuery = { __typename?: 'Query', callHistoryByAirCallId?: { __typename?: 'CallHistoryOutput', callType?: Types.CallHistoryCallType | null, clientId: any, createdAt?: any | null, id?: any | null, airCallId?: any | null, phoneNumber: string, result?: string | null, audioRecordId?: any | null, transcription?: string | null, hasAIAnalysis: boolean, maskedTranscript?: string | null, callHistoryAnalysis?: { __typename?: 'CallHistoryAnalysisOutput', topics?: Array<string> | null, summary?: string | null, sentiment?: string | null } | null, agent?: { __typename?: 'AgentViewOutput', firstName: string, lastName: string, id: any, picUrl?: string | null, email: string } | null, callQa?: { __typename?: 'CallQaOutput', qaScore?: number | null, overriddenScore?: number | null, effectiveScore?: number | null, wasOverridden: boolean, applicableMax?: number | null, pointsLost?: number | null, dispositionClass: string, isEnrollmentCall: boolean, overallAssessment?: string | null, coachingRecommendations?: string | null, rubricVersion?: string | null, scoredAt?: any | null, reviewedBy?: any | null, reviewedAt?: any | null, reviewNote?: string | null, questions: Array<{ __typename?: 'QaQuestionOutput', id: string, category: string, question: string, answer: string, evidence?: string | null, sourceAirCallId?: string | null, maxDeduction: number, deductionApplied: number }> } | null } | null };

export type EditQaReviewMutationVariables = Types.Exact<{
  airCallId: Types.Scalars['Long']['input'];
  overriddenScore?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  editedAuditSheet?: Types.InputMaybe<Types.Scalars['String']['input']>;
  note?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type EditQaReviewMutation = { __typename?: 'Mutation', editQaReview: { __typename?: 'CallQaOutput', qaScore?: number | null, overriddenScore?: number | null, effectiveScore?: number | null, wasOverridden: boolean, applicableMax?: number | null, pointsLost?: number | null, dispositionClass: string, isEnrollmentCall: boolean, overallAssessment?: string | null, coachingRecommendations?: string | null, rubricVersion?: string | null, scoredAt?: any | null, reviewedBy?: any | null, reviewedAt?: any | null, reviewNote?: string | null, questions: Array<{ __typename?: 'QaQuestionOutput', id: string, category: string, question: string, answer: string, evidence?: string | null, sourceAirCallId?: string | null, maxDeduction: number, deductionApplied: number }> } };

export type QaCallRowFieldsFragment = { __typename?: 'QaCallRowOutput', airCallId: any, callDate?: any | null, clientId: any, clientName?: string | null, agentId?: any | null, agentName?: string | null, effectiveScore?: number | null, dispositionClass: string, isEnrollmentCall: boolean, wasOverridden: boolean };

export type AgentQaReportFieldsFragment = { __typename?: 'AgentQaReportOutput', agentId?: any | null, agentName?: string | null, summary: { __typename?: 'QaSummaryOutput', callsScored: number, enrollmentCalls: number, averageScore: number, bestScore?: number | null, worstScore?: number | null, trend: Array<{ __typename?: 'QaTrendPointOutput', periodStart: any, averageScore: number, callsScored: number }> }, pointsLostByCategory: Array<{ __typename?: 'QaCategoryStatOutput', category: string, pointsLost: number, callsApplicable: number }>, mostFailedQuestions: Array<{ __typename?: 'QaQuestionStatOutput', questionId: string, question: string, failCount: number, applicableCount: number, failRate: number }>, recentCalls: Array<{ __typename?: 'QaCallRowOutput', airCallId: any, callDate?: any | null, clientId: any, clientName?: string | null, agentId?: any | null, agentName?: string | null, effectiveScore?: number | null, dispositionClass: string, isEnrollmentCall: boolean, wasOverridden: boolean }> };

export type QaByAgentQueryVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
  filter?: Types.InputMaybe<Types.CallQaFilterInput>;
}>;


export type QaByAgentQuery = { __typename?: 'Query', qaByAgent: { __typename?: 'AgentQaReportOutput', agentId?: any | null, agentName?: string | null, summary: { __typename?: 'QaSummaryOutput', callsScored: number, enrollmentCalls: number, averageScore: number, bestScore?: number | null, worstScore?: number | null, trend: Array<{ __typename?: 'QaTrendPointOutput', periodStart: any, averageScore: number, callsScored: number }> }, pointsLostByCategory: Array<{ __typename?: 'QaCategoryStatOutput', category: string, pointsLost: number, callsApplicable: number }>, mostFailedQuestions: Array<{ __typename?: 'QaQuestionStatOutput', questionId: string, question: string, failCount: number, applicableCount: number, failRate: number }>, recentCalls: Array<{ __typename?: 'QaCallRowOutput', airCallId: any, callDate?: any | null, clientId: any, clientName?: string | null, agentId?: any | null, agentName?: string | null, effectiveScore?: number | null, dispositionClass: string, isEnrollmentCall: boolean, wasOverridden: boolean }> } };

export type QaAgentReportsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CallQaFilterInput>;
}>;


export type QaAgentReportsQuery = { __typename?: 'Query', qaAgentReports: Array<{ __typename?: 'AgentQaReportOutput', agentId?: any | null, agentName?: string | null, summary: { __typename?: 'QaSummaryOutput', callsScored: number, enrollmentCalls: number, averageScore: number, bestScore?: number | null, worstScore?: number | null, trend: Array<{ __typename?: 'QaTrendPointOutput', periodStart: any, averageScore: number, callsScored: number }> }, pointsLostByCategory: Array<{ __typename?: 'QaCategoryStatOutput', category: string, pointsLost: number, callsApplicable: number }>, mostFailedQuestions: Array<{ __typename?: 'QaQuestionStatOutput', questionId: string, question: string, failCount: number, applicableCount: number, failRate: number }>, recentCalls: Array<{ __typename?: 'QaCallRowOutput', airCallId: any, callDate?: any | null, clientId: any, clientName?: string | null, agentId?: any | null, agentName?: string | null, effectiveScore?: number | null, dispositionClass: string, isEnrollmentCall: boolean, wasOverridden: boolean }> }> };

export type QaCompareQueryVariables = Types.Exact<{
  groups: Array<Types.QaCompareGroupInput> | Types.QaCompareGroupInput;
  filter?: Types.InputMaybe<Types.CallQaFilterInput>;
}>;


export type QaCompareQuery = { __typename?: 'Query', qaCompare: { __typename?: 'QaCompareOutput', groups: Array<{ __typename?: 'QaCompareGroupOutput', label: string, report: { __typename?: 'AgentQaReportOutput', summary: { __typename?: 'QaSummaryOutput', averageScore: number, callsScored: number } } }>, comparison?: { __typename?: 'QaComparisonOutput', scoreDelta: number, categoryDeltas: Array<{ __typename?: 'QaCategoryDeltaOutput', category: string, groupA: number, groupB: number, delta: number }>, questionDeltas: Array<{ __typename?: 'QaQuestionDeltaOutput', questionId: string, groupAFailRate: number, groupBFailRate: number, delta: number }> } | null } };

export type QaQuestionPerformanceQueryVariables = Types.Exact<{
  questionId: Types.Scalars['String']['input'];
  filter?: Types.InputMaybe<Types.CallQaFilterInput>;
}>;


export type QaQuestionPerformanceQuery = { __typename?: 'Query', qaQuestionPerformance: { __typename?: 'QaQuestionPerformanceOutput', questionId: string, failRate: number, pointsLost: number, totalApplicable: number, excludedNA: number, trend: Array<{ __typename?: 'QaTrendPointOutput', periodStart: any, averageScore: number, callsScored: number }>, perAgent: Array<{ __typename?: 'QaQuestionPerAgentOutput', agentId?: any | null, agentName?: string | null, failRate: number }> } };

export type QaAuditsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CallQaFilterInput>;
  page: Types.PageInput;
}>;


export type QaAuditsQuery = { __typename?: 'Query', qaAudits: { __typename?: 'PageableQaAuditOutput', totalPages: number, totalElements: any, number: number, size: number, isFirst: boolean, isLast: boolean, hasNext: boolean, hasPrevious: boolean, data: Array<{ __typename?: 'QaCallRowOutput', airCallId: any, callDate?: any | null, clientId: any, clientName?: string | null, agentId?: any | null, agentName?: string | null, effectiveScore?: number | null, dispositionClass: string, isEnrollmentCall: boolean, wasOverridden: boolean }> } };

export type QaByClientQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  filter?: Types.InputMaybe<Types.CallQaFilterInput>;
}>;


export type QaByClientQuery = { __typename?: 'Query', qaByClient: { __typename?: 'ClientQaReportOutput', calls: Array<{ __typename?: 'QaCallRowOutput', airCallId: any, callDate?: any | null, clientId: any, clientName?: string | null, agentId?: any | null, agentName?: string | null, effectiveScore?: number | null, dispositionClass: string, isEnrollmentCall: boolean, wasOverridden: boolean }>, aggregate: { __typename?: 'AgentQaReportOutput', agentId?: any | null, agentName?: string | null, summary: { __typename?: 'QaSummaryOutput', callsScored: number, enrollmentCalls: number, averageScore: number, bestScore?: number | null, worstScore?: number | null, trend: Array<{ __typename?: 'QaTrendPointOutput', periodStart: any, averageScore: number, callsScored: number }> }, pointsLostByCategory: Array<{ __typename?: 'QaCategoryStatOutput', category: string, pointsLost: number, callsApplicable: number }>, mostFailedQuestions: Array<{ __typename?: 'QaQuestionStatOutput', questionId: string, question: string, failCount: number, applicableCount: number, failRate: number }>, recentCalls: Array<{ __typename?: 'QaCallRowOutput', airCallId: any, callDate?: any | null, clientId: any, clientName?: string | null, agentId?: any | null, agentName?: string | null, effectiveScore?: number | null, dispositionClass: string, isEnrollmentCall: boolean, wasOverridden: boolean }> } } };

export type ClientViewByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type ClientViewByIdQuery = { __typename?: 'Query', clientViewById?: { __typename?: 'ClientViewOutput', id: any, managerNote?: string | null, recordedLineAgreementCheck?: boolean | null, soaAgreementCheck?: boolean | null, tpmoAgreementCheck?: boolean | null, tobacco?: boolean | null, urgentCallRequested?: boolean | null, urgentCallType?: Types.UrgentCallTypeDto | null, enrolled?: string | null, adviserName?: string | null, adviserEmail?: string | null, adviserPhone?: string | null, profileSource?: Types.ProfileSource | null, customAnswers?: string | null, countyName?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, userId?: any | null, pin?: string | null, noShow?: boolean | null, disqualifiedReason?: Types.DisqualifiedReasonDto | null, scheduledTagPlacement?: boolean | null, medicareNumber?: string | null, medicarePartBStartedAt?: any | null, medicarePartAStartedAt?: any | null, phoneNumber2?: string | null, isDNC: boolean, isLitigator: boolean, eligibleName?: string | null, gender?: string | null, profileId?: any | null, quoteId?: any | null, status: Types.StatusDto, birthDate?: any | null, zip?: string | null, cId?: string | null, uId?: string | null, utmBrand?: string | null, utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null, utmTerm?: string | null, wbraid?: string | null, msclkid?: string | null, gbraid?: string | null, gclid?: string | null, fbclid?: string | null, state?: string | null, followUpDate?: any | null, originalClientId?: any | null, expectedCloseDate?: any | null, preferredPharmacies: Array<string>, scopeOfAppointmentStatus?: Types.ScopeOfAppointmentStatusDto | null, createdAt?: string | null, additionalInformation?: string | null, soaAgreement?: boolean | null, bookingFor?: string | null, planTypes?: Array<string> | null, retireIn3Months?: string | null, clientFiles: Array<{ __typename?: 'ClientFileOutput', link: string, name: string }>, notes: Array<{ __typename?: 'ClientNoteOutput', clientId: any, createdAt: any, id: any, note: string, updatedAt: any, isManagerNote: boolean, createdByAgent?: { __typename?: 'AgentViewOutput', email: string, firstName: string, id: any, lastName: string, picUrl?: string | null } | null }>, leadSources?: Array<{ __typename?: 'LeadSourceOutput', source: string }> | null, pdpQuote?: { __typename?: 'PdpQuoteOutput', cId?: string | null, clientId: any, countyName?: string | null, createdAt: any, id: any, insulinSavings?: boolean | null, updatedAt: any, userId?: any | null, zip?: string | null } | null, medigapQuote?: { __typename?: 'MedigapQuoteViewOutput', cId?: string | null, createdAt?: any | null, id: any, updatedAt?: any | null, userId?: any | null, medigapFilterState?: { __typename?: 'MedigapFilterStateViewOutput', age: number, benefits?: Array<Types.MedigapFilterStateBenefit> | null, companies?: Array<string> | null, county?: string | null, effectiveDate?: any | null, gender: Types.MedigapFilterStateGender, id?: any | null, monthlyPlanPremiumRanges?: Array<string> | null, planCategory?: string | null, planNames?: Array<Types.MedigapFilterStatePlanName> | null, tobacco: boolean, zip: string } | null } | null, watchers: Array<{ __typename?: 'AgentViewOutput', email: string, firstName: string, id: any, lastName: string, picUrl?: string | null }>, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string, aiEnabled?: boolean | null } }>, agent?: { __typename?: 'AgentViewOutput', email: string, firstName: string, lastName: string, id: any, picUrl?: string | null } | null, preCallBriefing?: { __typename?: 'PreCallBriefingOutput', context?: Array<string> | null, talkingPoints?: Array<string> | null, callSummaries?: Array<string> | null, notesSummary?: Array<string> | null, emailsSummary?: Array<string> | null, updatedAt?: any | null } | null } | null };

export type ClientCardSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type ClientCardSubscription = { __typename?: 'Subscription', clientCard: { __typename?: 'ClientViewOutput', id: any, managerNote?: string | null, recordedLineAgreementCheck?: boolean | null, soaAgreementCheck?: boolean | null, tpmoAgreementCheck?: boolean | null, tobacco?: boolean | null, urgentCallRequested?: boolean | null, urgentCallType?: Types.UrgentCallTypeDto | null, enrolled?: string | null, adviserName?: string | null, adviserEmail?: string | null, adviserPhone?: string | null, profileSource?: Types.ProfileSource | null, customAnswers?: string | null, countyName?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, userId?: any | null, pin?: string | null, noShow?: boolean | null, disqualifiedReason?: Types.DisqualifiedReasonDto | null, scheduledTagPlacement?: boolean | null, medicareNumber?: string | null, medicarePartBStartedAt?: any | null, medicarePartAStartedAt?: any | null, phoneNumber2?: string | null, isDNC: boolean, isLitigator: boolean, eligibleName?: string | null, gender?: string | null, profileId?: any | null, quoteId?: any | null, status: Types.StatusDto, birthDate?: any | null, zip?: string | null, cId?: string | null, uId?: string | null, utmBrand?: string | null, utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null, utmTerm?: string | null, wbraid?: string | null, msclkid?: string | null, gbraid?: string | null, gclid?: string | null, fbclid?: string | null, state?: string | null, followUpDate?: any | null, originalClientId?: any | null, expectedCloseDate?: any | null, preferredPharmacies: Array<string>, scopeOfAppointmentStatus?: Types.ScopeOfAppointmentStatusDto | null, createdAt?: string | null, additionalInformation?: string | null, soaAgreement?: boolean | null, bookingFor?: string | null, planTypes?: Array<string> | null, retireIn3Months?: string | null, clientFiles: Array<{ __typename?: 'ClientFileOutput', link: string, name: string }>, notes: Array<{ __typename?: 'ClientNoteOutput', clientId: any, createdAt: any, id: any, note: string, updatedAt: any, isManagerNote: boolean, createdByAgent?: { __typename?: 'AgentViewOutput', email: string, firstName: string, id: any, lastName: string, picUrl?: string | null } | null }>, leadSources?: Array<{ __typename?: 'LeadSourceOutput', source: string }> | null, pdpQuote?: { __typename?: 'PdpQuoteOutput', cId?: string | null, clientId: any, countyName?: string | null, createdAt: any, id: any, insulinSavings?: boolean | null, updatedAt: any, userId?: any | null, zip?: string | null } | null, medigapQuote?: { __typename?: 'MedigapQuoteViewOutput', cId?: string | null, createdAt?: any | null, id: any, updatedAt?: any | null, userId?: any | null, medigapFilterState?: { __typename?: 'MedigapFilterStateViewOutput', age: number, benefits?: Array<Types.MedigapFilterStateBenefit> | null, companies?: Array<string> | null, county?: string | null, effectiveDate?: any | null, gender: Types.MedigapFilterStateGender, id?: any | null, monthlyPlanPremiumRanges?: Array<string> | null, planCategory?: string | null, planNames?: Array<Types.MedigapFilterStatePlanName> | null, tobacco: boolean, zip: string } | null } | null, watchers: Array<{ __typename?: 'AgentViewOutput', email: string, firstName: string, id: any, lastName: string, picUrl?: string | null }>, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string, aiEnabled?: boolean | null } }>, agent?: { __typename?: 'AgentViewOutput', email: string, firstName: string, lastName: string, id: any, picUrl?: string | null } | null, preCallBriefing?: { __typename?: 'PreCallBriefingOutput', context?: Array<string> | null, talkingPoints?: Array<string> | null, callSummaries?: Array<string> | null, notesSummary?: Array<string> | null, emailsSummary?: Array<string> | null, updatedAt?: any | null } | null } };

export type AffiliationPartnershipsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AffiliationPartnershipsQuery = { __typename?: 'Query', affiliationPartnerships: Array<{ __typename?: 'AffiliationPartnershipOutput', campaign: string, source: string }> };

export type ClientListQueryVariables = Types.Exact<{
  pageInput: Types.PageInput;
  filterInput?: Types.InputMaybe<Types.ClientViewFilterInput>;
  sort?: Types.InputMaybe<Types.ClientViewSortInput>;
}>;


export type ClientListQuery = { __typename?: 'Query', clientViews: { __typename?: 'PageableClientViewListRepresentationOutput', totalPages: number, totalElements: any, data: Array<{ __typename?: 'ClientViewListRepresentationOutput', clientId?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumber2?: string | null, birthDate?: any | null, userId?: any | null, state?: string | null, agentName?: string | null, agentId?: any | null, callsCount: string, lastCallDate?: any | null, status: Types.StatusDto, createdAt?: any | null, followUpDate?: any | null, expectedCloseDate?: any | null, urgentCallType?: Types.UrgentCallTypeDto | null, affiliationPartnershipSource?: string | null, profileSource?: Types.ProfileSource | null, latestNote?: string | null, latestNoteId?: any | null, managerNote?: string | null, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string } }> }> } };

export type FollowUpsQueryVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
  pageInput: Types.PageInput;
  excludedTagsIds?: Types.InputMaybe<Array<Types.Scalars['UUID']['input']> | Types.Scalars['UUID']['input']>;
  includedTagsIds?: Types.InputMaybe<Array<Types.Scalars['UUID']['input']> | Types.Scalars['UUID']['input']>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Types.ClientViewSortInput>;
}>;


export type FollowUpsQuery = { __typename?: 'Query', followUps: { __typename?: 'PageableClientViewListRepresentationOutput', totalPages: number, totalElements: any, data: Array<{ __typename?: 'ClientViewListRepresentationOutput', clientId?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumber2?: string | null, birthDate?: any | null, userId?: any | null, state?: string | null, agentName?: string | null, agentId?: any | null, callsCount: string, lastCallDate?: any | null, status: Types.StatusDto, createdAt?: any | null, followUpDate?: any | null, expectedCloseDate?: any | null, urgentCallType?: Types.UrgentCallTypeDto | null, affiliationPartnershipSource?: string | null, profileSource?: Types.ProfileSource | null, latestNote?: string | null, latestNoteId?: any | null, managerNote?: string | null, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string } }> }> } };

export type FollowUpsFutureQueryVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
  pageInput: Types.PageInput;
  excludedTagsIds?: Types.InputMaybe<Array<Types.Scalars['UUID']['input']> | Types.Scalars['UUID']['input']>;
  includedTagsIds?: Types.InputMaybe<Array<Types.Scalars['UUID']['input']> | Types.Scalars['UUID']['input']>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Types.ClientViewSortInput>;
}>;


export type FollowUpsFutureQuery = { __typename?: 'Query', followUpsFuture: { __typename?: 'PageableClientViewListRepresentationOutput', totalPages: number, totalElements: any, data: Array<{ __typename?: 'ClientViewListRepresentationOutput', clientId?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumber2?: string | null, birthDate?: any | null, userId?: any | null, state?: string | null, agentName?: string | null, agentId?: any | null, callsCount: string, lastCallDate?: any | null, status: Types.StatusDto, createdAt?: any | null, followUpDate?: any | null, expectedCloseDate?: any | null, urgentCallType?: Types.UrgentCallTypeDto | null, affiliationPartnershipSource?: string | null, profileSource?: Types.ProfileSource | null, latestNote?: string | null, latestNoteId?: any | null, managerNote?: string | null, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string } }> }> } };

export type SalesQualifiedQueryVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
  pageInput: Types.PageInput;
  excludedTagsIds?: Types.InputMaybe<Array<Types.Scalars['UUID']['input']> | Types.Scalars['UUID']['input']>;
  includedTagsIds?: Types.InputMaybe<Array<Types.Scalars['UUID']['input']> | Types.Scalars['UUID']['input']>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Types.ClientViewSortInput>;
}>;


export type SalesQualifiedQuery = { __typename?: 'Query', salesQualified: { __typename?: 'PageableClientViewListRepresentationOutput', totalPages: number, totalElements: any, data: Array<{ __typename?: 'ClientViewListRepresentationOutput', clientId?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumber2?: string | null, birthDate?: any | null, userId?: any | null, state?: string | null, agentName?: string | null, agentId?: any | null, callsCount: string, lastCallDate?: any | null, status: Types.StatusDto, createdAt?: any | null, followUpDate?: any | null, expectedCloseDate?: any | null, urgentCallType?: Types.UrgentCallTypeDto | null, affiliationPartnershipSource?: string | null, profileSource?: Types.ProfileSource | null, latestNote?: string | null, latestNoteId?: any | null, managerNote?: string | null, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string } }> }> } };

export type SalesQualifiedFutureQueryVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
  pageInput: Types.PageInput;
  excludedTagsIds?: Types.InputMaybe<Array<Types.Scalars['UUID']['input']> | Types.Scalars['UUID']['input']>;
  includedTagsIds?: Types.InputMaybe<Array<Types.Scalars['UUID']['input']> | Types.Scalars['UUID']['input']>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Types.ClientViewSortInput>;
}>;


export type SalesQualifiedFutureQuery = { __typename?: 'Query', salesQualifiedFuture: { __typename?: 'PageableClientViewListRepresentationOutput', totalPages: number, totalElements: any, data: Array<{ __typename?: 'ClientViewListRepresentationOutput', clientId?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumber2?: string | null, birthDate?: any | null, userId?: any | null, state?: string | null, agentName?: string | null, agentId?: any | null, callsCount: string, lastCallDate?: any | null, status: Types.StatusDto, createdAt?: any | null, followUpDate?: any | null, expectedCloseDate?: any | null, urgentCallType?: Types.UrgentCallTypeDto | null, affiliationPartnershipSource?: string | null, profileSource?: Types.ProfileSource | null, latestNote?: string | null, latestNoteId?: any | null, managerNote?: string | null, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string } }> }> } };

export type ContactedQueryVariables = Types.Exact<{
  agentId: Types.Scalars['UUID']['input'];
  pageInput: Types.PageInput;
  sort?: Types.InputMaybe<Types.ClientViewSortInput>;
}>;


export type ContactedQuery = { __typename?: 'Query', contacted: { __typename?: 'PageableClientViewListRepresentationOutput', totalPages: number, totalElements: any, data: Array<{ __typename?: 'ClientViewListRepresentationOutput', clientId?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumber2?: string | null, birthDate?: any | null, userId?: any | null, state?: string | null, agentName?: string | null, agentId?: any | null, callsCount: string, lastCallDate?: any | null, status: Types.StatusDto, createdAt?: any | null, followUpDate?: any | null, expectedCloseDate?: any | null, urgentCallType?: Types.UrgentCallTypeDto | null, affiliationPartnershipSource?: string | null, profileSource?: Types.ProfileSource | null, latestNote?: string | null, latestNoteId?: any | null, managerNote?: string | null, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string } }> }> } };

export type AgentAssignedToClientQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type AgentAssignedToClientQuery = { __typename?: 'Query', agentAssignedToClient: { __typename?: 'AgentViewOutput', id: any } };

export type GmailMessagesByEmailQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type GmailMessagesByEmailQuery = { __typename?: 'Query', gmailMessagesByEmail: Array<{ __typename?: 'AgentEmailOutput', id?: string | null, agentId: any, body?: string | null, createdAt?: any | null, from?: string | null, snippet?: string | null, subject?: string | null, to?: string | null }> };

export type SaveClientWatchersMutationVariables = Types.Exact<{
  input: Types.ClientWatcherInput;
}>;


export type SaveClientWatchersMutation = { __typename?: 'Mutation', saveClientWatchers: boolean };

export type AssignmentHistoryQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type AssignmentHistoryQuery = { __typename?: 'Query', assignmentHistory: Array<{ __typename?: 'AssignmentHistoryOutput', agentName: string, assignmentDate: any, assignmentType: Types.AssignmentHistoryType }> };

export type ResetPasswordMutationVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type MissingAppTotalQueryVariables = Types.Exact<{
  missingAppTagId: Types.Scalars['UUID']['input'];
}>;


export type MissingAppTotalQuery = { __typename?: 'Query', clientViews: { __typename?: 'PageableClientViewListRepresentationOutput', totalElements: any } };

export type UrgentMissingAppQueryVariables = Types.Exact<{
  missingAppTagId: Types.Scalars['UUID']['input'];
}>;


export type UrgentMissingAppQuery = { __typename?: 'Query', clientViews: { __typename?: 'PageableClientViewListRepresentationOutput', totalElements: any, data: Array<{ __typename?: 'ClientViewListRepresentationOutput', clientId?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumber2?: string | null, birthDate?: any | null, userId?: any | null, state?: string | null, agentName?: string | null, agentId?: any | null, callsCount: string, lastCallDate?: any | null, status: Types.StatusDto, createdAt?: any | null, followUpDate?: any | null, expectedCloseDate?: any | null, urgentCallType?: Types.UrgentCallTypeDto | null, affiliationPartnershipSource?: string | null, profileSource?: Types.ProfileSource | null, latestNote?: string | null, latestNoteId?: any | null, managerNote?: string | null, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string } }> }> } };

export type ClientListFieldsFragment = { __typename?: 'ClientViewListRepresentationOutput', clientId?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, phoneNumber2?: string | null, birthDate?: any | null, userId?: any | null, state?: string | null, agentName?: string | null, agentId?: any | null, callsCount: string, lastCallDate?: any | null, status: Types.StatusDto, createdAt?: any | null, followUpDate?: any | null, expectedCloseDate?: any | null, urgentCallType?: Types.UrgentCallTypeDto | null, affiliationPartnershipSource?: string | null, profileSource?: Types.ProfileSource | null, latestNote?: string | null, latestNoteId?: any | null, managerNote?: string | null, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string } }> };

export type ClientViewOutputFieldsFragment = { __typename?: 'ClientViewOutput', id: any, managerNote?: string | null, recordedLineAgreementCheck?: boolean | null, soaAgreementCheck?: boolean | null, tpmoAgreementCheck?: boolean | null, tobacco?: boolean | null, urgentCallRequested?: boolean | null, urgentCallType?: Types.UrgentCallTypeDto | null, enrolled?: string | null, adviserName?: string | null, adviserEmail?: string | null, adviserPhone?: string | null, profileSource?: Types.ProfileSource | null, customAnswers?: string | null, countyName?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, userId?: any | null, pin?: string | null, noShow?: boolean | null, disqualifiedReason?: Types.DisqualifiedReasonDto | null, scheduledTagPlacement?: boolean | null, medicareNumber?: string | null, medicarePartBStartedAt?: any | null, medicarePartAStartedAt?: any | null, phoneNumber2?: string | null, isDNC: boolean, isLitigator: boolean, eligibleName?: string | null, gender?: string | null, profileId?: any | null, quoteId?: any | null, status: Types.StatusDto, birthDate?: any | null, zip?: string | null, cId?: string | null, uId?: string | null, utmBrand?: string | null, utmCampaign?: string | null, utmContent?: string | null, utmMedium?: string | null, utmSource?: string | null, utmTerm?: string | null, wbraid?: string | null, msclkid?: string | null, gbraid?: string | null, gclid?: string | null, fbclid?: string | null, state?: string | null, followUpDate?: any | null, originalClientId?: any | null, expectedCloseDate?: any | null, preferredPharmacies: Array<string>, scopeOfAppointmentStatus?: Types.ScopeOfAppointmentStatusDto | null, createdAt?: string | null, additionalInformation?: string | null, soaAgreement?: boolean | null, bookingFor?: string | null, planTypes?: Array<string> | null, retireIn3Months?: string | null, clientFiles: Array<{ __typename?: 'ClientFileOutput', link: string, name: string }>, notes: Array<{ __typename?: 'ClientNoteOutput', clientId: any, createdAt: any, id: any, note: string, updatedAt: any, isManagerNote: boolean, createdByAgent?: { __typename?: 'AgentViewOutput', email: string, firstName: string, id: any, lastName: string, picUrl?: string | null } | null }>, leadSources?: Array<{ __typename?: 'LeadSourceOutput', source: string }> | null, pdpQuote?: { __typename?: 'PdpQuoteOutput', cId?: string | null, clientId: any, countyName?: string | null, createdAt: any, id: any, insulinSavings?: boolean | null, updatedAt: any, userId?: any | null, zip?: string | null } | null, medigapQuote?: { __typename?: 'MedigapQuoteViewOutput', cId?: string | null, createdAt?: any | null, id: any, updatedAt?: any | null, userId?: any | null, medigapFilterState?: { __typename?: 'MedigapFilterStateViewOutput', age: number, benefits?: Array<Types.MedigapFilterStateBenefit> | null, companies?: Array<string> | null, county?: string | null, effectiveDate?: any | null, gender: Types.MedigapFilterStateGender, id?: any | null, monthlyPlanPremiumRanges?: Array<string> | null, planCategory?: string | null, planNames?: Array<Types.MedigapFilterStatePlanName> | null, tobacco: boolean, zip: string } | null } | null, watchers: Array<{ __typename?: 'AgentViewOutput', email: string, firstName: string, id: any, lastName: string, picUrl?: string | null }>, tags: Array<{ __typename?: 'AssignedTagViewOutput', expiresAt?: any | null, aiGenerated?: boolean | null, tag: { __typename?: 'TagViewOutput', color?: string | null, id: any, name: string, aiEnabled?: boolean | null } }>, agent?: { __typename?: 'AgentViewOutput', email: string, firstName: string, lastName: string, id: any, picUrl?: string | null } | null, preCallBriefing?: { __typename?: 'PreCallBriefingOutput', context?: Array<string> | null, talkingPoints?: Array<string> | null, callSummaries?: Array<string> | null, notesSummary?: Array<string> | null, emailsSummary?: Array<string> | null, updatedAt?: any | null } | null };

export type CalendarEventFieldsFragment = { __typename?: 'CalendarEventOutput', id?: string | null, summary?: string | null, description?: string | null, location?: string | null, startDateTime?: any | null, endDateTime?: any | null, timeZone?: string | null, status?: string | null, htmlLink?: string | null, colorId?: string | null, reminderMinutes?: number | null, etag?: string | null, meetLink?: string | null, dialInPhone?: string | null, dialInPin?: string | null, organizerName?: string | null, morePhoneNumbersUrl?: string | null, attendeeEmails: Array<string>, attendees?: Array<{ __typename?: 'CalendarEventAttendeeOutput', email?: string | null, displayName?: string | null, responseStatus?: string | null, self?: boolean | null }> | null };

export type CalendarEventsQueryVariables = Types.Exact<{
  agentEmail?: Types.InputMaybe<Types.Scalars['String']['input']>;
  input: Types.ListCalendarEventsInput;
}>;


export type CalendarEventsQuery = { __typename?: 'Query', calendarEvents: { __typename?: 'CalendarEventsOutput', nextPageToken?: string | null, events: Array<{ __typename?: 'CalendarEventOutput', id?: string | null, summary?: string | null, description?: string | null, location?: string | null, startDateTime?: any | null, endDateTime?: any | null, timeZone?: string | null, status?: string | null, htmlLink?: string | null, colorId?: string | null, reminderMinutes?: number | null, etag?: string | null, meetLink?: string | null, dialInPhone?: string | null, dialInPin?: string | null, organizerName?: string | null, morePhoneNumbersUrl?: string | null, attendeeEmails: Array<string>, attendees?: Array<{ __typename?: 'CalendarEventAttendeeOutput', email?: string | null, displayName?: string | null, responseStatus?: string | null, self?: boolean | null }> | null }> } };

export type CreateCalendarEventMutationVariables = Types.Exact<{
  agentEmail?: Types.InputMaybe<Types.Scalars['String']['input']>;
  input: Types.CreateCalendarEventInput;
}>;


export type CreateCalendarEventMutation = { __typename?: 'Mutation', createCalendarEvent: { __typename?: 'CalendarEventOutput', id?: string | null, summary?: string | null, description?: string | null, location?: string | null, startDateTime?: any | null, endDateTime?: any | null, timeZone?: string | null, status?: string | null, htmlLink?: string | null, colorId?: string | null, reminderMinutes?: number | null, etag?: string | null, meetLink?: string | null, dialInPhone?: string | null, dialInPin?: string | null, organizerName?: string | null, morePhoneNumbersUrl?: string | null, attendeeEmails: Array<string>, attendees?: Array<{ __typename?: 'CalendarEventAttendeeOutput', email?: string | null, displayName?: string | null, responseStatus?: string | null, self?: boolean | null }> | null } };

export type UpdateCalendarEventMutationVariables = Types.Exact<{
  eventId: Types.Scalars['String']['input'];
  input: Types.UpdateCalendarEventInput;
  agentEmail?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateCalendarEventMutation = { __typename?: 'Mutation', updateCalendarEvent: { __typename?: 'CalendarEventOutput', id?: string | null, summary?: string | null, description?: string | null, location?: string | null, startDateTime?: any | null, endDateTime?: any | null, timeZone?: string | null, status?: string | null, htmlLink?: string | null, colorId?: string | null, reminderMinutes?: number | null, etag?: string | null, meetLink?: string | null, dialInPhone?: string | null, dialInPin?: string | null, organizerName?: string | null, morePhoneNumbersUrl?: string | null, attendeeEmails: Array<string>, attendees?: Array<{ __typename?: 'CalendarEventAttendeeOutput', email?: string | null, displayName?: string | null, responseStatus?: string | null, self?: boolean | null }> | null } };

export type DeleteCalendarEventMutationVariables = Types.Exact<{
  eventId: Types.Scalars['String']['input'];
  agentEmail?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type DeleteCalendarEventMutation = { __typename?: 'Mutation', deleteCalendarEvent: boolean };

export type RespondToCalendarEventMutationVariables = Types.Exact<{
  eventId: Types.Scalars['String']['input'];
  response: Types.CalendarEventResponse;
  agentEmail?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type RespondToCalendarEventMutation = { __typename?: 'Mutation', respondToCalendarEvent: { __typename?: 'CalendarEventOutput', id?: string | null, summary?: string | null, description?: string | null, location?: string | null, startDateTime?: any | null, endDateTime?: any | null, timeZone?: string | null, status?: string | null, htmlLink?: string | null, colorId?: string | null, reminderMinutes?: number | null, etag?: string | null, meetLink?: string | null, dialInPhone?: string | null, dialInPin?: string | null, organizerName?: string | null, morePhoneNumbersUrl?: string | null, attendeeEmails: Array<string>, attendees?: Array<{ __typename?: 'CalendarEventAttendeeOutput', email?: string | null, displayName?: string | null, responseStatus?: string | null, self?: boolean | null }> | null } };

export type CalendarEventUpdatesSubscriptionVariables = Types.Exact<{
  agentEmail?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CalendarEventUpdatesSubscription = { __typename?: 'Subscription', calendarEventUpdates: { __typename?: 'CalendarEventUpdateOutput', agentEmail: string, changeType: Types.CalendarEventChangeType, eventId: string, event?: { __typename?: 'CalendarEventOutput', id?: string | null, summary?: string | null, description?: string | null, location?: string | null, startDateTime?: any | null, endDateTime?: any | null, timeZone?: string | null, status?: string | null, htmlLink?: string | null, colorId?: string | null, reminderMinutes?: number | null, etag?: string | null, meetLink?: string | null, dialInPhone?: string | null, dialInPin?: string | null, organizerName?: string | null, morePhoneNumbersUrl?: string | null, attendeeEmails: Array<string>, attendees?: Array<{ __typename?: 'CalendarEventAttendeeOutput', email?: string | null, displayName?: string | null, responseStatus?: string | null, self?: boolean | null }> | null } | null } };

export const ActionItemFieldsFragmentDoc = gql`
    fragment ActionItemFields on ActionItemOutput {
  id
  clientId
  clientName
  createdAt
  title
  assigneeAgentId
  assigneeAgentName
  done
  updatedAt
  dueDate
  aiGenerated
}
    `;
export const AppointmentFieldsFragmentDoc = gql`
    fragment AppointmentFields on AppointmentOutput {
  agent {
    lastName
    firstName
    email
    picUrl
    id
  }
  createdBy
  createdAt
  endTime
  noShow
  invitee {
    url
    lastName
    firstName
    clientId
    email
    name
  }
  name
  startTime
  status
  updatedAt
  url
}
    `;
export const CallQaFieldsFragmentDoc = gql`
    fragment CallQaFields on CallQaOutput {
  qaScore
  overriddenScore
  effectiveScore
  wasOverridden
  applicableMax
  pointsLost
  dispositionClass
  isEnrollmentCall
  overallAssessment
  coachingRecommendations
  rubricVersion
  scoredAt
  reviewedBy
  reviewedAt
  reviewNote
  questions {
    id
    category
    question
    answer
    evidence
    sourceAirCallId
    maxDeduction
    deductionApplied
  }
}
    `;
export const CallHistoryFieldsFragmentDoc = gql`
    fragment CallHistoryFields on CallHistoryOutput {
  callType
  clientId
  createdAt
  id
  airCallId
  phoneNumber
  result
  audioRecordId
  transcription
  hasAIAnalysis
  maskedTranscript
  callHistoryAnalysis {
    topics
    summary
    sentiment
  }
  agent {
    firstName
    lastName
    id
    picUrl
    email
  }
  callQa {
    ...CallQaFields
  }
}
    ${CallQaFieldsFragmentDoc}`;
export const QaCallRowFieldsFragmentDoc = gql`
    fragment QaCallRowFields on QaCallRowOutput {
  airCallId
  callDate
  clientId
  clientName
  agentId
  agentName
  effectiveScore
  dispositionClass
  isEnrollmentCall
  wasOverridden
}
    `;
export const AgentQaReportFieldsFragmentDoc = gql`
    fragment AgentQaReportFields on AgentQaReportOutput {
  agentId
  agentName
  summary {
    callsScored
    enrollmentCalls
    averageScore
    bestScore
    worstScore
    trend {
      periodStart
      averageScore
      callsScored
    }
  }
  pointsLostByCategory {
    category
    pointsLost
    callsApplicable
  }
  mostFailedQuestions {
    questionId
    question
    failCount
    applicableCount
    failRate
  }
  recentCalls {
    ...QaCallRowFields
  }
}
    ${QaCallRowFieldsFragmentDoc}`;
export const ClientListFieldsFragmentDoc = gql`
    fragment ClientListFields on ClientViewListRepresentationOutput {
  clientId
  email
  firstName
  lastName
  phoneNumber
  phoneNumber2
  birthDate
  userId
  state
  agentName
  agentId
  callsCount
  lastCallDate
  status
  createdAt
  followUpDate
  expectedCloseDate
  tags {
    expiresAt
    aiGenerated
    tag {
      color
      id
      name
    }
  }
  urgentCallType
  affiliationPartnershipSource
  profileSource
  latestNote
  latestNoteId
  managerNote
}
    `;
export const ClientViewOutputFieldsFragmentDoc = gql`
    fragment ClientViewOutputFields on ClientViewOutput {
  id
  clientFiles {
    link
    name
  }
  managerNote
  recordedLineAgreementCheck
  soaAgreementCheck
  tpmoAgreementCheck
  tobacco
  urgentCallRequested
  urgentCallType
  enrolled
  adviserName
  adviserEmail
  adviserPhone
  profileSource
  customAnswers
  countyName
  email
  firstName
  lastName
  phoneNumber
  userId
  pin
  noShow
  disqualifiedReason
  scheduledTagPlacement
  medicareNumber
  medicarePartBStartedAt
  medicarePartAStartedAt
  phoneNumber2
  isDNC
  isLitigator
  eligibleName
  notes {
    clientId
    createdAt
    createdByAgent {
      email
      firstName
      id
      lastName
      picUrl
    }
    id
    note
    updatedAt
    isManagerNote
  }
  gender
  profileId
  quoteId
  status
  birthDate
  zip
  cId
  uId
  utmBrand
  utmCampaign
  utmContent
  utmMedium
  utmSource
  utmTerm
  wbraid
  msclkid
  gbraid
  gclid
  fbclid
  state
  followUpDate
  originalClientId
  leadSources {
    source
  }
  pdpQuote {
    cId
    clientId
    countyName
    createdAt
    id
    insulinSavings
    updatedAt
    userId
    zip
  }
  medigapQuote {
    cId
    createdAt
    id
    medigapFilterState {
      age
      benefits
      companies
      county
      effectiveDate
      gender
      id
      monthlyPlanPremiumRanges
      planCategory
      planNames
      tobacco
      zip
    }
    updatedAt
    userId
  }
  expectedCloseDate
  watchers {
    email
    firstName
    id
    lastName
    picUrl
  }
  preferredPharmacies
  scopeOfAppointmentStatus
  createdAt
  tags {
    expiresAt
    aiGenerated
    tag {
      color
      id
      name
      aiEnabled
    }
  }
  agent {
    email
    firstName
    lastName
    id
    picUrl
  }
  additionalInformation
  soaAgreement
  bookingFor
  planTypes
  retireIn3Months
  preCallBriefing {
    context
    talkingPoints
    callSummaries
    notesSummary
    emailsSummary
    updatedAt
  }
}
    `;
export const CalendarEventFieldsFragmentDoc = gql`
    fragment CalendarEventFields on CalendarEventOutput {
  id
  summary
  description
  location
  startDateTime
  endDateTime
  timeZone
  status
  htmlLink
  colorId
  reminderMinutes
  etag
  meetLink
  dialInPhone
  dialInPin
  organizerName
  morePhoneNumbersUrl
  attendeeEmails
  attendees {
    email
    displayName
    responseStatus
    self
  }
}
    `;
export const UniqueClosesByAgentDocument = gql`
    query uniqueClosesByAgent($agentId: UUID!, $currentRange: DateRangeInput!, $previousRange: DateRangeInput!) {
  previous: clientViews(
    filterInput: {agentId: $agentId, status: APPLICATION_SUBMITTED, range: $previousRange}
    pageInput: {page: 0, size: 1}
  ) {
    totalElements
  }
  current: clientViews(
    filterInput: {agentId: $agentId, status: APPLICATION_SUBMITTED, range: $currentRange}
    pageInput: {page: 0, size: 1}
  ) {
    totalElements
  }
}
    `;

/**
 * __useUniqueClosesByAgentQuery__
 *
 * To run a query within a React component, call `useUniqueClosesByAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniqueClosesByAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniqueClosesByAgentQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      currentRange: // value for 'currentRange'
 *      previousRange: // value for 'previousRange'
 *   },
 * });
 */
export function useUniqueClosesByAgentQuery(baseOptions: Apollo.QueryHookOptions<UniqueClosesByAgentQuery, UniqueClosesByAgentQueryVariables> & ({ variables: UniqueClosesByAgentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniqueClosesByAgentQuery, UniqueClosesByAgentQueryVariables>(UniqueClosesByAgentDocument, options);
      }
export function useUniqueClosesByAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniqueClosesByAgentQuery, UniqueClosesByAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniqueClosesByAgentQuery, UniqueClosesByAgentQueryVariables>(UniqueClosesByAgentDocument, options);
        }
export function useUniqueClosesByAgentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UniqueClosesByAgentQuery, UniqueClosesByAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UniqueClosesByAgentQuery, UniqueClosesByAgentQueryVariables>(UniqueClosesByAgentDocument, options);
        }
export type UniqueClosesByAgentQueryHookResult = ReturnType<typeof useUniqueClosesByAgentQuery>;
export type UniqueClosesByAgentLazyQueryHookResult = ReturnType<typeof useUniqueClosesByAgentLazyQuery>;
export type UniqueClosesByAgentSuspenseQueryHookResult = ReturnType<typeof useUniqueClosesByAgentSuspenseQuery>;
export type UniqueClosesByAgentQueryResult = Apollo.QueryResult<UniqueClosesByAgentQuery, UniqueClosesByAgentQueryVariables>;
export const CalendlyAppointmentsByAgentDocument = gql`
    query calendlyAppointmentsByAgent($filter: CalendlyAppointmentsFilterInput!, $pageInput: PageInput!, $sort: CalendlyAppointmentsSortInput!, $agentId: UUID!) {
  calendlyAppointmentsByAgent(
    filter: $filter
    pageInput: $pageInput
    sort: $sort
    agentId: $agentId
  ) {
    hasNext
    number
    totalElements
    data {
      ...AppointmentFields
    }
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useCalendlyAppointmentsByAgentQuery__
 *
 * To run a query within a React component, call `useCalendlyAppointmentsByAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendlyAppointmentsByAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendlyAppointmentsByAgentQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageInput: // value for 'pageInput'
 *      sort: // value for 'sort'
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useCalendlyAppointmentsByAgentQuery(baseOptions: Apollo.QueryHookOptions<CalendlyAppointmentsByAgentQuery, CalendlyAppointmentsByAgentQueryVariables> & ({ variables: CalendlyAppointmentsByAgentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendlyAppointmentsByAgentQuery, CalendlyAppointmentsByAgentQueryVariables>(CalendlyAppointmentsByAgentDocument, options);
      }
export function useCalendlyAppointmentsByAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendlyAppointmentsByAgentQuery, CalendlyAppointmentsByAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendlyAppointmentsByAgentQuery, CalendlyAppointmentsByAgentQueryVariables>(CalendlyAppointmentsByAgentDocument, options);
        }
export function useCalendlyAppointmentsByAgentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalendlyAppointmentsByAgentQuery, CalendlyAppointmentsByAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalendlyAppointmentsByAgentQuery, CalendlyAppointmentsByAgentQueryVariables>(CalendlyAppointmentsByAgentDocument, options);
        }
export type CalendlyAppointmentsByAgentQueryHookResult = ReturnType<typeof useCalendlyAppointmentsByAgentQuery>;
export type CalendlyAppointmentsByAgentLazyQueryHookResult = ReturnType<typeof useCalendlyAppointmentsByAgentLazyQuery>;
export type CalendlyAppointmentsByAgentSuspenseQueryHookResult = ReturnType<typeof useCalendlyAppointmentsByAgentSuspenseQuery>;
export type CalendlyAppointmentsByAgentQueryResult = Apollo.QueryResult<CalendlyAppointmentsByAgentQuery, CalendlyAppointmentsByAgentQueryVariables>;
export const AgentCurrentClientsMetricsDocument = gql`
    query agentCurrentClientsMetrics($filter: AgentCurrentClientsMetricsFilterInput!) {
  agentCurrentClientsMetrics(filter: $filter) {
    agentEmail
    agentEnabled
    agentId
    agentName
    followUpFuture
    followUpNotFuture
    followUpOutdated
    sqlNotFuture
    sqlOutdated
    sqlUpFuture
  }
}
    `;

/**
 * __useAgentCurrentClientsMetricsQuery__
 *
 * To run a query within a React component, call `useAgentCurrentClientsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentCurrentClientsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentCurrentClientsMetricsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAgentCurrentClientsMetricsQuery(baseOptions: Apollo.QueryHookOptions<AgentCurrentClientsMetricsQuery, AgentCurrentClientsMetricsQueryVariables> & ({ variables: AgentCurrentClientsMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentCurrentClientsMetricsQuery, AgentCurrentClientsMetricsQueryVariables>(AgentCurrentClientsMetricsDocument, options);
      }
export function useAgentCurrentClientsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentCurrentClientsMetricsQuery, AgentCurrentClientsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentCurrentClientsMetricsQuery, AgentCurrentClientsMetricsQueryVariables>(AgentCurrentClientsMetricsDocument, options);
        }
export function useAgentCurrentClientsMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentCurrentClientsMetricsQuery, AgentCurrentClientsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentCurrentClientsMetricsQuery, AgentCurrentClientsMetricsQueryVariables>(AgentCurrentClientsMetricsDocument, options);
        }
export type AgentCurrentClientsMetricsQueryHookResult = ReturnType<typeof useAgentCurrentClientsMetricsQuery>;
export type AgentCurrentClientsMetricsLazyQueryHookResult = ReturnType<typeof useAgentCurrentClientsMetricsLazyQuery>;
export type AgentCurrentClientsMetricsSuspenseQueryHookResult = ReturnType<typeof useAgentCurrentClientsMetricsSuspenseQuery>;
export type AgentCurrentClientsMetricsQueryResult = Apollo.QueryResult<AgentCurrentClientsMetricsQuery, AgentCurrentClientsMetricsQueryVariables>;
export const TestSubscriptionErrorDocument = gql`
    subscription testSubscriptionError {
  testSubscriptionError
}
    `;

/**
 * __useTestSubscriptionErrorSubscription__
 *
 * To run a query within a React component, call `useTestSubscriptionErrorSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTestSubscriptionErrorSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestSubscriptionErrorSubscription({
 *   variables: {
 *   },
 * });
 */
export function useTestSubscriptionErrorSubscription(baseOptions?: Apollo.SubscriptionHookOptions<TestSubscriptionErrorSubscription, TestSubscriptionErrorSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TestSubscriptionErrorSubscription, TestSubscriptionErrorSubscriptionVariables>(TestSubscriptionErrorDocument, options);
      }
export type TestSubscriptionErrorSubscriptionHookResult = ReturnType<typeof useTestSubscriptionErrorSubscription>;
export type TestSubscriptionErrorSubscriptionResult = Apollo.SubscriptionResult<TestSubscriptionErrorSubscription>;
export const AllSalesQualifiedDocument = gql`
    query allSalesQualified($agentId: UUID!) {
  allSalesQualified: salesQualified(
    agentId: $agentId
    pageInput: {page: 0, size: 10000}
  ) {
    data {
      ...ClientListFields
    }
  }
}
    ${ClientListFieldsFragmentDoc}`;

/**
 * __useAllSalesQualifiedQuery__
 *
 * To run a query within a React component, call `useAllSalesQualifiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSalesQualifiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSalesQualifiedQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useAllSalesQualifiedQuery(baseOptions: Apollo.QueryHookOptions<AllSalesQualifiedQuery, AllSalesQualifiedQueryVariables> & ({ variables: AllSalesQualifiedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSalesQualifiedQuery, AllSalesQualifiedQueryVariables>(AllSalesQualifiedDocument, options);
      }
export function useAllSalesQualifiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSalesQualifiedQuery, AllSalesQualifiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSalesQualifiedQuery, AllSalesQualifiedQueryVariables>(AllSalesQualifiedDocument, options);
        }
export function useAllSalesQualifiedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllSalesQualifiedQuery, AllSalesQualifiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSalesQualifiedQuery, AllSalesQualifiedQueryVariables>(AllSalesQualifiedDocument, options);
        }
export type AllSalesQualifiedQueryHookResult = ReturnType<typeof useAllSalesQualifiedQuery>;
export type AllSalesQualifiedLazyQueryHookResult = ReturnType<typeof useAllSalesQualifiedLazyQuery>;
export type AllSalesQualifiedSuspenseQueryHookResult = ReturnType<typeof useAllSalesQualifiedSuspenseQuery>;
export type AllSalesQualifiedQueryResult = Apollo.QueryResult<AllSalesQualifiedQuery, AllSalesQualifiedQueryVariables>;
export const AllFollowUpsDocument = gql`
    query allFollowUps($agentId: UUID!, $excludedTagsIds: [UUID!], $includedTagsIds: [UUID!]) {
  allFollowUps: followUps(
    agentId: $agentId
    pageInput: {page: 0, size: 10000}
    includedTagsIds: $includedTagsIds
    excludedTagsIds: $excludedTagsIds
  ) {
    data {
      ...ClientListFields
    }
  }
}
    ${ClientListFieldsFragmentDoc}`;

/**
 * __useAllFollowUpsQuery__
 *
 * To run a query within a React component, call `useAllFollowUpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFollowUpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFollowUpsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      excludedTagsIds: // value for 'excludedTagsIds'
 *      includedTagsIds: // value for 'includedTagsIds'
 *   },
 * });
 */
export function useAllFollowUpsQuery(baseOptions: Apollo.QueryHookOptions<AllFollowUpsQuery, AllFollowUpsQueryVariables> & ({ variables: AllFollowUpsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllFollowUpsQuery, AllFollowUpsQueryVariables>(AllFollowUpsDocument, options);
      }
export function useAllFollowUpsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFollowUpsQuery, AllFollowUpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllFollowUpsQuery, AllFollowUpsQueryVariables>(AllFollowUpsDocument, options);
        }
export function useAllFollowUpsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllFollowUpsQuery, AllFollowUpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllFollowUpsQuery, AllFollowUpsQueryVariables>(AllFollowUpsDocument, options);
        }
export type AllFollowUpsQueryHookResult = ReturnType<typeof useAllFollowUpsQuery>;
export type AllFollowUpsLazyQueryHookResult = ReturnType<typeof useAllFollowUpsLazyQuery>;
export type AllFollowUpsSuspenseQueryHookResult = ReturnType<typeof useAllFollowUpsSuspenseQuery>;
export type AllFollowUpsQueryResult = Apollo.QueryResult<AllFollowUpsQuery, AllFollowUpsQueryVariables>;
export const SaveManagerNoteDocument = gql`
    mutation saveManagerNote($clientId: UUID!, $managerNote: String!) {
  saveManagerNote(clientId: $clientId, managerNote: $managerNote)
}
    `;
export type SaveManagerNoteMutationFn = Apollo.MutationFunction<SaveManagerNoteMutation, SaveManagerNoteMutationVariables>;

/**
 * __useSaveManagerNoteMutation__
 *
 * To run a mutation, you first call `useSaveManagerNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveManagerNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveManagerNoteMutation, { data, loading, error }] = useSaveManagerNoteMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      managerNote: // value for 'managerNote'
 *   },
 * });
 */
export function useSaveManagerNoteMutation(baseOptions?: Apollo.MutationHookOptions<SaveManagerNoteMutation, SaveManagerNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveManagerNoteMutation, SaveManagerNoteMutationVariables>(SaveManagerNoteDocument, options);
      }
export type SaveManagerNoteMutationHookResult = ReturnType<typeof useSaveManagerNoteMutation>;
export type SaveManagerNoteMutationResult = Apollo.MutationResult<SaveManagerNoteMutation>;
export type SaveManagerNoteMutationOptions = Apollo.BaseMutationOptions<SaveManagerNoteMutation, SaveManagerNoteMutationVariables>;
export const AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentDocument = gql`
    mutation appointmentReminderCSRAcknowledgedAgentWillBeLateConfirmByAgent($id: String!) {
  appointmentReminderCSRAcknowledgedAgentWillBeLateConfirmByAgent(id: $id)
}
    `;
export type AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutationFn = Apollo.MutationFunction<AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation, AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutationVariables>;

/**
 * __useAppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation__
 *
 * To run a mutation, you first call `useAppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation, { data, loading, error }] = useAppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation, AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation, AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutationVariables>(AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentDocument, options);
      }
export type AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutationHookResult = ReturnType<typeof useAppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation>;
export type AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutationResult = Apollo.MutationResult<AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation>;
export type AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutationOptions = Apollo.BaseMutationOptions<AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation, AppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutationVariables>;
export const AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrDocument = gql`
    mutation appointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsr($id: String!) {
  appointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsr(id: $id)
}
    `;
export type AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutationFn = Apollo.MutationFunction<AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation, AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutationVariables>;

/**
 * __useAppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation__
 *
 * To run a mutation, you first call `useAppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation, { data, loading, error }] = useAppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation, AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation, AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutationVariables>(AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrDocument, options);
      }
export type AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutationHookResult = ReturnType<typeof useAppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation>;
export type AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutationResult = Apollo.MutationResult<AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation>;
export type AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutationOptions = Apollo.BaseMutationOptions<AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutation, AppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrMutationVariables>;
export const AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentDocument = gql`
    mutation appointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgent($id: String!) {
  appointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgent(id: $id)
}
    `;
export type AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutationFn = Apollo.MutationFunction<AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation, AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutationVariables>;

/**
 * __useAppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation__
 *
 * To run a mutation, you first call `useAppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation, { data, loading, error }] = useAppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation, AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation, AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutationVariables>(AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentDocument, options);
      }
export type AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutationHookResult = ReturnType<typeof useAppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation>;
export type AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutationResult = Apollo.MutationResult<AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation>;
export type AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutationOptions = Apollo.BaseMutationOptions<AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation, AppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutationVariables>;
export const AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentDocument = gql`
    mutation appointmentReminderSuggestedToRescheduleAppointmentConfirmByAgent($id: String!) {
  appointmentReminderSuggestedToRescheduleAppointmentConfirmByAgent(id: $id)
}
    `;
export type AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutationFn = Apollo.MutationFunction<AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation, AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutationVariables>;

/**
 * __useAppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation__
 *
 * To run a mutation, you first call `useAppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation, { data, loading, error }] = useAppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation, AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation, AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutationVariables>(AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentDocument, options);
      }
export type AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutationHookResult = ReturnType<typeof useAppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation>;
export type AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutationResult = Apollo.MutationResult<AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation>;
export type AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutationOptions = Apollo.BaseMutationOptions<AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutation, AppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentMutationVariables>;
export const AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrDocument = gql`
    mutation appointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsr($id: String!) {
  appointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsr(id: $id)
}
    `;
export type AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutationFn = Apollo.MutationFunction<AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation, AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutationVariables>;

/**
 * __useAppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation__
 *
 * To run a mutation, you first call `useAppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation, { data, loading, error }] = useAppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation, AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation, AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutationVariables>(AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrDocument, options);
      }
export type AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutationHookResult = ReturnType<typeof useAppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation>;
export type AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutationResult = Apollo.MutationResult<AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation>;
export type AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutationOptions = Apollo.BaseMutationOptions<AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutation, AppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrMutationVariables>;
export const AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrDocument = gql`
    mutation appointmentReminderAgentConfirmedButWillBeLateConfirmByCsr($id: String!) {
  appointmentReminderAgentConfirmedButWillBeLateConfirmByCsr(id: $id)
}
    `;
export type AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutationFn = Apollo.MutationFunction<AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation, AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutationVariables>;

/**
 * __useAppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation__
 *
 * To run a mutation, you first call `useAppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation, { data, loading, error }] = useAppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation, AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation, AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutationVariables>(AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrDocument, options);
      }
export type AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutationHookResult = ReturnType<typeof useAppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation>;
export type AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutationResult = Apollo.MutationResult<AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation>;
export type AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutationOptions = Apollo.BaseMutationOptions<AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutation, AppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrMutationVariables>;
export const AppointmentReminderAgentIsMissingAppointmentConfirmByCsrDocument = gql`
    mutation appointmentReminderAgentIsMissingAppointmentConfirmByCsr($id: String!) {
  appointmentReminderAgentIsMissingAppointmentConfirmByCsr(id: $id)
}
    `;
export type AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutationFn = Apollo.MutationFunction<AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation, AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutationVariables>;

/**
 * __useAppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation__
 *
 * To run a mutation, you first call `useAppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation, { data, loading, error }] = useAppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation, AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation, AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutationVariables>(AppointmentReminderAgentIsMissingAppointmentConfirmByCsrDocument, options);
      }
export type AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutationHookResult = ReturnType<typeof useAppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation>;
export type AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutationResult = Apollo.MutationResult<AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation>;
export type AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutationOptions = Apollo.BaseMutationOptions<AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutation, AppointmentReminderAgentIsMissingAppointmentConfirmByCsrMutationVariables>;
export const AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentDocument = gql`
    mutation appointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgent($id: String!) {
  appointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgent(id: $id)
}
    `;
export type AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutationFn = Apollo.MutationFunction<AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation, AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutationVariables>;

/**
 * __useAppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation__
 *
 * To run a mutation, you first call `useAppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation, { data, loading, error }] = useAppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation, AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation, AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutationVariables>(AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentDocument, options);
      }
export type AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutationHookResult = ReturnType<typeof useAppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation>;
export type AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutationResult = Apollo.MutationResult<AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation>;
export type AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutationOptions = Apollo.BaseMutationOptions<AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutation, AppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentMutationVariables>;
export const AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeDocument = gql`
    mutation appointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTime($id: String!) {
  appointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTime(id: $id)
}
    `;
export type AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutationFn = Apollo.MutationFunction<AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation, AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutationVariables>;

/**
 * __useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation__
 *
 * To run a mutation, you first call `useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation, { data, loading, error }] = useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation, AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation, AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutationVariables>(AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeDocument, options);
      }
export type AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutationHookResult = ReturnType<typeof useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation>;
export type AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutationResult = Apollo.MutationResult<AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation>;
export type AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutationOptions = Apollo.BaseMutationOptions<AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutation, AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeMutationVariables>;
export const AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentDocument = gql`
    mutation appointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgent($id: String!) {
  appointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgent(id: $id)
}
    `;
export type AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutationFn = Apollo.MutationFunction<AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation, AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutationVariables>;

/**
 * __useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation__
 *
 * To run a mutation, you first call `useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation, { data, loading, error }] = useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation, AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation, AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutationVariables>(AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentDocument, options);
      }
export type AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutationHookResult = ReturnType<typeof useAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation>;
export type AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutationResult = Apollo.MutationResult<AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation>;
export type AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutationOptions = Apollo.BaseMutationOptions<AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutation, AppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentMutationVariables>;
export const AppointmentReminderRequiredAgentConfirmationWillBeLateDocument = gql`
    mutation appointmentReminderRequiredAgentConfirmationWillBeLate($id: String!) {
  appointmentReminderRequiredAgentConfirmationWillBeLate(id: $id)
}
    `;
export type AppointmentReminderRequiredAgentConfirmationWillBeLateMutationFn = Apollo.MutationFunction<AppointmentReminderRequiredAgentConfirmationWillBeLateMutation, AppointmentReminderRequiredAgentConfirmationWillBeLateMutationVariables>;

/**
 * __useAppointmentReminderRequiredAgentConfirmationWillBeLateMutation__
 *
 * To run a mutation, you first call `useAppointmentReminderRequiredAgentConfirmationWillBeLateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReminderRequiredAgentConfirmationWillBeLateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentReminderRequiredAgentConfirmationWillBeLateMutation, { data, loading, error }] = useAppointmentReminderRequiredAgentConfirmationWillBeLateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentReminderRequiredAgentConfirmationWillBeLateMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentReminderRequiredAgentConfirmationWillBeLateMutation, AppointmentReminderRequiredAgentConfirmationWillBeLateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentReminderRequiredAgentConfirmationWillBeLateMutation, AppointmentReminderRequiredAgentConfirmationWillBeLateMutationVariables>(AppointmentReminderRequiredAgentConfirmationWillBeLateDocument, options);
      }
export type AppointmentReminderRequiredAgentConfirmationWillBeLateMutationHookResult = ReturnType<typeof useAppointmentReminderRequiredAgentConfirmationWillBeLateMutation>;
export type AppointmentReminderRequiredAgentConfirmationWillBeLateMutationResult = Apollo.MutationResult<AppointmentReminderRequiredAgentConfirmationWillBeLateMutation>;
export type AppointmentReminderRequiredAgentConfirmationWillBeLateMutationOptions = Apollo.BaseMutationOptions<AppointmentReminderRequiredAgentConfirmationWillBeLateMutation, AppointmentReminderRequiredAgentConfirmationWillBeLateMutationVariables>;
export const AppointmentReminderRequiredAgentConfirmationConfirmDocument = gql`
    mutation appointmentReminderRequiredAgentConfirmationConfirm($id: String!) {
  appointmentReminderRequiredAgentConfirmationConfirm(id: $id)
}
    `;
export type AppointmentReminderRequiredAgentConfirmationConfirmMutationFn = Apollo.MutationFunction<AppointmentReminderRequiredAgentConfirmationConfirmMutation, AppointmentReminderRequiredAgentConfirmationConfirmMutationVariables>;

/**
 * __useAppointmentReminderRequiredAgentConfirmationConfirmMutation__
 *
 * To run a mutation, you first call `useAppointmentReminderRequiredAgentConfirmationConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentReminderRequiredAgentConfirmationConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentReminderRequiredAgentConfirmationConfirmMutation, { data, loading, error }] = useAppointmentReminderRequiredAgentConfirmationConfirmMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentReminderRequiredAgentConfirmationConfirmMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentReminderRequiredAgentConfirmationConfirmMutation, AppointmentReminderRequiredAgentConfirmationConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentReminderRequiredAgentConfirmationConfirmMutation, AppointmentReminderRequiredAgentConfirmationConfirmMutationVariables>(AppointmentReminderRequiredAgentConfirmationConfirmDocument, options);
      }
export type AppointmentReminderRequiredAgentConfirmationConfirmMutationHookResult = ReturnType<typeof useAppointmentReminderRequiredAgentConfirmationConfirmMutation>;
export type AppointmentReminderRequiredAgentConfirmationConfirmMutationResult = Apollo.MutationResult<AppointmentReminderRequiredAgentConfirmationConfirmMutation>;
export type AppointmentReminderRequiredAgentConfirmationConfirmMutationOptions = Apollo.BaseMutationOptions<AppointmentReminderRequiredAgentConfirmationConfirmMutation, AppointmentReminderRequiredAgentConfirmationConfirmMutationVariables>;
export const RequiredActionsDocument = gql`
    subscription requiredActions {
  requiredActions {
    createdAt
    detailsJson
    done
    id
    type
    updatedAt
  }
}
    `;

/**
 * __useRequiredActionsSubscription__
 *
 * To run a query within a React component, call `useRequiredActionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRequiredActionsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequiredActionsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useRequiredActionsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RequiredActionsSubscription, RequiredActionsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RequiredActionsSubscription, RequiredActionsSubscriptionVariables>(RequiredActionsDocument, options);
      }
export type RequiredActionsSubscriptionHookResult = ReturnType<typeof useRequiredActionsSubscription>;
export type RequiredActionsSubscriptionResult = Apollo.SubscriptionResult<RequiredActionsSubscription>;
export const AgentGmailAuthUrlDocument = gql`
    query agentGmailAuthUrl {
  agentGmailAuthUrl
}
    `;

/**
 * __useAgentGmailAuthUrlQuery__
 *
 * To run a query within a React component, call `useAgentGmailAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentGmailAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentGmailAuthUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentGmailAuthUrlQuery(baseOptions?: Apollo.QueryHookOptions<AgentGmailAuthUrlQuery, AgentGmailAuthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentGmailAuthUrlQuery, AgentGmailAuthUrlQueryVariables>(AgentGmailAuthUrlDocument, options);
      }
export function useAgentGmailAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentGmailAuthUrlQuery, AgentGmailAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentGmailAuthUrlQuery, AgentGmailAuthUrlQueryVariables>(AgentGmailAuthUrlDocument, options);
        }
export function useAgentGmailAuthUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentGmailAuthUrlQuery, AgentGmailAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentGmailAuthUrlQuery, AgentGmailAuthUrlQueryVariables>(AgentGmailAuthUrlDocument, options);
        }
export type AgentGmailAuthUrlQueryHookResult = ReturnType<typeof useAgentGmailAuthUrlQuery>;
export type AgentGmailAuthUrlLazyQueryHookResult = ReturnType<typeof useAgentGmailAuthUrlLazyQuery>;
export type AgentGmailAuthUrlSuspenseQueryHookResult = ReturnType<typeof useAgentGmailAuthUrlSuspenseQuery>;
export type AgentGmailAuthUrlQueryResult = Apollo.QueryResult<AgentGmailAuthUrlQuery, AgentGmailAuthUrlQueryVariables>;
export const ClientCommunicationNoShowDocument = gql`
    mutation clientCommunicationNoShow($clientId: UUID!) {
  clientCommunicationNoShow(clientId: $clientId)
}
    `;
export type ClientCommunicationNoShowMutationFn = Apollo.MutationFunction<ClientCommunicationNoShowMutation, ClientCommunicationNoShowMutationVariables>;

/**
 * __useClientCommunicationNoShowMutation__
 *
 * To run a mutation, you first call `useClientCommunicationNoShowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientCommunicationNoShowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientCommunicationNoShowMutation, { data, loading, error }] = useClientCommunicationNoShowMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useClientCommunicationNoShowMutation(baseOptions?: Apollo.MutationHookOptions<ClientCommunicationNoShowMutation, ClientCommunicationNoShowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClientCommunicationNoShowMutation, ClientCommunicationNoShowMutationVariables>(ClientCommunicationNoShowDocument, options);
      }
export type ClientCommunicationNoShowMutationHookResult = ReturnType<typeof useClientCommunicationNoShowMutation>;
export type ClientCommunicationNoShowMutationResult = Apollo.MutationResult<ClientCommunicationNoShowMutation>;
export type ClientCommunicationNoShowMutationOptions = Apollo.BaseMutationOptions<ClientCommunicationNoShowMutation, ClientCommunicationNoShowMutationVariables>;
export const DeleteActionItemDocument = gql`
    mutation deleteActionItem($id: UUID!) {
  deleteActionItem(id: $id)
}
    `;
export type DeleteActionItemMutationFn = Apollo.MutationFunction<DeleteActionItemMutation, DeleteActionItemMutationVariables>;

/**
 * __useDeleteActionItemMutation__
 *
 * To run a mutation, you first call `useDeleteActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionItemMutation, { data, loading, error }] = useDeleteActionItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteActionItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionItemMutation, DeleteActionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionItemMutation, DeleteActionItemMutationVariables>(DeleteActionItemDocument, options);
      }
export type DeleteActionItemMutationHookResult = ReturnType<typeof useDeleteActionItemMutation>;
export type DeleteActionItemMutationResult = Apollo.MutationResult<DeleteActionItemMutation>;
export type DeleteActionItemMutationOptions = Apollo.BaseMutationOptions<DeleteActionItemMutation, DeleteActionItemMutationVariables>;
export const AgentCallAgendaWholeStateDocument = gql`
    subscription agentCallAgendaWholeState {
  agentCallAgendaWholeState {
    rrView {
      busy {
        agentId
        assignedToClient
        dontDisturb
        excluded
        onACall
      }
      inActiveQueue
      offline
      tasksWaitingPool {
        clientId
        inPoolUntil
      }
    }
    agentsSorted {
      agentEmail
      agentId
      agentName
      availabilityIsUpdatedAt
      csr
      dontDisturb
      excludedFromRoundRobin
      isAvailableForNewLeads
      licensedStates
      picUrl
      onCall
      airCallAvailabilityStatus
      onCallWithClient {
        clientEmail
        clientId
        clientName
      }
      online
    }
    tasks {
      assignmentHistory {
        agentEmail
        agentId
        agentName
        type
      }
      clientEmail
      clientId
      clientName
      completed
      createdAt
      currentAssignment {
        assignedAgentEmail
        assignedAgentId
        assignedAgentName
        assignedUntil
        scheduledReassignAt
        type
      }
      isNew
      priorityReason
      state
    }
  }
}
    `;

/**
 * __useAgentCallAgendaWholeStateSubscription__
 *
 * To run a query within a React component, call `useAgentCallAgendaWholeStateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAgentCallAgendaWholeStateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentCallAgendaWholeStateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAgentCallAgendaWholeStateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AgentCallAgendaWholeStateSubscription, AgentCallAgendaWholeStateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AgentCallAgendaWholeStateSubscription, AgentCallAgendaWholeStateSubscriptionVariables>(AgentCallAgendaWholeStateDocument, options);
      }
export type AgentCallAgendaWholeStateSubscriptionHookResult = ReturnType<typeof useAgentCallAgendaWholeStateSubscription>;
export type AgentCallAgendaWholeStateSubscriptionResult = Apollo.SubscriptionResult<AgentCallAgendaWholeStateSubscription>;
export const SaveActionItemDocument = gql`
    mutation saveActionItem($input: ActionItemInput!) {
  saveActionItem(input: $input) {
    ...ActionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;
export type SaveActionItemMutationFn = Apollo.MutationFunction<SaveActionItemMutation, SaveActionItemMutationVariables>;

/**
 * __useSaveActionItemMutation__
 *
 * To run a mutation, you first call `useSaveActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveActionItemMutation, { data, loading, error }] = useSaveActionItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveActionItemMutation(baseOptions?: Apollo.MutationHookOptions<SaveActionItemMutation, SaveActionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveActionItemMutation, SaveActionItemMutationVariables>(SaveActionItemDocument, options);
      }
export type SaveActionItemMutationHookResult = ReturnType<typeof useSaveActionItemMutation>;
export type SaveActionItemMutationResult = Apollo.MutationResult<SaveActionItemMutation>;
export type SaveActionItemMutationOptions = Apollo.BaseMutationOptions<SaveActionItemMutation, SaveActionItemMutationVariables>;
export const ActionItemsByClientIdDocument = gql`
    query actionItemsByClientId($clientId: UUID!) {
  actionItemsByClientId(clientId: $clientId) {
    ...ActionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;

/**
 * __useActionItemsByClientIdQuery__
 *
 * To run a query within a React component, call `useActionItemsByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionItemsByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionItemsByClientIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useActionItemsByClientIdQuery(baseOptions: Apollo.QueryHookOptions<ActionItemsByClientIdQuery, ActionItemsByClientIdQueryVariables> & ({ variables: ActionItemsByClientIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionItemsByClientIdQuery, ActionItemsByClientIdQueryVariables>(ActionItemsByClientIdDocument, options);
      }
export function useActionItemsByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionItemsByClientIdQuery, ActionItemsByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionItemsByClientIdQuery, ActionItemsByClientIdQueryVariables>(ActionItemsByClientIdDocument, options);
        }
export function useActionItemsByClientIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActionItemsByClientIdQuery, ActionItemsByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActionItemsByClientIdQuery, ActionItemsByClientIdQueryVariables>(ActionItemsByClientIdDocument, options);
        }
export type ActionItemsByClientIdQueryHookResult = ReturnType<typeof useActionItemsByClientIdQuery>;
export type ActionItemsByClientIdLazyQueryHookResult = ReturnType<typeof useActionItemsByClientIdLazyQuery>;
export type ActionItemsByClientIdSuspenseQueryHookResult = ReturnType<typeof useActionItemsByClientIdSuspenseQuery>;
export type ActionItemsByClientIdQueryResult = Apollo.QueryResult<ActionItemsByClientIdQuery, ActionItemsByClientIdQueryVariables>;
export const ActionItemsDocument = gql`
    query actionItems($filter: ActionItemFilterInput!, $pageInput: PageInput!, $sort: ActionItemSortInput) {
  actionItems(filter: $filter, pageInput: $pageInput, sort: $sort) {
    totalElements
    hasNext
    number
    data {
      ...ActionItemFields
    }
  }
}
    ${ActionItemFieldsFragmentDoc}`;

/**
 * __useActionItemsQuery__
 *
 * To run a query within a React component, call `useActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageInput: // value for 'pageInput'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useActionItemsQuery(baseOptions: Apollo.QueryHookOptions<ActionItemsQuery, ActionItemsQueryVariables> & ({ variables: ActionItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionItemsQuery, ActionItemsQueryVariables>(ActionItemsDocument, options);
      }
export function useActionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionItemsQuery, ActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionItemsQuery, ActionItemsQueryVariables>(ActionItemsDocument, options);
        }
export function useActionItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActionItemsQuery, ActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActionItemsQuery, ActionItemsQueryVariables>(ActionItemsDocument, options);
        }
export type ActionItemsQueryHookResult = ReturnType<typeof useActionItemsQuery>;
export type ActionItemsLazyQueryHookResult = ReturnType<typeof useActionItemsLazyQuery>;
export type ActionItemsSuspenseQueryHookResult = ReturnType<typeof useActionItemsSuspenseQuery>;
export type ActionItemsQueryResult = Apollo.QueryResult<ActionItemsQuery, ActionItemsQueryVariables>;
export const CallHistoryAiAnalysisByClientDocument = gql`
    query callHistoryAIAnalysisByClient($client: UUID!) {
  callHistoryAIAnalysisByClient(client: $client) {
    callHistoryId
    airCallTimeline
    aiAnalysis
  }
}
    `;

/**
 * __useCallHistoryAiAnalysisByClientQuery__
 *
 * To run a query within a React component, call `useCallHistoryAiAnalysisByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallHistoryAiAnalysisByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallHistoryAiAnalysisByClientQuery({
 *   variables: {
 *      client: // value for 'client'
 *   },
 * });
 */
export function useCallHistoryAiAnalysisByClientQuery(baseOptions: Apollo.QueryHookOptions<CallHistoryAiAnalysisByClientQuery, CallHistoryAiAnalysisByClientQueryVariables> & ({ variables: CallHistoryAiAnalysisByClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallHistoryAiAnalysisByClientQuery, CallHistoryAiAnalysisByClientQueryVariables>(CallHistoryAiAnalysisByClientDocument, options);
      }
export function useCallHistoryAiAnalysisByClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallHistoryAiAnalysisByClientQuery, CallHistoryAiAnalysisByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallHistoryAiAnalysisByClientQuery, CallHistoryAiAnalysisByClientQueryVariables>(CallHistoryAiAnalysisByClientDocument, options);
        }
export function useCallHistoryAiAnalysisByClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CallHistoryAiAnalysisByClientQuery, CallHistoryAiAnalysisByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallHistoryAiAnalysisByClientQuery, CallHistoryAiAnalysisByClientQueryVariables>(CallHistoryAiAnalysisByClientDocument, options);
        }
export type CallHistoryAiAnalysisByClientQueryHookResult = ReturnType<typeof useCallHistoryAiAnalysisByClientQuery>;
export type CallHistoryAiAnalysisByClientLazyQueryHookResult = ReturnType<typeof useCallHistoryAiAnalysisByClientLazyQuery>;
export type CallHistoryAiAnalysisByClientSuspenseQueryHookResult = ReturnType<typeof useCallHistoryAiAnalysisByClientSuspenseQuery>;
export type CallHistoryAiAnalysisByClientQueryResult = Apollo.QueryResult<CallHistoryAiAnalysisByClientQuery, CallHistoryAiAnalysisByClientQueryVariables>;
export const SaveTagDocument = gql`
    mutation saveTag($input: TagInput!) {
  saveTag(input: $input)
}
    `;
export type SaveTagMutationFn = Apollo.MutationFunction<SaveTagMutation, SaveTagMutationVariables>;

/**
 * __useSaveTagMutation__
 *
 * To run a mutation, you first call `useSaveTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTagMutation, { data, loading, error }] = useSaveTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTagMutation(baseOptions?: Apollo.MutationHookOptions<SaveTagMutation, SaveTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTagMutation, SaveTagMutationVariables>(SaveTagDocument, options);
      }
export type SaveTagMutationHookResult = ReturnType<typeof useSaveTagMutation>;
export type SaveTagMutationResult = Apollo.MutationResult<SaveTagMutation>;
export type SaveTagMutationOptions = Apollo.BaseMutationOptions<SaveTagMutation, SaveTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation deleteTag($id: UUID!) {
  deleteTag(id: $id)
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const TagsDocument = gql`
    query tags {
  tags {
    color
    id
    name
    aiEnabled
    aiDescription
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export function useTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsSuspenseQueryHookResult = ReturnType<typeof useTagsSuspenseQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const SaveAgentGmailCodeDocument = gql`
    mutation saveAgentGmailCode($code: String!) {
  saveAgentGmailCode(code: $code)
}
    `;
export type SaveAgentGmailCodeMutationFn = Apollo.MutationFunction<SaveAgentGmailCodeMutation, SaveAgentGmailCodeMutationVariables>;

/**
 * __useSaveAgentGmailCodeMutation__
 *
 * To run a mutation, you first call `useSaveAgentGmailCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAgentGmailCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAgentGmailCodeMutation, { data, loading, error }] = useSaveAgentGmailCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSaveAgentGmailCodeMutation(baseOptions?: Apollo.MutationHookOptions<SaveAgentGmailCodeMutation, SaveAgentGmailCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAgentGmailCodeMutation, SaveAgentGmailCodeMutationVariables>(SaveAgentGmailCodeDocument, options);
      }
export type SaveAgentGmailCodeMutationHookResult = ReturnType<typeof useSaveAgentGmailCodeMutation>;
export type SaveAgentGmailCodeMutationResult = Apollo.MutationResult<SaveAgentGmailCodeMutation>;
export type SaveAgentGmailCodeMutationOptions = Apollo.BaseMutationOptions<SaveAgentGmailCodeMutation, SaveAgentGmailCodeMutationVariables>;
export const IsAgentGmailSetUpDocument = gql`
    query isAgentGmailSetUp($agentId: UUID!) {
  isAgentGmailSetUp(agentId: $agentId)
}
    `;

/**
 * __useIsAgentGmailSetUpQuery__
 *
 * To run a query within a React component, call `useIsAgentGmailSetUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsAgentGmailSetUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsAgentGmailSetUpQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useIsAgentGmailSetUpQuery(baseOptions: Apollo.QueryHookOptions<IsAgentGmailSetUpQuery, IsAgentGmailSetUpQueryVariables> & ({ variables: IsAgentGmailSetUpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsAgentGmailSetUpQuery, IsAgentGmailSetUpQueryVariables>(IsAgentGmailSetUpDocument, options);
      }
export function useIsAgentGmailSetUpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsAgentGmailSetUpQuery, IsAgentGmailSetUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsAgentGmailSetUpQuery, IsAgentGmailSetUpQueryVariables>(IsAgentGmailSetUpDocument, options);
        }
export function useIsAgentGmailSetUpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsAgentGmailSetUpQuery, IsAgentGmailSetUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsAgentGmailSetUpQuery, IsAgentGmailSetUpQueryVariables>(IsAgentGmailSetUpDocument, options);
        }
export type IsAgentGmailSetUpQueryHookResult = ReturnType<typeof useIsAgentGmailSetUpQuery>;
export type IsAgentGmailSetUpLazyQueryHookResult = ReturnType<typeof useIsAgentGmailSetUpLazyQuery>;
export type IsAgentGmailSetUpSuspenseQueryHookResult = ReturnType<typeof useIsAgentGmailSetUpSuspenseQuery>;
export type IsAgentGmailSetUpQueryResult = Apollo.QueryResult<IsAgentGmailSetUpQuery, IsAgentGmailSetUpQueryVariables>;
export const SetDefaultAgentDocument = gql`
    mutation setDefaultAgent($agentId: UUID!) {
  setDefaultAgent(agentId: $agentId)
}
    `;
export type SetDefaultAgentMutationFn = Apollo.MutationFunction<SetDefaultAgentMutation, SetDefaultAgentMutationVariables>;

/**
 * __useSetDefaultAgentMutation__
 *
 * To run a mutation, you first call `useSetDefaultAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultAgentMutation, { data, loading, error }] = useSetDefaultAgentMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useSetDefaultAgentMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultAgentMutation, SetDefaultAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultAgentMutation, SetDefaultAgentMutationVariables>(SetDefaultAgentDocument, options);
      }
export type SetDefaultAgentMutationHookResult = ReturnType<typeof useSetDefaultAgentMutation>;
export type SetDefaultAgentMutationResult = Apollo.MutationResult<SetDefaultAgentMutation>;
export type SetDefaultAgentMutationOptions = Apollo.BaseMutationOptions<SetDefaultAgentMutation, SetDefaultAgentMutationVariables>;
export const UrgentCallRequestsDocument = gql`
    subscription urgentCallRequests {
  urgentCallRequests {
    clientId
    email
    firstName
    lastName
    urgentCallType
  }
}
    `;

/**
 * __useUrgentCallRequestsSubscription__
 *
 * To run a query within a React component, call `useUrgentCallRequestsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUrgentCallRequestsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUrgentCallRequestsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUrgentCallRequestsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UrgentCallRequestsSubscription, UrgentCallRequestsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UrgentCallRequestsSubscription, UrgentCallRequestsSubscriptionVariables>(UrgentCallRequestsDocument, options);
      }
export type UrgentCallRequestsSubscriptionHookResult = ReturnType<typeof useUrgentCallRequestsSubscription>;
export type UrgentCallRequestsSubscriptionResult = Apollo.SubscriptionResult<UrgentCallRequestsSubscription>;
export const UploadAgentAvatarDocument = gql`
    mutation uploadAgentAvatar($img: Upload!) {
  uploadAgentAvatar(img: $img)
}
    `;
export type UploadAgentAvatarMutationFn = Apollo.MutationFunction<UploadAgentAvatarMutation, UploadAgentAvatarMutationVariables>;

/**
 * __useUploadAgentAvatarMutation__
 *
 * To run a mutation, you first call `useUploadAgentAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAgentAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAgentAvatarMutation, { data, loading, error }] = useUploadAgentAvatarMutation({
 *   variables: {
 *      img: // value for 'img'
 *   },
 * });
 */
export function useUploadAgentAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UploadAgentAvatarMutation, UploadAgentAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAgentAvatarMutation, UploadAgentAvatarMutationVariables>(UploadAgentAvatarDocument, options);
      }
export type UploadAgentAvatarMutationHookResult = ReturnType<typeof useUploadAgentAvatarMutation>;
export type UploadAgentAvatarMutationResult = Apollo.MutationResult<UploadAgentAvatarMutation>;
export type UploadAgentAvatarMutationOptions = Apollo.BaseMutationOptions<UploadAgentAvatarMutation, UploadAgentAvatarMutationVariables>;
export const SaveAgentDocument = gql`
    mutation saveAgent($input: AgentInput!) {
  saveAgent(input: $input)
}
    `;
export type SaveAgentMutationFn = Apollo.MutationFunction<SaveAgentMutation, SaveAgentMutationVariables>;

/**
 * __useSaveAgentMutation__
 *
 * To run a mutation, you first call `useSaveAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAgentMutation, { data, loading, error }] = useSaveAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAgentMutation(baseOptions?: Apollo.MutationHookOptions<SaveAgentMutation, SaveAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAgentMutation, SaveAgentMutationVariables>(SaveAgentDocument, options);
      }
export type SaveAgentMutationHookResult = ReturnType<typeof useSaveAgentMutation>;
export type SaveAgentMutationResult = Apollo.MutationResult<SaveAgentMutation>;
export type SaveAgentMutationOptions = Apollo.BaseMutationOptions<SaveAgentMutation, SaveAgentMutationVariables>;
export const AgentDashboardCountersDocument = gql`
    query agentDashboardCounters($agentId: UUID!, $missingAppsTagId: UUID!) {
  salesQualified(agentId: $agentId, pageInput: {page: 0, size: 20}) {
    totalElements
  }
  salesQualifiedFuture(agentId: $agentId, pageInput: {page: 0, size: 20}) {
    totalElements
  }
  followUps(
    agentId: $agentId
    excludedTagsIds: [$missingAppsTagId]
    pageInput: {page: 0, size: 20}
  ) {
    totalElements
  }
  followUpsFuture(
    agentId: $agentId
    excludedTagsIds: [$missingAppsTagId]
    pageInput: {page: 0, size: 20}
  ) {
    totalElements
  }
  missingApps: followUps(
    agentId: $agentId
    includedTagsIds: [$missingAppsTagId]
    pageInput: {page: 0, size: 20}
  ) {
    totalElements
  }
  contacted(agentId: $agentId, pageInput: {page: 0, size: 20}) {
    totalElements
  }
}
    `;

/**
 * __useAgentDashboardCountersQuery__
 *
 * To run a query within a React component, call `useAgentDashboardCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentDashboardCountersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentDashboardCountersQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      missingAppsTagId: // value for 'missingAppsTagId'
 *   },
 * });
 */
export function useAgentDashboardCountersQuery(baseOptions: Apollo.QueryHookOptions<AgentDashboardCountersQuery, AgentDashboardCountersQueryVariables> & ({ variables: AgentDashboardCountersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentDashboardCountersQuery, AgentDashboardCountersQueryVariables>(AgentDashboardCountersDocument, options);
      }
export function useAgentDashboardCountersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentDashboardCountersQuery, AgentDashboardCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentDashboardCountersQuery, AgentDashboardCountersQueryVariables>(AgentDashboardCountersDocument, options);
        }
export function useAgentDashboardCountersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentDashboardCountersQuery, AgentDashboardCountersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentDashboardCountersQuery, AgentDashboardCountersQueryVariables>(AgentDashboardCountersDocument, options);
        }
export type AgentDashboardCountersQueryHookResult = ReturnType<typeof useAgentDashboardCountersQuery>;
export type AgentDashboardCountersLazyQueryHookResult = ReturnType<typeof useAgentDashboardCountersLazyQuery>;
export type AgentDashboardCountersSuspenseQueryHookResult = ReturnType<typeof useAgentDashboardCountersSuspenseQuery>;
export type AgentDashboardCountersQueryResult = Apollo.QueryResult<AgentDashboardCountersQuery, AgentDashboardCountersQueryVariables>;
export const TwoHrCallbackDocument = gql`
    subscription twoHrCallback($filter: SLAFilterInput!) {
  slas(filter: $filter, pageInput: {page: 0, size: 100}) {
    data {
      createdAt
    }
    totalElements
  }
}
    `;

/**
 * __useTwoHrCallbackSubscription__
 *
 * To run a query within a React component, call `useTwoHrCallbackSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTwoHrCallbackSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTwoHrCallbackSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTwoHrCallbackSubscription(baseOptions: Apollo.SubscriptionHookOptions<TwoHrCallbackSubscription, TwoHrCallbackSubscriptionVariables> & ({ variables: TwoHrCallbackSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TwoHrCallbackSubscription, TwoHrCallbackSubscriptionVariables>(TwoHrCallbackDocument, options);
      }
export type TwoHrCallbackSubscriptionHookResult = ReturnType<typeof useTwoHrCallbackSubscription>;
export type TwoHrCallbackSubscriptionResult = Apollo.SubscriptionResult<TwoHrCallbackSubscription>;
export const NewLeadsStatisticsDocument = gql`
    subscription newLeadsStatistics {
  newLeadsStatistics {
    count
    nerdWalletCount
    oldestCreatedAt
  }
}
    `;

/**
 * __useNewLeadsStatisticsSubscription__
 *
 * To run a query within a React component, call `useNewLeadsStatisticsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewLeadsStatisticsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewLeadsStatisticsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewLeadsStatisticsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NewLeadsStatisticsSubscription, NewLeadsStatisticsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewLeadsStatisticsSubscription, NewLeadsStatisticsSubscriptionVariables>(NewLeadsStatisticsDocument, options);
      }
export type NewLeadsStatisticsSubscriptionHookResult = ReturnType<typeof useNewLeadsStatisticsSubscription>;
export type NewLeadsStatisticsSubscriptionResult = Apollo.SubscriptionResult<NewLeadsStatisticsSubscription>;
export const DeleteClientFileDocument = gql`
    mutation deleteClientFile($link: String!, $clientId: UUID!) {
  deleteClientFile(link: $link, clientId: $clientId)
}
    `;
export type DeleteClientFileMutationFn = Apollo.MutationFunction<DeleteClientFileMutation, DeleteClientFileMutationVariables>;

/**
 * __useDeleteClientFileMutation__
 *
 * To run a mutation, you first call `useDeleteClientFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientFileMutation, { data, loading, error }] = useDeleteClientFileMutation({
 *   variables: {
 *      link: // value for 'link'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useDeleteClientFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientFileMutation, DeleteClientFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientFileMutation, DeleteClientFileMutationVariables>(DeleteClientFileDocument, options);
      }
export type DeleteClientFileMutationHookResult = ReturnType<typeof useDeleteClientFileMutation>;
export type DeleteClientFileMutationResult = Apollo.MutationResult<DeleteClientFileMutation>;
export type DeleteClientFileMutationOptions = Apollo.BaseMutationOptions<DeleteClientFileMutation, DeleteClientFileMutationVariables>;
export const AddClientFilesDocument = gql`
    mutation addClientFiles($clientFiles: [ClientFileInput!]!, $clientId: UUID!) {
  addClientFiles(clientFiles: $clientFiles, clientId: $clientId)
}
    `;
export type AddClientFilesMutationFn = Apollo.MutationFunction<AddClientFilesMutation, AddClientFilesMutationVariables>;

/**
 * __useAddClientFilesMutation__
 *
 * To run a mutation, you first call `useAddClientFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientFilesMutation, { data, loading, error }] = useAddClientFilesMutation({
 *   variables: {
 *      clientFiles: // value for 'clientFiles'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useAddClientFilesMutation(baseOptions?: Apollo.MutationHookOptions<AddClientFilesMutation, AddClientFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClientFilesMutation, AddClientFilesMutationVariables>(AddClientFilesDocument, options);
      }
export type AddClientFilesMutationHookResult = ReturnType<typeof useAddClientFilesMutation>;
export type AddClientFilesMutationResult = Apollo.MutationResult<AddClientFilesMutation>;
export type AddClientFilesMutationOptions = Apollo.BaseMutationOptions<AddClientFilesMutation, AddClientFilesMutationVariables>;
export const UpdateClientNoteDocument = gql`
    mutation updateClientNote($noteId: UUID!, $note: String!) {
  updateClientNote(noteId: $noteId, note: $note)
}
    `;
export type UpdateClientNoteMutationFn = Apollo.MutationFunction<UpdateClientNoteMutation, UpdateClientNoteMutationVariables>;

/**
 * __useUpdateClientNoteMutation__
 *
 * To run a mutation, you first call `useUpdateClientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientNoteMutation, { data, loading, error }] = useUpdateClientNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateClientNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientNoteMutation, UpdateClientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientNoteMutation, UpdateClientNoteMutationVariables>(UpdateClientNoteDocument, options);
      }
export type UpdateClientNoteMutationHookResult = ReturnType<typeof useUpdateClientNoteMutation>;
export type UpdateClientNoteMutationResult = Apollo.MutationResult<UpdateClientNoteMutation>;
export type UpdateClientNoteMutationOptions = Apollo.BaseMutationOptions<UpdateClientNoteMutation, UpdateClientNoteMutationVariables>;
export const CreateClientNoteDocument = gql`
    mutation createClientNote($clientId: UUID!, $note: String!, $isManagerNote: Boolean) {
  createClientNote(
    clientId: $clientId
    note: $note
    isManagerNote: $isManagerNote
  )
}
    `;
export type CreateClientNoteMutationFn = Apollo.MutationFunction<CreateClientNoteMutation, CreateClientNoteMutationVariables>;

/**
 * __useCreateClientNoteMutation__
 *
 * To run a mutation, you first call `useCreateClientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientNoteMutation, { data, loading, error }] = useCreateClientNoteMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      note: // value for 'note'
 *      isManagerNote: // value for 'isManagerNote'
 *   },
 * });
 */
export function useCreateClientNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientNoteMutation, CreateClientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientNoteMutation, CreateClientNoteMutationVariables>(CreateClientNoteDocument, options);
      }
export type CreateClientNoteMutationHookResult = ReturnType<typeof useCreateClientNoteMutation>;
export type CreateClientNoteMutationResult = Apollo.MutationResult<CreateClientNoteMutation>;
export type CreateClientNoteMutationOptions = Apollo.BaseMutationOptions<CreateClientNoteMutation, CreateClientNoteMutationVariables>;
export const SaveChannelAttributionDocument = gql`
    mutation saveChannelAttribution($clientId: UUID!, $marketingCampaign: String, $marketingSource: String) {
  saveChannelAttribution(
    clientId: $clientId
    marketingCampaign: $marketingCampaign
    marketingSource: $marketingSource
  )
}
    `;
export type SaveChannelAttributionMutationFn = Apollo.MutationFunction<SaveChannelAttributionMutation, SaveChannelAttributionMutationVariables>;

/**
 * __useSaveChannelAttributionMutation__
 *
 * To run a mutation, you first call `useSaveChannelAttributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChannelAttributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChannelAttributionMutation, { data, loading, error }] = useSaveChannelAttributionMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      marketingCampaign: // value for 'marketingCampaign'
 *      marketingSource: // value for 'marketingSource'
 *   },
 * });
 */
export function useSaveChannelAttributionMutation(baseOptions?: Apollo.MutationHookOptions<SaveChannelAttributionMutation, SaveChannelAttributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveChannelAttributionMutation, SaveChannelAttributionMutationVariables>(SaveChannelAttributionDocument, options);
      }
export type SaveChannelAttributionMutationHookResult = ReturnType<typeof useSaveChannelAttributionMutation>;
export type SaveChannelAttributionMutationResult = Apollo.MutationResult<SaveChannelAttributionMutation>;
export type SaveChannelAttributionMutationOptions = Apollo.BaseMutationOptions<SaveChannelAttributionMutation, SaveChannelAttributionMutationVariables>;
export const SearchForClientGroupDocument = gql`
    query searchForClientGroup($pageInput: PageInput!, $filterInput: ClientViewFilterInput) {
  clientViews(pageInput: $pageInput, filterInput: $filterInput) {
    totalElements
    data {
      clientId
      email
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useSearchForClientGroupQuery__
 *
 * To run a query within a React component, call `useSearchForClientGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchForClientGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchForClientGroupQuery({
 *   variables: {
 *      pageInput: // value for 'pageInput'
 *      filterInput: // value for 'filterInput'
 *   },
 * });
 */
export function useSearchForClientGroupQuery(baseOptions: Apollo.QueryHookOptions<SearchForClientGroupQuery, SearchForClientGroupQueryVariables> & ({ variables: SearchForClientGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchForClientGroupQuery, SearchForClientGroupQueryVariables>(SearchForClientGroupDocument, options);
      }
export function useSearchForClientGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchForClientGroupQuery, SearchForClientGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchForClientGroupQuery, SearchForClientGroupQueryVariables>(SearchForClientGroupDocument, options);
        }
export function useSearchForClientGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchForClientGroupQuery, SearchForClientGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchForClientGroupQuery, SearchForClientGroupQueryVariables>(SearchForClientGroupDocument, options);
        }
export type SearchForClientGroupQueryHookResult = ReturnType<typeof useSearchForClientGroupQuery>;
export type SearchForClientGroupLazyQueryHookResult = ReturnType<typeof useSearchForClientGroupLazyQuery>;
export type SearchForClientGroupSuspenseQueryHookResult = ReturnType<typeof useSearchForClientGroupSuspenseQuery>;
export type SearchForClientGroupQueryResult = Apollo.QueryResult<SearchForClientGroupQuery, SearchForClientGroupQueryVariables>;
export const DeleteClientNoteDocument = gql`
    mutation deleteClientNote($noteId: UUID!) {
  deleteClientNote(noteId: $noteId)
}
    `;
export type DeleteClientNoteMutationFn = Apollo.MutationFunction<DeleteClientNoteMutation, DeleteClientNoteMutationVariables>;

/**
 * __useDeleteClientNoteMutation__
 *
 * To run a mutation, you first call `useDeleteClientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientNoteMutation, { data, loading, error }] = useDeleteClientNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useDeleteClientNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientNoteMutation, DeleteClientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientNoteMutation, DeleteClientNoteMutationVariables>(DeleteClientNoteDocument, options);
      }
export type DeleteClientNoteMutationHookResult = ReturnType<typeof useDeleteClientNoteMutation>;
export type DeleteClientNoteMutationResult = Apollo.MutationResult<DeleteClientNoteMutation>;
export type DeleteClientNoteMutationOptions = Apollo.BaseMutationOptions<DeleteClientNoteMutation, DeleteClientNoteMutationVariables>;
export const SetClientUserIdDocument = gql`
    mutation setClientUserId($clientId: UUID!, $userId: UUID) {
  setClientUserId(clientId: $clientId, userId: $userId)
}
    `;
export type SetClientUserIdMutationFn = Apollo.MutationFunction<SetClientUserIdMutation, SetClientUserIdMutationVariables>;

/**
 * __useSetClientUserIdMutation__
 *
 * To run a mutation, you first call `useSetClientUserIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClientUserIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClientUserIdMutation, { data, loading, error }] = useSetClientUserIdMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetClientUserIdMutation(baseOptions?: Apollo.MutationHookOptions<SetClientUserIdMutation, SetClientUserIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClientUserIdMutation, SetClientUserIdMutationVariables>(SetClientUserIdDocument, options);
      }
export type SetClientUserIdMutationHookResult = ReturnType<typeof useSetClientUserIdMutation>;
export type SetClientUserIdMutationResult = Apollo.MutationResult<SetClientUserIdMutation>;
export type SetClientUserIdMutationOptions = Apollo.BaseMutationOptions<SetClientUserIdMutation, SetClientUserIdMutationVariables>;
export const CheckUserExistenceByEmailDocument = gql`
    query checkUserExistenceByEmail($email: String!) {
  checkUserExistenceByEmail(email: $email)
}
    `;

/**
 * __useCheckUserExistenceByEmailQuery__
 *
 * To run a query within a React component, call `useCheckUserExistenceByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserExistenceByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserExistenceByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckUserExistenceByEmailQuery(baseOptions: Apollo.QueryHookOptions<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables> & ({ variables: CheckUserExistenceByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables>(CheckUserExistenceByEmailDocument, options);
      }
export function useCheckUserExistenceByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables>(CheckUserExistenceByEmailDocument, options);
        }
export function useCheckUserExistenceByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables>(CheckUserExistenceByEmailDocument, options);
        }
export type CheckUserExistenceByEmailQueryHookResult = ReturnType<typeof useCheckUserExistenceByEmailQuery>;
export type CheckUserExistenceByEmailLazyQueryHookResult = ReturnType<typeof useCheckUserExistenceByEmailLazyQuery>;
export type CheckUserExistenceByEmailSuspenseQueryHookResult = ReturnType<typeof useCheckUserExistenceByEmailSuspenseQuery>;
export type CheckUserExistenceByEmailQueryResult = Apollo.QueryResult<CheckUserExistenceByEmailQuery, CheckUserExistenceByEmailQueryVariables>;
export const SaveClientTagDocument = gql`
    mutation saveClientTag($input: ClientTagInput!) {
  saveClientTag(input: $input)
}
    `;
export type SaveClientTagMutationFn = Apollo.MutationFunction<SaveClientTagMutation, SaveClientTagMutationVariables>;

/**
 * __useSaveClientTagMutation__
 *
 * To run a mutation, you first call `useSaveClientTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveClientTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveClientTagMutation, { data, loading, error }] = useSaveClientTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveClientTagMutation(baseOptions?: Apollo.MutationHookOptions<SaveClientTagMutation, SaveClientTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveClientTagMutation, SaveClientTagMutationVariables>(SaveClientTagDocument, options);
      }
export type SaveClientTagMutationHookResult = ReturnType<typeof useSaveClientTagMutation>;
export type SaveClientTagMutationResult = Apollo.MutationResult<SaveClientTagMutation>;
export type SaveClientTagMutationOptions = Apollo.BaseMutationOptions<SaveClientTagMutation, SaveClientTagMutationVariables>;
export const SlasDocument = gql`
    subscription slas($pageInput: PageInput!, $filter: SLAFilterInput!) {
  slas(pageInput: $pageInput, filter: $filter) {
    data {
      agent {
        email
        firstName
        id
        lastName
      }
      firstCallAgentName
      secondCallAgentName
      callsCount
      tags {
        expiresAt
        aiGenerated
        tag {
          color
          id
          name
        }
      }
      state
      clientId
      createdAt
      firstCallAt
      firstName
      lastName
      phoneNumber
      secondCallAt
      status
      successfulCallsCount
    }
    totalElements
  }
}
    `;

/**
 * __useSlasSubscription__
 *
 * To run a query within a React component, call `useSlasSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSlasSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlasSubscription({
 *   variables: {
 *      pageInput: // value for 'pageInput'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSlasSubscription(baseOptions: Apollo.SubscriptionHookOptions<SlasSubscription, SlasSubscriptionVariables> & ({ variables: SlasSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SlasSubscription, SlasSubscriptionVariables>(SlasDocument, options);
      }
export type SlasSubscriptionHookResult = ReturnType<typeof useSlasSubscription>;
export type SlasSubscriptionResult = Apollo.SubscriptionResult<SlasSubscription>;
export const AttemptedLeadsDocument = gql`
    query attemptedLeads($filter: AttemptedLeadFilterInput!, $pageInput: PageInput!, $sort: AttemptedLeadSortInput) {
  attemptedLeads(filter: $filter, pageInput: $pageInput, sort: $sort) {
    data {
      birthDate
      callsCount
      clientId
      firstName
      email
      iepFlag
      lastCallDate
      lastName
      leadDate
      leadGroup
      phoneNumber
      state
      status
      urgent
      lastCallAgentFullName
      tags {
        expiresAt
        aiGenerated
        tag {
          color
          id
          name
        }
      }
    }
    totalElements
  }
}
    `;

/**
 * __useAttemptedLeadsQuery__
 *
 * To run a query within a React component, call `useAttemptedLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttemptedLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttemptedLeadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageInput: // value for 'pageInput'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAttemptedLeadsQuery(baseOptions: Apollo.QueryHookOptions<AttemptedLeadsQuery, AttemptedLeadsQueryVariables> & ({ variables: AttemptedLeadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttemptedLeadsQuery, AttemptedLeadsQueryVariables>(AttemptedLeadsDocument, options);
      }
export function useAttemptedLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttemptedLeadsQuery, AttemptedLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttemptedLeadsQuery, AttemptedLeadsQueryVariables>(AttemptedLeadsDocument, options);
        }
export function useAttemptedLeadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AttemptedLeadsQuery, AttemptedLeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttemptedLeadsQuery, AttemptedLeadsQueryVariables>(AttemptedLeadsDocument, options);
        }
export type AttemptedLeadsQueryHookResult = ReturnType<typeof useAttemptedLeadsQuery>;
export type AttemptedLeadsLazyQueryHookResult = ReturnType<typeof useAttemptedLeadsLazyQuery>;
export type AttemptedLeadsSuspenseQueryHookResult = ReturnType<typeof useAttemptedLeadsSuspenseQuery>;
export type AttemptedLeadsQueryResult = Apollo.QueryResult<AttemptedLeadsQuery, AttemptedLeadsQueryVariables>;
export const AvailableAgentsDocument = gql`
    query availableAgents {
  availableAgents {
    email
    firstName
    lastName
    id
  }
}
    `;

/**
 * __useAvailableAgentsQuery__
 *
 * To run a query within a React component, call `useAvailableAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableAgentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableAgentsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableAgentsQuery, AvailableAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableAgentsQuery, AvailableAgentsQueryVariables>(AvailableAgentsDocument, options);
      }
export function useAvailableAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableAgentsQuery, AvailableAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableAgentsQuery, AvailableAgentsQueryVariables>(AvailableAgentsDocument, options);
        }
export function useAvailableAgentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableAgentsQuery, AvailableAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableAgentsQuery, AvailableAgentsQueryVariables>(AvailableAgentsDocument, options);
        }
export type AvailableAgentsQueryHookResult = ReturnType<typeof useAvailableAgentsQuery>;
export type AvailableAgentsLazyQueryHookResult = ReturnType<typeof useAvailableAgentsLazyQuery>;
export type AvailableAgentsSuspenseQueryHookResult = ReturnType<typeof useAvailableAgentsSuspenseQuery>;
export type AvailableAgentsQueryResult = Apollo.QueryResult<AvailableAgentsQuery, AvailableAgentsQueryVariables>;
export const PatchClientPersonalInfoDocument = gql`
    mutation patchClientPersonalInfo($clientId: UUID!, $preferredDrugs: [PreferredDrugInput!], $preferredPharmacies: [String!], $drugDeliveryType: ClientDrugDeliveryType) {
  patchClientPersonalInfo(
    clientId: $clientId
    preferredDrugs: $preferredDrugs
    preferredPharmacies: $preferredPharmacies
    drugDeliveryType: $drugDeliveryType
  )
}
    `;
export type PatchClientPersonalInfoMutationFn = Apollo.MutationFunction<PatchClientPersonalInfoMutation, PatchClientPersonalInfoMutationVariables>;

/**
 * __usePatchClientPersonalInfoMutation__
 *
 * To run a mutation, you first call `usePatchClientPersonalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchClientPersonalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchClientPersonalInfoMutation, { data, loading, error }] = usePatchClientPersonalInfoMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      preferredDrugs: // value for 'preferredDrugs'
 *      preferredPharmacies: // value for 'preferredPharmacies'
 *      drugDeliveryType: // value for 'drugDeliveryType'
 *   },
 * });
 */
export function usePatchClientPersonalInfoMutation(baseOptions?: Apollo.MutationHookOptions<PatchClientPersonalInfoMutation, PatchClientPersonalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchClientPersonalInfoMutation, PatchClientPersonalInfoMutationVariables>(PatchClientPersonalInfoDocument, options);
      }
export type PatchClientPersonalInfoMutationHookResult = ReturnType<typeof usePatchClientPersonalInfoMutation>;
export type PatchClientPersonalInfoMutationResult = Apollo.MutationResult<PatchClientPersonalInfoMutation>;
export type PatchClientPersonalInfoMutationOptions = Apollo.BaseMutationOptions<PatchClientPersonalInfoMutation, PatchClientPersonalInfoMutationVariables>;
export const SetRecordedLineAgreementCheckDocument = gql`
    mutation setRecordedLineAgreementCheck($clientId: UUID!) {
  setRecordedLineAgreementCheck(clientId: $clientId)
}
    `;
export type SetRecordedLineAgreementCheckMutationFn = Apollo.MutationFunction<SetRecordedLineAgreementCheckMutation, SetRecordedLineAgreementCheckMutationVariables>;

/**
 * __useSetRecordedLineAgreementCheckMutation__
 *
 * To run a mutation, you first call `useSetRecordedLineAgreementCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRecordedLineAgreementCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRecordedLineAgreementCheckMutation, { data, loading, error }] = useSetRecordedLineAgreementCheckMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useSetRecordedLineAgreementCheckMutation(baseOptions?: Apollo.MutationHookOptions<SetRecordedLineAgreementCheckMutation, SetRecordedLineAgreementCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRecordedLineAgreementCheckMutation, SetRecordedLineAgreementCheckMutationVariables>(SetRecordedLineAgreementCheckDocument, options);
      }
export type SetRecordedLineAgreementCheckMutationHookResult = ReturnType<typeof useSetRecordedLineAgreementCheckMutation>;
export type SetRecordedLineAgreementCheckMutationResult = Apollo.MutationResult<SetRecordedLineAgreementCheckMutation>;
export type SetRecordedLineAgreementCheckMutationOptions = Apollo.BaseMutationOptions<SetRecordedLineAgreementCheckMutation, SetRecordedLineAgreementCheckMutationVariables>;
export const SetTpmoAgreementCheckDocument = gql`
    mutation setTPMOAgreementCheck($clientId: UUID!) {
  setTPMOAgreementCheck(clientId: $clientId)
}
    `;
export type SetTpmoAgreementCheckMutationFn = Apollo.MutationFunction<SetTpmoAgreementCheckMutation, SetTpmoAgreementCheckMutationVariables>;

/**
 * __useSetTpmoAgreementCheckMutation__
 *
 * To run a mutation, you first call `useSetTpmoAgreementCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTpmoAgreementCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTpmoAgreementCheckMutation, { data, loading, error }] = useSetTpmoAgreementCheckMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useSetTpmoAgreementCheckMutation(baseOptions?: Apollo.MutationHookOptions<SetTpmoAgreementCheckMutation, SetTpmoAgreementCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTpmoAgreementCheckMutation, SetTpmoAgreementCheckMutationVariables>(SetTpmoAgreementCheckDocument, options);
      }
export type SetTpmoAgreementCheckMutationHookResult = ReturnType<typeof useSetTpmoAgreementCheckMutation>;
export type SetTpmoAgreementCheckMutationResult = Apollo.MutationResult<SetTpmoAgreementCheckMutation>;
export type SetTpmoAgreementCheckMutationOptions = Apollo.BaseMutationOptions<SetTpmoAgreementCheckMutation, SetTpmoAgreementCheckMutationVariables>;
export const SetSoaAgreementCheckDocument = gql`
    mutation setSOAAgreementCheck($clientId: UUID!) {
  setSOAAgreementCheck(clientId: $clientId)
}
    `;
export type SetSoaAgreementCheckMutationFn = Apollo.MutationFunction<SetSoaAgreementCheckMutation, SetSoaAgreementCheckMutationVariables>;

/**
 * __useSetSoaAgreementCheckMutation__
 *
 * To run a mutation, you first call `useSetSoaAgreementCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSoaAgreementCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSoaAgreementCheckMutation, { data, loading, error }] = useSetSoaAgreementCheckMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useSetSoaAgreementCheckMutation(baseOptions?: Apollo.MutationHookOptions<SetSoaAgreementCheckMutation, SetSoaAgreementCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSoaAgreementCheckMutation, SetSoaAgreementCheckMutationVariables>(SetSoaAgreementCheckDocument, options);
      }
export type SetSoaAgreementCheckMutationHookResult = ReturnType<typeof useSetSoaAgreementCheckMutation>;
export type SetSoaAgreementCheckMutationResult = Apollo.MutationResult<SetSoaAgreementCheckMutation>;
export type SetSoaAgreementCheckMutationOptions = Apollo.BaseMutationOptions<SetSoaAgreementCheckMutation, SetSoaAgreementCheckMutationVariables>;
export const AgentsDocument = gql`
    query agents($page: PageInput!, $filter: AgentFilterInput!, $sort: AgentSortInput) {
  agents(page: $page, filter: $filter, sort: $sort) {
    data {
      consultationUrl
      email
      enabled
      enrollmentMeetingUrl
      firstName
      id
      lastName
      phone
      picUrl
      planReviewUrl
      receiveEmails
      isDefault
      isCSR
      enabledForRoundRobin
      role
    }
    totalElements
  }
}
    `;

/**
 * __useAgentsQuery__
 *
 * To run a query within a React component, call `useAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAgentsQuery(baseOptions: Apollo.QueryHookOptions<AgentsQuery, AgentsQueryVariables> & ({ variables: AgentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentsQuery, AgentsQueryVariables>(AgentsDocument, options);
      }
export function useAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentsQuery, AgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentsQuery, AgentsQueryVariables>(AgentsDocument, options);
        }
export function useAgentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentsQuery, AgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentsQuery, AgentsQueryVariables>(AgentsDocument, options);
        }
export type AgentsQueryHookResult = ReturnType<typeof useAgentsQuery>;
export type AgentsLazyQueryHookResult = ReturnType<typeof useAgentsLazyQuery>;
export type AgentsSuspenseQueryHookResult = ReturnType<typeof useAgentsSuspenseQuery>;
export type AgentsQueryResult = Apollo.QueryResult<AgentsQuery, AgentsQueryVariables>;
export const AgentCallAgendaDocument = gql`
    subscription agentCallAgenda {
  agentCallAgenda {
    assignedClientsCallTasks
    dontDisturb
    scheduledReassignAt
  }
}
    `;

/**
 * __useAgentCallAgendaSubscription__
 *
 * To run a query within a React component, call `useAgentCallAgendaSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAgentCallAgendaSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentCallAgendaSubscription({
 *   variables: {
 *   },
 * });
 */
export function useAgentCallAgendaSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AgentCallAgendaSubscription, AgentCallAgendaSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AgentCallAgendaSubscription, AgentCallAgendaSubscriptionVariables>(AgentCallAgendaDocument, options);
      }
export type AgentCallAgendaSubscriptionHookResult = ReturnType<typeof useAgentCallAgendaSubscription>;
export type AgentCallAgendaSubscriptionResult = Apollo.SubscriptionResult<AgentCallAgendaSubscription>;
export const StartTestCallFor30SecondsDocument = gql`
    mutation startTestCallFor30Seconds($agentId: UUID!, $clientId: UUID!) {
  startTestCallFor30Seconds(agentId: $agentId, clientId: $clientId)
}
    `;
export type StartTestCallFor30SecondsMutationFn = Apollo.MutationFunction<StartTestCallFor30SecondsMutation, StartTestCallFor30SecondsMutationVariables>;

/**
 * __useStartTestCallFor30SecondsMutation__
 *
 * To run a mutation, you first call `useStartTestCallFor30SecondsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTestCallFor30SecondsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTestCallFor30SecondsMutation, { data, loading, error }] = useStartTestCallFor30SecondsMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useStartTestCallFor30SecondsMutation(baseOptions?: Apollo.MutationHookOptions<StartTestCallFor30SecondsMutation, StartTestCallFor30SecondsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTestCallFor30SecondsMutation, StartTestCallFor30SecondsMutationVariables>(StartTestCallFor30SecondsDocument, options);
      }
export type StartTestCallFor30SecondsMutationHookResult = ReturnType<typeof useStartTestCallFor30SecondsMutation>;
export type StartTestCallFor30SecondsMutationResult = Apollo.MutationResult<StartTestCallFor30SecondsMutation>;
export type StartTestCallFor30SecondsMutationOptions = Apollo.BaseMutationOptions<StartTestCallFor30SecondsMutation, StartTestCallFor30SecondsMutationVariables>;
export const SetDontDisturbDocument = gql`
    mutation setDontDisturb($dontDisturb: Boolean!) {
  setDontDisturb(dontDisturb: $dontDisturb)
}
    `;
export type SetDontDisturbMutationFn = Apollo.MutationFunction<SetDontDisturbMutation, SetDontDisturbMutationVariables>;

/**
 * __useSetDontDisturbMutation__
 *
 * To run a mutation, you first call `useSetDontDisturbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDontDisturbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDontDisturbMutation, { data, loading, error }] = useSetDontDisturbMutation({
 *   variables: {
 *      dontDisturb: // value for 'dontDisturb'
 *   },
 * });
 */
export function useSetDontDisturbMutation(baseOptions?: Apollo.MutationHookOptions<SetDontDisturbMutation, SetDontDisturbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDontDisturbMutation, SetDontDisturbMutationVariables>(SetDontDisturbDocument, options);
      }
export type SetDontDisturbMutationHookResult = ReturnType<typeof useSetDontDisturbMutation>;
export type SetDontDisturbMutationResult = Apollo.MutationResult<SetDontDisturbMutation>;
export type SetDontDisturbMutationOptions = Apollo.BaseMutationOptions<SetDontDisturbMutation, SetDontDisturbMutationVariables>;
export const AgentByIdDocument = gql`
    query agentById($id: UUID!) {
  agentById(id: $id) {
    consultationUrl
    email
    enabled
    enrollmentMeetingUrl
    b2bMeetingUrl
    firstName
    id
    lastName
    phone
    picUrl
    planReviewUrl
    receiveEmails
    isDefault
    isCSR
    role
  }
}
    `;

/**
 * __useAgentByIdQuery__
 *
 * To run a query within a React component, call `useAgentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgentByIdQuery(baseOptions: Apollo.QueryHookOptions<AgentByIdQuery, AgentByIdQueryVariables> & ({ variables: AgentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentByIdQuery, AgentByIdQueryVariables>(AgentByIdDocument, options);
      }
export function useAgentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentByIdQuery, AgentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentByIdQuery, AgentByIdQueryVariables>(AgentByIdDocument, options);
        }
export function useAgentByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentByIdQuery, AgentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentByIdQuery, AgentByIdQueryVariables>(AgentByIdDocument, options);
        }
export type AgentByIdQueryHookResult = ReturnType<typeof useAgentByIdQuery>;
export type AgentByIdLazyQueryHookResult = ReturnType<typeof useAgentByIdLazyQuery>;
export type AgentByIdSuspenseQueryHookResult = ReturnType<typeof useAgentByIdSuspenseQuery>;
export type AgentByIdQueryResult = Apollo.QueryResult<AgentByIdQuery, AgentByIdQueryVariables>;
export const CsrTrackingReportDocument = gql`
    query csrTrackingReport($from: LocalDate!, $to: LocalDate!) {
  csrTrackingReport(from: $from, to: $to) {
    bookedCallsCount
    email
    agentId
    nonWarmTransfersAttendedCount
    nonWarmTransfersCount
    warmTransfersCount
    futureAppointmentsCount
    undispositionedAppointmentsCount
    nonWarmTransfersNotAttendedCount
  }
}
    `;

/**
 * __useCsrTrackingReportQuery__
 *
 * To run a query within a React component, call `useCsrTrackingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCsrTrackingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsrTrackingReportQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCsrTrackingReportQuery(baseOptions: Apollo.QueryHookOptions<CsrTrackingReportQuery, CsrTrackingReportQueryVariables> & ({ variables: CsrTrackingReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CsrTrackingReportQuery, CsrTrackingReportQueryVariables>(CsrTrackingReportDocument, options);
      }
export function useCsrTrackingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CsrTrackingReportQuery, CsrTrackingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CsrTrackingReportQuery, CsrTrackingReportQueryVariables>(CsrTrackingReportDocument, options);
        }
export function useCsrTrackingReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CsrTrackingReportQuery, CsrTrackingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CsrTrackingReportQuery, CsrTrackingReportQueryVariables>(CsrTrackingReportDocument, options);
        }
export type CsrTrackingReportQueryHookResult = ReturnType<typeof useCsrTrackingReportQuery>;
export type CsrTrackingReportLazyQueryHookResult = ReturnType<typeof useCsrTrackingReportLazyQuery>;
export type CsrTrackingReportSuspenseQueryHookResult = ReturnType<typeof useCsrTrackingReportSuspenseQuery>;
export type CsrTrackingReportQueryResult = Apollo.QueryResult<CsrTrackingReportQuery, CsrTrackingReportQueryVariables>;
export const SaveStatusDocument = gql`
    mutation saveStatus($id: UUID!, $status: StatusDto!, $agentId: UUID, $followUpDate: LocalDate) {
  saveStatus(
    id: $id
    status: $status
    agentId: $agentId
    followUpDate: $followUpDate
  )
}
    `;
export type SaveStatusMutationFn = Apollo.MutationFunction<SaveStatusMutation, SaveStatusMutationVariables>;

/**
 * __useSaveStatusMutation__
 *
 * To run a mutation, you first call `useSaveStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveStatusMutation, { data, loading, error }] = useSaveStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      agentId: // value for 'agentId'
 *      followUpDate: // value for 'followUpDate'
 *   },
 * });
 */
export function useSaveStatusMutation(baseOptions?: Apollo.MutationHookOptions<SaveStatusMutation, SaveStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveStatusMutation, SaveStatusMutationVariables>(SaveStatusDocument, options);
      }
export type SaveStatusMutationHookResult = ReturnType<typeof useSaveStatusMutation>;
export type SaveStatusMutationResult = Apollo.MutationResult<SaveStatusMutation>;
export type SaveStatusMutationOptions = Apollo.BaseMutationOptions<SaveStatusMutation, SaveStatusMutationVariables>;
export const SaveExpectedCloseDateDocument = gql`
    mutation saveExpectedCloseDate($id: UUID!, $expectedCloseDate: LocalDate!) {
  saveExpectedCloseDate(id: $id, expectedCloseDate: $expectedCloseDate)
}
    `;
export type SaveExpectedCloseDateMutationFn = Apollo.MutationFunction<SaveExpectedCloseDateMutation, SaveExpectedCloseDateMutationVariables>;

/**
 * __useSaveExpectedCloseDateMutation__
 *
 * To run a mutation, you first call `useSaveExpectedCloseDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveExpectedCloseDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveExpectedCloseDateMutation, { data, loading, error }] = useSaveExpectedCloseDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      expectedCloseDate: // value for 'expectedCloseDate'
 *   },
 * });
 */
export function useSaveExpectedCloseDateMutation(baseOptions?: Apollo.MutationHookOptions<SaveExpectedCloseDateMutation, SaveExpectedCloseDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveExpectedCloseDateMutation, SaveExpectedCloseDateMutationVariables>(SaveExpectedCloseDateDocument, options);
      }
export type SaveExpectedCloseDateMutationHookResult = ReturnType<typeof useSaveExpectedCloseDateMutation>;
export type SaveExpectedCloseDateMutationResult = Apollo.MutationResult<SaveExpectedCloseDateMutation>;
export type SaveExpectedCloseDateMutationOptions = Apollo.BaseMutationOptions<SaveExpectedCloseDateMutation, SaveExpectedCloseDateMutationVariables>;
export const SaveDisqualifiedReasonDocument = gql`
    mutation saveDisqualifiedReason($disqualifiedReason: DisqualifiedReasonDto!, $id: UUID!) {
  saveDisqualifiedReason(disqualifiedReason: $disqualifiedReason, id: $id)
}
    `;
export type SaveDisqualifiedReasonMutationFn = Apollo.MutationFunction<SaveDisqualifiedReasonMutation, SaveDisqualifiedReasonMutationVariables>;

/**
 * __useSaveDisqualifiedReasonMutation__
 *
 * To run a mutation, you first call `useSaveDisqualifiedReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDisqualifiedReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDisqualifiedReasonMutation, { data, loading, error }] = useSaveDisqualifiedReasonMutation({
 *   variables: {
 *      disqualifiedReason: // value for 'disqualifiedReason'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveDisqualifiedReasonMutation(baseOptions?: Apollo.MutationHookOptions<SaveDisqualifiedReasonMutation, SaveDisqualifiedReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDisqualifiedReasonMutation, SaveDisqualifiedReasonMutationVariables>(SaveDisqualifiedReasonDocument, options);
      }
export type SaveDisqualifiedReasonMutationHookResult = ReturnType<typeof useSaveDisqualifiedReasonMutation>;
export type SaveDisqualifiedReasonMutationResult = Apollo.MutationResult<SaveDisqualifiedReasonMutation>;
export type SaveDisqualifiedReasonMutationOptions = Apollo.BaseMutationOptions<SaveDisqualifiedReasonMutation, SaveDisqualifiedReasonMutationVariables>;
export const CsrCalendlyAppointmentsDocument = gql`
    query csrCalendlyAppointments($agentId: UUID!, $from: LocalDate!, $to: LocalDate!) {
  csrCalendlyAppointments(agentId: $agentId, from: $from, to: $to) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useCsrCalendlyAppointmentsQuery__
 *
 * To run a query within a React component, call `useCsrCalendlyAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCsrCalendlyAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsrCalendlyAppointmentsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCsrCalendlyAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<CsrCalendlyAppointmentsQuery, CsrCalendlyAppointmentsQueryVariables> & ({ variables: CsrCalendlyAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CsrCalendlyAppointmentsQuery, CsrCalendlyAppointmentsQueryVariables>(CsrCalendlyAppointmentsDocument, options);
      }
export function useCsrCalendlyAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CsrCalendlyAppointmentsQuery, CsrCalendlyAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CsrCalendlyAppointmentsQuery, CsrCalendlyAppointmentsQueryVariables>(CsrCalendlyAppointmentsDocument, options);
        }
export function useCsrCalendlyAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CsrCalendlyAppointmentsQuery, CsrCalendlyAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CsrCalendlyAppointmentsQuery, CsrCalendlyAppointmentsQueryVariables>(CsrCalendlyAppointmentsDocument, options);
        }
export type CsrCalendlyAppointmentsQueryHookResult = ReturnType<typeof useCsrCalendlyAppointmentsQuery>;
export type CsrCalendlyAppointmentsLazyQueryHookResult = ReturnType<typeof useCsrCalendlyAppointmentsLazyQuery>;
export type CsrCalendlyAppointmentsSuspenseQueryHookResult = ReturnType<typeof useCsrCalendlyAppointmentsSuspenseQuery>;
export type CsrCalendlyAppointmentsQueryResult = Apollo.QueryResult<CsrCalendlyAppointmentsQuery, CsrCalendlyAppointmentsQueryVariables>;
export const ClientCalendlyAppointmentsDocument = gql`
    query clientCalendlyAppointments($clientId: UUID!) {
  clientCalendlyAppointments(clientId: $clientId) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useClientCalendlyAppointmentsQuery__
 *
 * To run a query within a React component, call `useClientCalendlyAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCalendlyAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCalendlyAppointmentsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useClientCalendlyAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<ClientCalendlyAppointmentsQuery, ClientCalendlyAppointmentsQueryVariables> & ({ variables: ClientCalendlyAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientCalendlyAppointmentsQuery, ClientCalendlyAppointmentsQueryVariables>(ClientCalendlyAppointmentsDocument, options);
      }
export function useClientCalendlyAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientCalendlyAppointmentsQuery, ClientCalendlyAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientCalendlyAppointmentsQuery, ClientCalendlyAppointmentsQueryVariables>(ClientCalendlyAppointmentsDocument, options);
        }
export function useClientCalendlyAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientCalendlyAppointmentsQuery, ClientCalendlyAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientCalendlyAppointmentsQuery, ClientCalendlyAppointmentsQueryVariables>(ClientCalendlyAppointmentsDocument, options);
        }
export type ClientCalendlyAppointmentsQueryHookResult = ReturnType<typeof useClientCalendlyAppointmentsQuery>;
export type ClientCalendlyAppointmentsLazyQueryHookResult = ReturnType<typeof useClientCalendlyAppointmentsLazyQuery>;
export type ClientCalendlyAppointmentsSuspenseQueryHookResult = ReturnType<typeof useClientCalendlyAppointmentsSuspenseQuery>;
export type ClientCalendlyAppointmentsQueryResult = Apollo.QueryResult<ClientCalendlyAppointmentsQuery, ClientCalendlyAppointmentsQueryVariables>;
export const SetCalendlyAppointmentNoShowDocument = gql`
    mutation setCalendlyAppointmentNoShow($id: String!, $noShow: Boolean!) {
  setCalendlyAppointmentNoShow(id: $id, noShow: $noShow)
}
    `;
export type SetCalendlyAppointmentNoShowMutationFn = Apollo.MutationFunction<SetCalendlyAppointmentNoShowMutation, SetCalendlyAppointmentNoShowMutationVariables>;

/**
 * __useSetCalendlyAppointmentNoShowMutation__
 *
 * To run a mutation, you first call `useSetCalendlyAppointmentNoShowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCalendlyAppointmentNoShowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCalendlyAppointmentNoShowMutation, { data, loading, error }] = useSetCalendlyAppointmentNoShowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      noShow: // value for 'noShow'
 *   },
 * });
 */
export function useSetCalendlyAppointmentNoShowMutation(baseOptions?: Apollo.MutationHookOptions<SetCalendlyAppointmentNoShowMutation, SetCalendlyAppointmentNoShowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCalendlyAppointmentNoShowMutation, SetCalendlyAppointmentNoShowMutationVariables>(SetCalendlyAppointmentNoShowDocument, options);
      }
export type SetCalendlyAppointmentNoShowMutationHookResult = ReturnType<typeof useSetCalendlyAppointmentNoShowMutation>;
export type SetCalendlyAppointmentNoShowMutationResult = Apollo.MutationResult<SetCalendlyAppointmentNoShowMutation>;
export type SetCalendlyAppointmentNoShowMutationOptions = Apollo.BaseMutationOptions<SetCalendlyAppointmentNoShowMutation, SetCalendlyAppointmentNoShowMutationVariables>;
export const ChangeEnrollmentStatusDocument = gql`
    mutation changeEnrollmentStatus($enrollmentId: UUID!, $status: EnrollmentStatusInput!) {
  changeEnrollmentStatus(enrollmentId: $enrollmentId, status: $status)
}
    `;
export type ChangeEnrollmentStatusMutationFn = Apollo.MutationFunction<ChangeEnrollmentStatusMutation, ChangeEnrollmentStatusMutationVariables>;

/**
 * __useChangeEnrollmentStatusMutation__
 *
 * To run a mutation, you first call `useChangeEnrollmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEnrollmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEnrollmentStatusMutation, { data, loading, error }] = useChangeEnrollmentStatusMutation({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeEnrollmentStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEnrollmentStatusMutation, ChangeEnrollmentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEnrollmentStatusMutation, ChangeEnrollmentStatusMutationVariables>(ChangeEnrollmentStatusDocument, options);
      }
export type ChangeEnrollmentStatusMutationHookResult = ReturnType<typeof useChangeEnrollmentStatusMutation>;
export type ChangeEnrollmentStatusMutationResult = Apollo.MutationResult<ChangeEnrollmentStatusMutation>;
export type ChangeEnrollmentStatusMutationOptions = Apollo.BaseMutationOptions<ChangeEnrollmentStatusMutation, ChangeEnrollmentStatusMutationVariables>;
export const ChangeMedigapEnrollmentStatusDocument = gql`
    mutation changeMedigapEnrollmentStatus($enrollmentId: UUID!, $status: MedigapEnrollmentStatus!) {
  changeMedigapEnrollmentStatus(enrollmentId: $enrollmentId, status: $status)
}
    `;
export type ChangeMedigapEnrollmentStatusMutationFn = Apollo.MutationFunction<ChangeMedigapEnrollmentStatusMutation, ChangeMedigapEnrollmentStatusMutationVariables>;

/**
 * __useChangeMedigapEnrollmentStatusMutation__
 *
 * To run a mutation, you first call `useChangeMedigapEnrollmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMedigapEnrollmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMedigapEnrollmentStatusMutation, { data, loading, error }] = useChangeMedigapEnrollmentStatusMutation({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeMedigapEnrollmentStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMedigapEnrollmentStatusMutation, ChangeMedigapEnrollmentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMedigapEnrollmentStatusMutation, ChangeMedigapEnrollmentStatusMutationVariables>(ChangeMedigapEnrollmentStatusDocument, options);
      }
export type ChangeMedigapEnrollmentStatusMutationHookResult = ReturnType<typeof useChangeMedigapEnrollmentStatusMutation>;
export type ChangeMedigapEnrollmentStatusMutationResult = Apollo.MutationResult<ChangeMedigapEnrollmentStatusMutation>;
export type ChangeMedigapEnrollmentStatusMutationOptions = Apollo.BaseMutationOptions<ChangeMedigapEnrollmentStatusMutation, ChangeMedigapEnrollmentStatusMutationVariables>;
export const SaveMedigapEnrollmentDocument = gql`
    mutation saveMedigapEnrollment($input: MedigapEnrollmentInput!) {
  saveMedigapEnrollment(input: $input)
}
    `;
export type SaveMedigapEnrollmentMutationFn = Apollo.MutationFunction<SaveMedigapEnrollmentMutation, SaveMedigapEnrollmentMutationVariables>;

/**
 * __useSaveMedigapEnrollmentMutation__
 *
 * To run a mutation, you first call `useSaveMedigapEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMedigapEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMedigapEnrollmentMutation, { data, loading, error }] = useSaveMedigapEnrollmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMedigapEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<SaveMedigapEnrollmentMutation, SaveMedigapEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMedigapEnrollmentMutation, SaveMedigapEnrollmentMutationVariables>(SaveMedigapEnrollmentDocument, options);
      }
export type SaveMedigapEnrollmentMutationHookResult = ReturnType<typeof useSaveMedigapEnrollmentMutation>;
export type SaveMedigapEnrollmentMutationResult = Apollo.MutationResult<SaveMedigapEnrollmentMutation>;
export type SaveMedigapEnrollmentMutationOptions = Apollo.BaseMutationOptions<SaveMedigapEnrollmentMutation, SaveMedigapEnrollmentMutationVariables>;
export const DeletePdpEnrollmentDocument = gql`
    mutation deletePdpEnrollment($enrollmentId: UUID!) {
  deletePdpEnrollment(enrollmentId: $enrollmentId)
}
    `;
export type DeletePdpEnrollmentMutationFn = Apollo.MutationFunction<DeletePdpEnrollmentMutation, DeletePdpEnrollmentMutationVariables>;

/**
 * __useDeletePdpEnrollmentMutation__
 *
 * To run a mutation, you first call `useDeletePdpEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePdpEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePdpEnrollmentMutation, { data, loading, error }] = useDeletePdpEnrollmentMutation({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *   },
 * });
 */
export function useDeletePdpEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePdpEnrollmentMutation, DeletePdpEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePdpEnrollmentMutation, DeletePdpEnrollmentMutationVariables>(DeletePdpEnrollmentDocument, options);
      }
export type DeletePdpEnrollmentMutationHookResult = ReturnType<typeof useDeletePdpEnrollmentMutation>;
export type DeletePdpEnrollmentMutationResult = Apollo.MutationResult<DeletePdpEnrollmentMutation>;
export type DeletePdpEnrollmentMutationOptions = Apollo.BaseMutationOptions<DeletePdpEnrollmentMutation, DeletePdpEnrollmentMutationVariables>;
export const ChangePdpEnrollmentStatusDocument = gql`
    mutation changePdpEnrollmentStatus($enrollmentId: UUID!, $status: PdpEnrollmentStatus!) {
  changePdpEnrollmentStatus(enrollmentId: $enrollmentId, status: $status)
}
    `;
export type ChangePdpEnrollmentStatusMutationFn = Apollo.MutationFunction<ChangePdpEnrollmentStatusMutation, ChangePdpEnrollmentStatusMutationVariables>;

/**
 * __useChangePdpEnrollmentStatusMutation__
 *
 * To run a mutation, you first call `useChangePdpEnrollmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePdpEnrollmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePdpEnrollmentStatusMutation, { data, loading, error }] = useChangePdpEnrollmentStatusMutation({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangePdpEnrollmentStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangePdpEnrollmentStatusMutation, ChangePdpEnrollmentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePdpEnrollmentStatusMutation, ChangePdpEnrollmentStatusMutationVariables>(ChangePdpEnrollmentStatusDocument, options);
      }
export type ChangePdpEnrollmentStatusMutationHookResult = ReturnType<typeof useChangePdpEnrollmentStatusMutation>;
export type ChangePdpEnrollmentStatusMutationResult = Apollo.MutationResult<ChangePdpEnrollmentStatusMutation>;
export type ChangePdpEnrollmentStatusMutationOptions = Apollo.BaseMutationOptions<ChangePdpEnrollmentStatusMutation, ChangePdpEnrollmentStatusMutationVariables>;
export const AgentByContextDocument = gql`
    query agentByContext {
  agentByContext {
    consultationUrl
    email
    enabled
    enrollmentMeetingUrl
    firstName
    id
    lastName
    phone
    picUrl
    planReviewUrl
    receiveEmails
    isDefault
    isCSR
    enabledForRoundRobin
  }
}
    `;

/**
 * __useAgentByContextQuery__
 *
 * To run a query within a React component, call `useAgentByContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentByContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentByContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentByContextQuery(baseOptions?: Apollo.QueryHookOptions<AgentByContextQuery, AgentByContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentByContextQuery, AgentByContextQueryVariables>(AgentByContextDocument, options);
      }
export function useAgentByContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentByContextQuery, AgentByContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentByContextQuery, AgentByContextQueryVariables>(AgentByContextDocument, options);
        }
export function useAgentByContextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentByContextQuery, AgentByContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentByContextQuery, AgentByContextQueryVariables>(AgentByContextDocument, options);
        }
export type AgentByContextQueryHookResult = ReturnType<typeof useAgentByContextQuery>;
export type AgentByContextLazyQueryHookResult = ReturnType<typeof useAgentByContextLazyQuery>;
export type AgentByContextSuspenseQueryHookResult = ReturnType<typeof useAgentByContextSuspenseQuery>;
export type AgentByContextQueryResult = Apollo.QueryResult<AgentByContextQuery, AgentByContextQueryVariables>;
export const SaveEnrollmentDocument = gql`
    mutation saveEnrollment($input: EnrollmentInput!, $clientId: UUID, $userId: UUID) {
  saveEnrollment(input: $input, clientId: $clientId, userId: $userId)
}
    `;
export type SaveEnrollmentMutationFn = Apollo.MutationFunction<SaveEnrollmentMutation, SaveEnrollmentMutationVariables>;

/**
 * __useSaveEnrollmentMutation__
 *
 * To run a mutation, you first call `useSaveEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEnrollmentMutation, { data, loading, error }] = useSaveEnrollmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      clientId: // value for 'clientId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSaveEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<SaveEnrollmentMutation, SaveEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEnrollmentMutation, SaveEnrollmentMutationVariables>(SaveEnrollmentDocument, options);
      }
export type SaveEnrollmentMutationHookResult = ReturnType<typeof useSaveEnrollmentMutation>;
export type SaveEnrollmentMutationResult = Apollo.MutationResult<SaveEnrollmentMutation>;
export type SaveEnrollmentMutationOptions = Apollo.BaseMutationOptions<SaveEnrollmentMutation, SaveEnrollmentMutationVariables>;
export const SavePdpEnrollmentDocument = gql`
    mutation savePdpEnrollment($input: PdpEnrollmentInput!, $clientId: UUID) {
  savePdpEnrollment(input: $input, clientId: $clientId) {
    id
  }
}
    `;
export type SavePdpEnrollmentMutationFn = Apollo.MutationFunction<SavePdpEnrollmentMutation, SavePdpEnrollmentMutationVariables>;

/**
 * __useSavePdpEnrollmentMutation__
 *
 * To run a mutation, you first call `useSavePdpEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePdpEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePdpEnrollmentMutation, { data, loading, error }] = useSavePdpEnrollmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useSavePdpEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<SavePdpEnrollmentMutation, SavePdpEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePdpEnrollmentMutation, SavePdpEnrollmentMutationVariables>(SavePdpEnrollmentDocument, options);
      }
export type SavePdpEnrollmentMutationHookResult = ReturnType<typeof useSavePdpEnrollmentMutation>;
export type SavePdpEnrollmentMutationResult = Apollo.MutationResult<SavePdpEnrollmentMutation>;
export type SavePdpEnrollmentMutationOptions = Apollo.BaseMutationOptions<SavePdpEnrollmentMutation, SavePdpEnrollmentMutationVariables>;
export const DeleteMedigapEnrollmentDocument = gql`
    mutation deleteMedigapEnrollment($medigapEnrollmentId: UUID!) {
  deleteMedigapEnrollment(medigapEnrollmentId: $medigapEnrollmentId)
}
    `;
export type DeleteMedigapEnrollmentMutationFn = Apollo.MutationFunction<DeleteMedigapEnrollmentMutation, DeleteMedigapEnrollmentMutationVariables>;

/**
 * __useDeleteMedigapEnrollmentMutation__
 *
 * To run a mutation, you first call `useDeleteMedigapEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMedigapEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMedigapEnrollmentMutation, { data, loading, error }] = useDeleteMedigapEnrollmentMutation({
 *   variables: {
 *      medigapEnrollmentId: // value for 'medigapEnrollmentId'
 *   },
 * });
 */
export function useDeleteMedigapEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMedigapEnrollmentMutation, DeleteMedigapEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMedigapEnrollmentMutation, DeleteMedigapEnrollmentMutationVariables>(DeleteMedigapEnrollmentDocument, options);
      }
export type DeleteMedigapEnrollmentMutationHookResult = ReturnType<typeof useDeleteMedigapEnrollmentMutation>;
export type DeleteMedigapEnrollmentMutationResult = Apollo.MutationResult<DeleteMedigapEnrollmentMutation>;
export type DeleteMedigapEnrollmentMutationOptions = Apollo.BaseMutationOptions<DeleteMedigapEnrollmentMutation, DeleteMedigapEnrollmentMutationVariables>;
export const DeleteEnrollmentDocument = gql`
    mutation deleteEnrollment($enrollmentId: UUID!) {
  deleteEnrollment(enrollmentId: $enrollmentId)
}
    `;
export type DeleteEnrollmentMutationFn = Apollo.MutationFunction<DeleteEnrollmentMutation, DeleteEnrollmentMutationVariables>;

/**
 * __useDeleteEnrollmentMutation__
 *
 * To run a mutation, you first call `useDeleteEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnrollmentMutation, { data, loading, error }] = useDeleteEnrollmentMutation({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *   },
 * });
 */
export function useDeleteEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEnrollmentMutation, DeleteEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEnrollmentMutation, DeleteEnrollmentMutationVariables>(DeleteEnrollmentDocument, options);
      }
export type DeleteEnrollmentMutationHookResult = ReturnType<typeof useDeleteEnrollmentMutation>;
export type DeleteEnrollmentMutationResult = Apollo.MutationResult<DeleteEnrollmentMutation>;
export type DeleteEnrollmentMutationOptions = Apollo.BaseMutationOptions<DeleteEnrollmentMutation, DeleteEnrollmentMutationVariables>;
export const AllEnrollmentsDocument = gql`
    query allEnrollments($filter: AllEnrollmentsFilterInput!, $page: PageInput!) {
  allEnrollments(filter: $filter, page: $page) {
    totalElements
    data {
      age
      agentId
      approvedAt
      bidId
      birthDate
      clientId
      county
      mgPlanKey
      createdAt
      effectiveDate
      applicationDate
      firstName
      gender
      email
      id
      lastName
      mgPlanName
      planYear
      naic
      phoneNumber
      carrierName
      planName
      started
      status
      tobacco
      type
      zip
      pdpQuoteId
      enrollmentType
    }
  }
}
    `;

/**
 * __useAllEnrollmentsQuery__
 *
 * To run a query within a React component, call `useAllEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEnrollmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEnrollmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAllEnrollmentsQuery(baseOptions: Apollo.QueryHookOptions<AllEnrollmentsQuery, AllEnrollmentsQueryVariables> & ({ variables: AllEnrollmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEnrollmentsQuery, AllEnrollmentsQueryVariables>(AllEnrollmentsDocument, options);
      }
export function useAllEnrollmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEnrollmentsQuery, AllEnrollmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEnrollmentsQuery, AllEnrollmentsQueryVariables>(AllEnrollmentsDocument, options);
        }
export function useAllEnrollmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllEnrollmentsQuery, AllEnrollmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllEnrollmentsQuery, AllEnrollmentsQueryVariables>(AllEnrollmentsDocument, options);
        }
export type AllEnrollmentsQueryHookResult = ReturnType<typeof useAllEnrollmentsQuery>;
export type AllEnrollmentsLazyQueryHookResult = ReturnType<typeof useAllEnrollmentsLazyQuery>;
export type AllEnrollmentsSuspenseQueryHookResult = ReturnType<typeof useAllEnrollmentsSuspenseQuery>;
export type AllEnrollmentsQueryResult = Apollo.QueryResult<AllEnrollmentsQuery, AllEnrollmentsQueryVariables>;
export const ClientGroupByClientIdDocument = gql`
    query clientGroupByClientId($clientId: UUID!) {
  clientGroupByClientId(clientId: $clientId) {
    clients {
      clientId
      email
      firstName
      lastName
    }
    id
  }
}
    `;

/**
 * __useClientGroupByClientIdQuery__
 *
 * To run a query within a React component, call `useClientGroupByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientGroupByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientGroupByClientIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useClientGroupByClientIdQuery(baseOptions: Apollo.QueryHookOptions<ClientGroupByClientIdQuery, ClientGroupByClientIdQueryVariables> & ({ variables: ClientGroupByClientIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientGroupByClientIdQuery, ClientGroupByClientIdQueryVariables>(ClientGroupByClientIdDocument, options);
      }
export function useClientGroupByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientGroupByClientIdQuery, ClientGroupByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientGroupByClientIdQuery, ClientGroupByClientIdQueryVariables>(ClientGroupByClientIdDocument, options);
        }
export function useClientGroupByClientIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientGroupByClientIdQuery, ClientGroupByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientGroupByClientIdQuery, ClientGroupByClientIdQueryVariables>(ClientGroupByClientIdDocument, options);
        }
export type ClientGroupByClientIdQueryHookResult = ReturnType<typeof useClientGroupByClientIdQuery>;
export type ClientGroupByClientIdLazyQueryHookResult = ReturnType<typeof useClientGroupByClientIdLazyQuery>;
export type ClientGroupByClientIdSuspenseQueryHookResult = ReturnType<typeof useClientGroupByClientIdSuspenseQuery>;
export type ClientGroupByClientIdQueryResult = Apollo.QueryResult<ClientGroupByClientIdQuery, ClientGroupByClientIdQueryVariables>;
export const MergeClientsInOneGroupDocument = gql`
    mutation mergeClientsInOneGroup($clientIds: [UUID!]!) {
  mergeClientsInOneGroup(clientIds: $clientIds)
}
    `;
export type MergeClientsInOneGroupMutationFn = Apollo.MutationFunction<MergeClientsInOneGroupMutation, MergeClientsInOneGroupMutationVariables>;

/**
 * __useMergeClientsInOneGroupMutation__
 *
 * To run a mutation, you first call `useMergeClientsInOneGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeClientsInOneGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeClientsInOneGroupMutation, { data, loading, error }] = useMergeClientsInOneGroupMutation({
 *   variables: {
 *      clientIds: // value for 'clientIds'
 *   },
 * });
 */
export function useMergeClientsInOneGroupMutation(baseOptions?: Apollo.MutationHookOptions<MergeClientsInOneGroupMutation, MergeClientsInOneGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeClientsInOneGroupMutation, MergeClientsInOneGroupMutationVariables>(MergeClientsInOneGroupDocument, options);
      }
export type MergeClientsInOneGroupMutationHookResult = ReturnType<typeof useMergeClientsInOneGroupMutation>;
export type MergeClientsInOneGroupMutationResult = Apollo.MutationResult<MergeClientsInOneGroupMutation>;
export type MergeClientsInOneGroupMutationOptions = Apollo.BaseMutationOptions<MergeClientsInOneGroupMutation, MergeClientsInOneGroupMutationVariables>;
export const DeleteClientsFromAnyGroupDocument = gql`
    mutation deleteClientsFromAnyGroup($clientIds: [UUID!]!) {
  deleteClientsFromAnyGroup(clientIds: $clientIds)
}
    `;
export type DeleteClientsFromAnyGroupMutationFn = Apollo.MutationFunction<DeleteClientsFromAnyGroupMutation, DeleteClientsFromAnyGroupMutationVariables>;

/**
 * __useDeleteClientsFromAnyGroupMutation__
 *
 * To run a mutation, you first call `useDeleteClientsFromAnyGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientsFromAnyGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientsFromAnyGroupMutation, { data, loading, error }] = useDeleteClientsFromAnyGroupMutation({
 *   variables: {
 *      clientIds: // value for 'clientIds'
 *   },
 * });
 */
export function useDeleteClientsFromAnyGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientsFromAnyGroupMutation, DeleteClientsFromAnyGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientsFromAnyGroupMutation, DeleteClientsFromAnyGroupMutationVariables>(DeleteClientsFromAnyGroupDocument, options);
      }
export type DeleteClientsFromAnyGroupMutationHookResult = ReturnType<typeof useDeleteClientsFromAnyGroupMutation>;
export type DeleteClientsFromAnyGroupMutationResult = Apollo.MutationResult<DeleteClientsFromAnyGroupMutation>;
export type DeleteClientsFromAnyGroupMutationOptions = Apollo.BaseMutationOptions<DeleteClientsFromAnyGroupMutation, DeleteClientsFromAnyGroupMutationVariables>;
export const ShortenedCostActivationLinkDocument = gql`
    query shortenedCostActivationLink($clientId: UUID!) {
  shortenedCostActivationLink(clientId: $clientId)
}
    `;

/**
 * __useShortenedCostActivationLinkQuery__
 *
 * To run a query within a React component, call `useShortenedCostActivationLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortenedCostActivationLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortenedCostActivationLinkQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useShortenedCostActivationLinkQuery(baseOptions: Apollo.QueryHookOptions<ShortenedCostActivationLinkQuery, ShortenedCostActivationLinkQueryVariables> & ({ variables: ShortenedCostActivationLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShortenedCostActivationLinkQuery, ShortenedCostActivationLinkQueryVariables>(ShortenedCostActivationLinkDocument, options);
      }
export function useShortenedCostActivationLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortenedCostActivationLinkQuery, ShortenedCostActivationLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShortenedCostActivationLinkQuery, ShortenedCostActivationLinkQueryVariables>(ShortenedCostActivationLinkDocument, options);
        }
export function useShortenedCostActivationLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ShortenedCostActivationLinkQuery, ShortenedCostActivationLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShortenedCostActivationLinkQuery, ShortenedCostActivationLinkQueryVariables>(ShortenedCostActivationLinkDocument, options);
        }
export type ShortenedCostActivationLinkQueryHookResult = ReturnType<typeof useShortenedCostActivationLinkQuery>;
export type ShortenedCostActivationLinkLazyQueryHookResult = ReturnType<typeof useShortenedCostActivationLinkLazyQuery>;
export type ShortenedCostActivationLinkSuspenseQueryHookResult = ReturnType<typeof useShortenedCostActivationLinkSuspenseQuery>;
export type ShortenedCostActivationLinkQueryResult = Apollo.QueryResult<ShortenedCostActivationLinkQuery, ShortenedCostActivationLinkQueryVariables>;
export const UpdateLeadSourcesDocument = gql`
    mutation updateLeadSources($clientId: UUID!) {
  updateSources(clientId: $clientId) {
    campaign
  }
}
    `;
export type UpdateLeadSourcesMutationFn = Apollo.MutationFunction<UpdateLeadSourcesMutation, UpdateLeadSourcesMutationVariables>;

/**
 * __useUpdateLeadSourcesMutation__
 *
 * To run a mutation, you first call `useUpdateLeadSourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadSourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadSourcesMutation, { data, loading, error }] = useUpdateLeadSourcesMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useUpdateLeadSourcesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadSourcesMutation, UpdateLeadSourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadSourcesMutation, UpdateLeadSourcesMutationVariables>(UpdateLeadSourcesDocument, options);
      }
export type UpdateLeadSourcesMutationHookResult = ReturnType<typeof useUpdateLeadSourcesMutation>;
export type UpdateLeadSourcesMutationResult = Apollo.MutationResult<UpdateLeadSourcesMutation>;
export type UpdateLeadSourcesMutationOptions = Apollo.BaseMutationOptions<UpdateLeadSourcesMutation, UpdateLeadSourcesMutationVariables>;
export const ClientLeadSourcesDocument = gql`
    query clientLeadSources($clientId: UUID!) {
  clientLeadSources(clientId: $clientId) {
    campaign
    eventDate
    medium
    source
    term
    content
  }
}
    `;

/**
 * __useClientLeadSourcesQuery__
 *
 * To run a query within a React component, call `useClientLeadSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientLeadSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientLeadSourcesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useClientLeadSourcesQuery(baseOptions: Apollo.QueryHookOptions<ClientLeadSourcesQuery, ClientLeadSourcesQueryVariables> & ({ variables: ClientLeadSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientLeadSourcesQuery, ClientLeadSourcesQueryVariables>(ClientLeadSourcesDocument, options);
      }
export function useClientLeadSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientLeadSourcesQuery, ClientLeadSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientLeadSourcesQuery, ClientLeadSourcesQueryVariables>(ClientLeadSourcesDocument, options);
        }
export function useClientLeadSourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientLeadSourcesQuery, ClientLeadSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientLeadSourcesQuery, ClientLeadSourcesQueryVariables>(ClientLeadSourcesDocument, options);
        }
export type ClientLeadSourcesQueryHookResult = ReturnType<typeof useClientLeadSourcesQuery>;
export type ClientLeadSourcesLazyQueryHookResult = ReturnType<typeof useClientLeadSourcesLazyQuery>;
export type ClientLeadSourcesSuspenseQueryHookResult = ReturnType<typeof useClientLeadSourcesSuspenseQuery>;
export type ClientLeadSourcesQueryResult = Apollo.QueryResult<ClientLeadSourcesQuery, ClientLeadSourcesQueryVariables>;
export const SendComparisonEmailDocument = gql`
    mutation sendComparisonEmail($clientId: UUID!, $link: String!) {
  sendComparisonEmail(clientId: $clientId, link: $link)
}
    `;
export type SendComparisonEmailMutationFn = Apollo.MutationFunction<SendComparisonEmailMutation, SendComparisonEmailMutationVariables>;

/**
 * __useSendComparisonEmailMutation__
 *
 * To run a mutation, you first call `useSendComparisonEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendComparisonEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendComparisonEmailMutation, { data, loading, error }] = useSendComparisonEmailMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      link: // value for 'link'
 *   },
 * });
 */
export function useSendComparisonEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendComparisonEmailMutation, SendComparisonEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendComparisonEmailMutation, SendComparisonEmailMutationVariables>(SendComparisonEmailDocument, options);
      }
export type SendComparisonEmailMutationHookResult = ReturnType<typeof useSendComparisonEmailMutation>;
export type SendComparisonEmailMutationResult = Apollo.MutationResult<SendComparisonEmailMutation>;
export type SendComparisonEmailMutationOptions = Apollo.BaseMutationOptions<SendComparisonEmailMutation, SendComparisonEmailMutationVariables>;
export const DeleteEmailTemplateDocument = gql`
    mutation deleteEmailTemplate($id: UUID!) {
  deleteEmailTemplate(id: $id)
}
    `;
export type DeleteEmailTemplateMutationFn = Apollo.MutationFunction<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;

/**
 * __useDeleteEmailTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmailTemplateMutation, { data, loading, error }] = useDeleteEmailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>(DeleteEmailTemplateDocument, options);
      }
export type DeleteEmailTemplateMutationHookResult = ReturnType<typeof useDeleteEmailTemplateMutation>;
export type DeleteEmailTemplateMutationResult = Apollo.MutationResult<DeleteEmailTemplateMutation>;
export type DeleteEmailTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;
export const SaveEmailTemplateDocument = gql`
    mutation saveEmailTemplate($emailTemplate: EmailTemplateDtoInput!) {
  saveEmailTemplate(emailTemplate: $emailTemplate)
}
    `;
export type SaveEmailTemplateMutationFn = Apollo.MutationFunction<SaveEmailTemplateMutation, SaveEmailTemplateMutationVariables>;

/**
 * __useSaveEmailTemplateMutation__
 *
 * To run a mutation, you first call `useSaveEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEmailTemplateMutation, { data, loading, error }] = useSaveEmailTemplateMutation({
 *   variables: {
 *      emailTemplate: // value for 'emailTemplate'
 *   },
 * });
 */
export function useSaveEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveEmailTemplateMutation, SaveEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEmailTemplateMutation, SaveEmailTemplateMutationVariables>(SaveEmailTemplateDocument, options);
      }
export type SaveEmailTemplateMutationHookResult = ReturnType<typeof useSaveEmailTemplateMutation>;
export type SaveEmailTemplateMutationResult = Apollo.MutationResult<SaveEmailTemplateMutation>;
export type SaveEmailTemplateMutationOptions = Apollo.BaseMutationOptions<SaveEmailTemplateMutation, SaveEmailTemplateMutationVariables>;
export const EmailTemplateDocument = gql`
    query emailTemplate($id: UUID!) {
  emailTemplate(id: $id) {
    title
    template
    id
  }
}
    `;

/**
 * __useEmailTemplateQuery__
 *
 * To run a query within a React component, call `useEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<EmailTemplateQuery, EmailTemplateQueryVariables> & ({ variables: EmailTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailTemplateQuery, EmailTemplateQueryVariables>(EmailTemplateDocument, options);
      }
export function useEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailTemplateQuery, EmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailTemplateQuery, EmailTemplateQueryVariables>(EmailTemplateDocument, options);
        }
export function useEmailTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailTemplateQuery, EmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailTemplateQuery, EmailTemplateQueryVariables>(EmailTemplateDocument, options);
        }
export type EmailTemplateQueryHookResult = ReturnType<typeof useEmailTemplateQuery>;
export type EmailTemplateLazyQueryHookResult = ReturnType<typeof useEmailTemplateLazyQuery>;
export type EmailTemplateSuspenseQueryHookResult = ReturnType<typeof useEmailTemplateSuspenseQuery>;
export type EmailTemplateQueryResult = Apollo.QueryResult<EmailTemplateQuery, EmailTemplateQueryVariables>;
export const EmailTemplatesDocument = gql`
    query emailTemplates($pageInput: PageInput!) {
  emailTemplates(pageInput: $pageInput) {
    totalElements
    data {
      id
      template
      title
    }
  }
}
    `;

/**
 * __useEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailTemplatesQuery({
 *   variables: {
 *      pageInput: // value for 'pageInput'
 *   },
 * });
 */
export function useEmailTemplatesQuery(baseOptions: Apollo.QueryHookOptions<EmailTemplatesQuery, EmailTemplatesQueryVariables> & ({ variables: EmailTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailTemplatesQuery, EmailTemplatesQueryVariables>(EmailTemplatesDocument, options);
      }
export function useEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailTemplatesQuery, EmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailTemplatesQuery, EmailTemplatesQueryVariables>(EmailTemplatesDocument, options);
        }
export function useEmailTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailTemplatesQuery, EmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailTemplatesQuery, EmailTemplatesQueryVariables>(EmailTemplatesDocument, options);
        }
export type EmailTemplatesQueryHookResult = ReturnType<typeof useEmailTemplatesQuery>;
export type EmailTemplatesLazyQueryHookResult = ReturnType<typeof useEmailTemplatesLazyQuery>;
export type EmailTemplatesSuspenseQueryHookResult = ReturnType<typeof useEmailTemplatesSuspenseQuery>;
export type EmailTemplatesQueryResult = Apollo.QueryResult<EmailTemplatesQuery, EmailTemplatesQueryVariables>;
export const SaveUserProfileDocument = gql`
    mutation saveUserProfile($data: UserProfileInput!) {
  saveUserProfile(input: $data) {
    enrollmentId
    profileId
    userId
    clientId
    userToken {
      accessToken
      idToken
      refreshToken
    }
  }
}
    `;
export type SaveUserProfileMutationFn = Apollo.MutationFunction<SaveUserProfileMutation, SaveUserProfileMutationVariables>;

/**
 * __useSaveUserProfileMutation__
 *
 * To run a mutation, you first call `useSaveUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserProfileMutation, { data, loading, error }] = useSaveUserProfileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserProfileMutation, SaveUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserProfileMutation, SaveUserProfileMutationVariables>(SaveUserProfileDocument, options);
      }
export type SaveUserProfileMutationHookResult = ReturnType<typeof useSaveUserProfileMutation>;
export type SaveUserProfileMutationResult = Apollo.MutationResult<SaveUserProfileMutation>;
export type SaveUserProfileMutationOptions = Apollo.BaseMutationOptions<SaveUserProfileMutation, SaveUserProfileMutationVariables>;
export const SaveCallHistoryDocument = gql`
    mutation saveCallHistory($input: CallHistoryInput!) {
  saveCallHistory(input: $input)
}
    `;
export type SaveCallHistoryMutationFn = Apollo.MutationFunction<SaveCallHistoryMutation, SaveCallHistoryMutationVariables>;

/**
 * __useSaveCallHistoryMutation__
 *
 * To run a mutation, you first call `useSaveCallHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCallHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCallHistoryMutation, { data, loading, error }] = useSaveCallHistoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCallHistoryMutation(baseOptions?: Apollo.MutationHookOptions<SaveCallHistoryMutation, SaveCallHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCallHistoryMutation, SaveCallHistoryMutationVariables>(SaveCallHistoryDocument, options);
      }
export type SaveCallHistoryMutationHookResult = ReturnType<typeof useSaveCallHistoryMutation>;
export type SaveCallHistoryMutationResult = Apollo.MutationResult<SaveCallHistoryMutation>;
export type SaveCallHistoryMutationOptions = Apollo.BaseMutationOptions<SaveCallHistoryMutation, SaveCallHistoryMutationVariables>;
export const CallHistoryAiAnalysisDocument = gql`
    query callHistoryAIAnalysis($callHistory: UUID!) {
  callHistoryAIAnalysis(callHistory: $callHistory) {
    aiAnalysis
    airCallTimeline
    callHistoryId
  }
}
    `;

/**
 * __useCallHistoryAiAnalysisQuery__
 *
 * To run a query within a React component, call `useCallHistoryAiAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallHistoryAiAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallHistoryAiAnalysisQuery({
 *   variables: {
 *      callHistory: // value for 'callHistory'
 *   },
 * });
 */
export function useCallHistoryAiAnalysisQuery(baseOptions: Apollo.QueryHookOptions<CallHistoryAiAnalysisQuery, CallHistoryAiAnalysisQueryVariables> & ({ variables: CallHistoryAiAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallHistoryAiAnalysisQuery, CallHistoryAiAnalysisQueryVariables>(CallHistoryAiAnalysisDocument, options);
      }
export function useCallHistoryAiAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallHistoryAiAnalysisQuery, CallHistoryAiAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallHistoryAiAnalysisQuery, CallHistoryAiAnalysisQueryVariables>(CallHistoryAiAnalysisDocument, options);
        }
export function useCallHistoryAiAnalysisSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CallHistoryAiAnalysisQuery, CallHistoryAiAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallHistoryAiAnalysisQuery, CallHistoryAiAnalysisQueryVariables>(CallHistoryAiAnalysisDocument, options);
        }
export type CallHistoryAiAnalysisQueryHookResult = ReturnType<typeof useCallHistoryAiAnalysisQuery>;
export type CallHistoryAiAnalysisLazyQueryHookResult = ReturnType<typeof useCallHistoryAiAnalysisLazyQuery>;
export type CallHistoryAiAnalysisSuspenseQueryHookResult = ReturnType<typeof useCallHistoryAiAnalysisSuspenseQuery>;
export type CallHistoryAiAnalysisQueryResult = Apollo.QueryResult<CallHistoryAiAnalysisQuery, CallHistoryAiAnalysisQueryVariables>;
export const CallHistoryItemsDocument = gql`
    query callHistoryItems($clientId: UUID!, $page: PageInput!) {
  callHistoryItems(clientId: $clientId, page: $page) {
    data {
      ...CallHistoryFields
    }
    totalElements
  }
}
    ${CallHistoryFieldsFragmentDoc}`;

/**
 * __useCallHistoryItemsQuery__
 *
 * To run a query within a React component, call `useCallHistoryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallHistoryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallHistoryItemsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCallHistoryItemsQuery(baseOptions: Apollo.QueryHookOptions<CallHistoryItemsQuery, CallHistoryItemsQueryVariables> & ({ variables: CallHistoryItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallHistoryItemsQuery, CallHistoryItemsQueryVariables>(CallHistoryItemsDocument, options);
      }
export function useCallHistoryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallHistoryItemsQuery, CallHistoryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallHistoryItemsQuery, CallHistoryItemsQueryVariables>(CallHistoryItemsDocument, options);
        }
export function useCallHistoryItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CallHistoryItemsQuery, CallHistoryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallHistoryItemsQuery, CallHistoryItemsQueryVariables>(CallHistoryItemsDocument, options);
        }
export type CallHistoryItemsQueryHookResult = ReturnType<typeof useCallHistoryItemsQuery>;
export type CallHistoryItemsLazyQueryHookResult = ReturnType<typeof useCallHistoryItemsLazyQuery>;
export type CallHistoryItemsSuspenseQueryHookResult = ReturnType<typeof useCallHistoryItemsSuspenseQuery>;
export type CallHistoryItemsQueryResult = Apollo.QueryResult<CallHistoryItemsQuery, CallHistoryItemsQueryVariables>;
export const CallHistoryByAirCallIdDocument = gql`
    query callHistoryByAirCallId($airCallId: Long!) {
  callHistoryByAirCallId(airCallId: $airCallId) {
    ...CallHistoryFields
  }
}
    ${CallHistoryFieldsFragmentDoc}`;

/**
 * __useCallHistoryByAirCallIdQuery__
 *
 * To run a query within a React component, call `useCallHistoryByAirCallIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallHistoryByAirCallIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallHistoryByAirCallIdQuery({
 *   variables: {
 *      airCallId: // value for 'airCallId'
 *   },
 * });
 */
export function useCallHistoryByAirCallIdQuery(baseOptions: Apollo.QueryHookOptions<CallHistoryByAirCallIdQuery, CallHistoryByAirCallIdQueryVariables> & ({ variables: CallHistoryByAirCallIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallHistoryByAirCallIdQuery, CallHistoryByAirCallIdQueryVariables>(CallHistoryByAirCallIdDocument, options);
      }
export function useCallHistoryByAirCallIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallHistoryByAirCallIdQuery, CallHistoryByAirCallIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallHistoryByAirCallIdQuery, CallHistoryByAirCallIdQueryVariables>(CallHistoryByAirCallIdDocument, options);
        }
export function useCallHistoryByAirCallIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CallHistoryByAirCallIdQuery, CallHistoryByAirCallIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CallHistoryByAirCallIdQuery, CallHistoryByAirCallIdQueryVariables>(CallHistoryByAirCallIdDocument, options);
        }
export type CallHistoryByAirCallIdQueryHookResult = ReturnType<typeof useCallHistoryByAirCallIdQuery>;
export type CallHistoryByAirCallIdLazyQueryHookResult = ReturnType<typeof useCallHistoryByAirCallIdLazyQuery>;
export type CallHistoryByAirCallIdSuspenseQueryHookResult = ReturnType<typeof useCallHistoryByAirCallIdSuspenseQuery>;
export type CallHistoryByAirCallIdQueryResult = Apollo.QueryResult<CallHistoryByAirCallIdQuery, CallHistoryByAirCallIdQueryVariables>;
export const EditQaReviewDocument = gql`
    mutation editQaReview($airCallId: Long!, $overriddenScore: Int, $editedAuditSheet: String, $note: String) {
  editQaReview(
    airCallId: $airCallId
    overriddenScore: $overriddenScore
    editedAuditSheet: $editedAuditSheet
    note: $note
  ) {
    ...CallQaFields
  }
}
    ${CallQaFieldsFragmentDoc}`;
export type EditQaReviewMutationFn = Apollo.MutationFunction<EditQaReviewMutation, EditQaReviewMutationVariables>;

/**
 * __useEditQaReviewMutation__
 *
 * To run a mutation, you first call `useEditQaReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditQaReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editQaReviewMutation, { data, loading, error }] = useEditQaReviewMutation({
 *   variables: {
 *      airCallId: // value for 'airCallId'
 *      overriddenScore: // value for 'overriddenScore'
 *      editedAuditSheet: // value for 'editedAuditSheet'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useEditQaReviewMutation(baseOptions?: Apollo.MutationHookOptions<EditQaReviewMutation, EditQaReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditQaReviewMutation, EditQaReviewMutationVariables>(EditQaReviewDocument, options);
      }
export type EditQaReviewMutationHookResult = ReturnType<typeof useEditQaReviewMutation>;
export type EditQaReviewMutationResult = Apollo.MutationResult<EditQaReviewMutation>;
export type EditQaReviewMutationOptions = Apollo.BaseMutationOptions<EditQaReviewMutation, EditQaReviewMutationVariables>;
export const QaByAgentDocument = gql`
    query qaByAgent($agentId: UUID!, $filter: CallQaFilterInput) {
  qaByAgent(agentId: $agentId, filter: $filter) {
    ...AgentQaReportFields
  }
}
    ${AgentQaReportFieldsFragmentDoc}`;

/**
 * __useQaByAgentQuery__
 *
 * To run a query within a React component, call `useQaByAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useQaByAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQaByAgentQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useQaByAgentQuery(baseOptions: Apollo.QueryHookOptions<QaByAgentQuery, QaByAgentQueryVariables> & ({ variables: QaByAgentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QaByAgentQuery, QaByAgentQueryVariables>(QaByAgentDocument, options);
      }
export function useQaByAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QaByAgentQuery, QaByAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QaByAgentQuery, QaByAgentQueryVariables>(QaByAgentDocument, options);
        }
export function useQaByAgentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QaByAgentQuery, QaByAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QaByAgentQuery, QaByAgentQueryVariables>(QaByAgentDocument, options);
        }
export type QaByAgentQueryHookResult = ReturnType<typeof useQaByAgentQuery>;
export type QaByAgentLazyQueryHookResult = ReturnType<typeof useQaByAgentLazyQuery>;
export type QaByAgentSuspenseQueryHookResult = ReturnType<typeof useQaByAgentSuspenseQuery>;
export type QaByAgentQueryResult = Apollo.QueryResult<QaByAgentQuery, QaByAgentQueryVariables>;
export const QaAgentReportsDocument = gql`
    query qaAgentReports($filter: CallQaFilterInput) {
  qaAgentReports(filter: $filter) {
    ...AgentQaReportFields
  }
}
    ${AgentQaReportFieldsFragmentDoc}`;

/**
 * __useQaAgentReportsQuery__
 *
 * To run a query within a React component, call `useQaAgentReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQaAgentReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQaAgentReportsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useQaAgentReportsQuery(baseOptions?: Apollo.QueryHookOptions<QaAgentReportsQuery, QaAgentReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QaAgentReportsQuery, QaAgentReportsQueryVariables>(QaAgentReportsDocument, options);
      }
export function useQaAgentReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QaAgentReportsQuery, QaAgentReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QaAgentReportsQuery, QaAgentReportsQueryVariables>(QaAgentReportsDocument, options);
        }
export function useQaAgentReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QaAgentReportsQuery, QaAgentReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QaAgentReportsQuery, QaAgentReportsQueryVariables>(QaAgentReportsDocument, options);
        }
export type QaAgentReportsQueryHookResult = ReturnType<typeof useQaAgentReportsQuery>;
export type QaAgentReportsLazyQueryHookResult = ReturnType<typeof useQaAgentReportsLazyQuery>;
export type QaAgentReportsSuspenseQueryHookResult = ReturnType<typeof useQaAgentReportsSuspenseQuery>;
export type QaAgentReportsQueryResult = Apollo.QueryResult<QaAgentReportsQuery, QaAgentReportsQueryVariables>;
export const QaCompareDocument = gql`
    query qaCompare($groups: [QaCompareGroupInput!]!, $filter: CallQaFilterInput) {
  qaCompare(groups: $groups, filter: $filter) {
    groups {
      label
      report {
        summary {
          averageScore
          callsScored
        }
      }
    }
    comparison {
      scoreDelta
      categoryDeltas {
        category
        groupA
        groupB
        delta
      }
      questionDeltas {
        questionId
        groupAFailRate
        groupBFailRate
        delta
      }
    }
  }
}
    `;

/**
 * __useQaCompareQuery__
 *
 * To run a query within a React component, call `useQaCompareQuery` and pass it any options that fit your needs.
 * When your component renders, `useQaCompareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQaCompareQuery({
 *   variables: {
 *      groups: // value for 'groups'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useQaCompareQuery(baseOptions: Apollo.QueryHookOptions<QaCompareQuery, QaCompareQueryVariables> & ({ variables: QaCompareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QaCompareQuery, QaCompareQueryVariables>(QaCompareDocument, options);
      }
export function useQaCompareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QaCompareQuery, QaCompareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QaCompareQuery, QaCompareQueryVariables>(QaCompareDocument, options);
        }
export function useQaCompareSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QaCompareQuery, QaCompareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QaCompareQuery, QaCompareQueryVariables>(QaCompareDocument, options);
        }
export type QaCompareQueryHookResult = ReturnType<typeof useQaCompareQuery>;
export type QaCompareLazyQueryHookResult = ReturnType<typeof useQaCompareLazyQuery>;
export type QaCompareSuspenseQueryHookResult = ReturnType<typeof useQaCompareSuspenseQuery>;
export type QaCompareQueryResult = Apollo.QueryResult<QaCompareQuery, QaCompareQueryVariables>;
export const QaQuestionPerformanceDocument = gql`
    query qaQuestionPerformance($questionId: String!, $filter: CallQaFilterInput) {
  qaQuestionPerformance(questionId: $questionId, filter: $filter) {
    questionId
    failRate
    pointsLost
    totalApplicable
    excludedNA
    trend {
      periodStart
      averageScore
      callsScored
    }
    perAgent {
      agentId
      agentName
      failRate
    }
  }
}
    `;

/**
 * __useQaQuestionPerformanceQuery__
 *
 * To run a query within a React component, call `useQaQuestionPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useQaQuestionPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQaQuestionPerformanceQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useQaQuestionPerformanceQuery(baseOptions: Apollo.QueryHookOptions<QaQuestionPerformanceQuery, QaQuestionPerformanceQueryVariables> & ({ variables: QaQuestionPerformanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QaQuestionPerformanceQuery, QaQuestionPerformanceQueryVariables>(QaQuestionPerformanceDocument, options);
      }
export function useQaQuestionPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QaQuestionPerformanceQuery, QaQuestionPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QaQuestionPerformanceQuery, QaQuestionPerformanceQueryVariables>(QaQuestionPerformanceDocument, options);
        }
export function useQaQuestionPerformanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QaQuestionPerformanceQuery, QaQuestionPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QaQuestionPerformanceQuery, QaQuestionPerformanceQueryVariables>(QaQuestionPerformanceDocument, options);
        }
export type QaQuestionPerformanceQueryHookResult = ReturnType<typeof useQaQuestionPerformanceQuery>;
export type QaQuestionPerformanceLazyQueryHookResult = ReturnType<typeof useQaQuestionPerformanceLazyQuery>;
export type QaQuestionPerformanceSuspenseQueryHookResult = ReturnType<typeof useQaQuestionPerformanceSuspenseQuery>;
export type QaQuestionPerformanceQueryResult = Apollo.QueryResult<QaQuestionPerformanceQuery, QaQuestionPerformanceQueryVariables>;
export const QaAuditsDocument = gql`
    query qaAudits($filter: CallQaFilterInput, $page: PageInput!) {
  qaAudits(filter: $filter, page: $page) {
    data {
      ...QaCallRowFields
    }
    totalPages
    totalElements
    number
    size
    isFirst
    isLast
    hasNext
    hasPrevious
  }
}
    ${QaCallRowFieldsFragmentDoc}`;

/**
 * __useQaAuditsQuery__
 *
 * To run a query within a React component, call `useQaAuditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQaAuditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQaAuditsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useQaAuditsQuery(baseOptions: Apollo.QueryHookOptions<QaAuditsQuery, QaAuditsQueryVariables> & ({ variables: QaAuditsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QaAuditsQuery, QaAuditsQueryVariables>(QaAuditsDocument, options);
      }
export function useQaAuditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QaAuditsQuery, QaAuditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QaAuditsQuery, QaAuditsQueryVariables>(QaAuditsDocument, options);
        }
export function useQaAuditsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QaAuditsQuery, QaAuditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QaAuditsQuery, QaAuditsQueryVariables>(QaAuditsDocument, options);
        }
export type QaAuditsQueryHookResult = ReturnType<typeof useQaAuditsQuery>;
export type QaAuditsLazyQueryHookResult = ReturnType<typeof useQaAuditsLazyQuery>;
export type QaAuditsSuspenseQueryHookResult = ReturnType<typeof useQaAuditsSuspenseQuery>;
export type QaAuditsQueryResult = Apollo.QueryResult<QaAuditsQuery, QaAuditsQueryVariables>;
export const QaByClientDocument = gql`
    query qaByClient($clientId: UUID!, $filter: CallQaFilterInput) {
  qaByClient(clientId: $clientId, filter: $filter) {
    calls {
      ...QaCallRowFields
    }
    aggregate {
      ...AgentQaReportFields
    }
  }
}
    ${QaCallRowFieldsFragmentDoc}
${AgentQaReportFieldsFragmentDoc}`;

/**
 * __useQaByClientQuery__
 *
 * To run a query within a React component, call `useQaByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useQaByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQaByClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useQaByClientQuery(baseOptions: Apollo.QueryHookOptions<QaByClientQuery, QaByClientQueryVariables> & ({ variables: QaByClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QaByClientQuery, QaByClientQueryVariables>(QaByClientDocument, options);
      }
export function useQaByClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QaByClientQuery, QaByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QaByClientQuery, QaByClientQueryVariables>(QaByClientDocument, options);
        }
export function useQaByClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QaByClientQuery, QaByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QaByClientQuery, QaByClientQueryVariables>(QaByClientDocument, options);
        }
export type QaByClientQueryHookResult = ReturnType<typeof useQaByClientQuery>;
export type QaByClientLazyQueryHookResult = ReturnType<typeof useQaByClientLazyQuery>;
export type QaByClientSuspenseQueryHookResult = ReturnType<typeof useQaByClientSuspenseQuery>;
export type QaByClientQueryResult = Apollo.QueryResult<QaByClientQuery, QaByClientQueryVariables>;
export const ClientViewByIdDocument = gql`
    query clientViewById($id: UUID!) {
  clientViewById(id: $id) {
    ...ClientViewOutputFields
  }
}
    ${ClientViewOutputFieldsFragmentDoc}`;

/**
 * __useClientViewByIdQuery__
 *
 * To run a query within a React component, call `useClientViewByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientViewByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientViewByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientViewByIdQuery(baseOptions: Apollo.QueryHookOptions<ClientViewByIdQuery, ClientViewByIdQueryVariables> & ({ variables: ClientViewByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientViewByIdQuery, ClientViewByIdQueryVariables>(ClientViewByIdDocument, options);
      }
export function useClientViewByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientViewByIdQuery, ClientViewByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientViewByIdQuery, ClientViewByIdQueryVariables>(ClientViewByIdDocument, options);
        }
export function useClientViewByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientViewByIdQuery, ClientViewByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientViewByIdQuery, ClientViewByIdQueryVariables>(ClientViewByIdDocument, options);
        }
export type ClientViewByIdQueryHookResult = ReturnType<typeof useClientViewByIdQuery>;
export type ClientViewByIdLazyQueryHookResult = ReturnType<typeof useClientViewByIdLazyQuery>;
export type ClientViewByIdSuspenseQueryHookResult = ReturnType<typeof useClientViewByIdSuspenseQuery>;
export type ClientViewByIdQueryResult = Apollo.QueryResult<ClientViewByIdQuery, ClientViewByIdQueryVariables>;
export const ClientCardDocument = gql`
    subscription clientCard($id: UUID!) {
  clientCard(data: {clientId: $id}) {
    ...ClientViewOutputFields
  }
}
    ${ClientViewOutputFieldsFragmentDoc}`;

/**
 * __useClientCardSubscription__
 *
 * To run a query within a React component, call `useClientCardSubscription` and pass it any options that fit your needs.
 * When your component renders, `useClientCardSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCardSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientCardSubscription(baseOptions: Apollo.SubscriptionHookOptions<ClientCardSubscription, ClientCardSubscriptionVariables> & ({ variables: ClientCardSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ClientCardSubscription, ClientCardSubscriptionVariables>(ClientCardDocument, options);
      }
export type ClientCardSubscriptionHookResult = ReturnType<typeof useClientCardSubscription>;
export type ClientCardSubscriptionResult = Apollo.SubscriptionResult<ClientCardSubscription>;
export const AffiliationPartnershipsDocument = gql`
    query affiliationPartnerships {
  affiliationPartnerships {
    campaign
    source
  }
}
    `;

/**
 * __useAffiliationPartnershipsQuery__
 *
 * To run a query within a React component, call `useAffiliationPartnershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliationPartnershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliationPartnershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAffiliationPartnershipsQuery(baseOptions?: Apollo.QueryHookOptions<AffiliationPartnershipsQuery, AffiliationPartnershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliationPartnershipsQuery, AffiliationPartnershipsQueryVariables>(AffiliationPartnershipsDocument, options);
      }
export function useAffiliationPartnershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliationPartnershipsQuery, AffiliationPartnershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliationPartnershipsQuery, AffiliationPartnershipsQueryVariables>(AffiliationPartnershipsDocument, options);
        }
export function useAffiliationPartnershipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AffiliationPartnershipsQuery, AffiliationPartnershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliationPartnershipsQuery, AffiliationPartnershipsQueryVariables>(AffiliationPartnershipsDocument, options);
        }
export type AffiliationPartnershipsQueryHookResult = ReturnType<typeof useAffiliationPartnershipsQuery>;
export type AffiliationPartnershipsLazyQueryHookResult = ReturnType<typeof useAffiliationPartnershipsLazyQuery>;
export type AffiliationPartnershipsSuspenseQueryHookResult = ReturnType<typeof useAffiliationPartnershipsSuspenseQuery>;
export type AffiliationPartnershipsQueryResult = Apollo.QueryResult<AffiliationPartnershipsQuery, AffiliationPartnershipsQueryVariables>;
export const ClientListDocument = gql`
    query clientList($pageInput: PageInput!, $filterInput: ClientViewFilterInput, $sort: ClientViewSortInput) {
  clientViews(pageInput: $pageInput, filterInput: $filterInput, sort: $sort) {
    totalPages
    totalElements
    data {
      ...ClientListFields
    }
  }
}
    ${ClientListFieldsFragmentDoc}`;

/**
 * __useClientListQuery__
 *
 * To run a query within a React component, call `useClientListQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientListQuery({
 *   variables: {
 *      pageInput: // value for 'pageInput'
 *      filterInput: // value for 'filterInput'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useClientListQuery(baseOptions: Apollo.QueryHookOptions<ClientListQuery, ClientListQueryVariables> & ({ variables: ClientListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientListQuery, ClientListQueryVariables>(ClientListDocument, options);
      }
export function useClientListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientListQuery, ClientListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientListQuery, ClientListQueryVariables>(ClientListDocument, options);
        }
export function useClientListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientListQuery, ClientListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientListQuery, ClientListQueryVariables>(ClientListDocument, options);
        }
export type ClientListQueryHookResult = ReturnType<typeof useClientListQuery>;
export type ClientListLazyQueryHookResult = ReturnType<typeof useClientListLazyQuery>;
export type ClientListSuspenseQueryHookResult = ReturnType<typeof useClientListSuspenseQuery>;
export type ClientListQueryResult = Apollo.QueryResult<ClientListQuery, ClientListQueryVariables>;
export const FollowUpsDocument = gql`
    query followUps($agentId: UUID!, $pageInput: PageInput!, $excludedTagsIds: [UUID!], $includedTagsIds: [UUID!], $searchTerm: String, $sort: ClientViewSortInput) {
  followUps(
    agentId: $agentId
    pageInput: $pageInput
    includedTagsIds: $includedTagsIds
    excludedTagsIds: $excludedTagsIds
    searchTerm: $searchTerm
    sort: $sort
  ) {
    totalPages
    totalElements
    data {
      ...ClientListFields
    }
  }
}
    ${ClientListFieldsFragmentDoc}`;

/**
 * __useFollowUpsQuery__
 *
 * To run a query within a React component, call `useFollowUpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowUpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowUpsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      pageInput: // value for 'pageInput'
 *      excludedTagsIds: // value for 'excludedTagsIds'
 *      includedTagsIds: // value for 'includedTagsIds'
 *      searchTerm: // value for 'searchTerm'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFollowUpsQuery(baseOptions: Apollo.QueryHookOptions<FollowUpsQuery, FollowUpsQueryVariables> & ({ variables: FollowUpsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowUpsQuery, FollowUpsQueryVariables>(FollowUpsDocument, options);
      }
export function useFollowUpsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowUpsQuery, FollowUpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowUpsQuery, FollowUpsQueryVariables>(FollowUpsDocument, options);
        }
export function useFollowUpsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FollowUpsQuery, FollowUpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FollowUpsQuery, FollowUpsQueryVariables>(FollowUpsDocument, options);
        }
export type FollowUpsQueryHookResult = ReturnType<typeof useFollowUpsQuery>;
export type FollowUpsLazyQueryHookResult = ReturnType<typeof useFollowUpsLazyQuery>;
export type FollowUpsSuspenseQueryHookResult = ReturnType<typeof useFollowUpsSuspenseQuery>;
export type FollowUpsQueryResult = Apollo.QueryResult<FollowUpsQuery, FollowUpsQueryVariables>;
export const FollowUpsFutureDocument = gql`
    query followUpsFuture($agentId: UUID!, $pageInput: PageInput!, $excludedTagsIds: [UUID!], $includedTagsIds: [UUID!], $searchTerm: String, $sort: ClientViewSortInput) {
  followUpsFuture(
    agentId: $agentId
    pageInput: $pageInput
    includedTagsIds: $includedTagsIds
    excludedTagsIds: $excludedTagsIds
    searchTerm: $searchTerm
    sort: $sort
  ) {
    totalPages
    totalElements
    data {
      ...ClientListFields
    }
  }
}
    ${ClientListFieldsFragmentDoc}`;

/**
 * __useFollowUpsFutureQuery__
 *
 * To run a query within a React component, call `useFollowUpsFutureQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowUpsFutureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowUpsFutureQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      pageInput: // value for 'pageInput'
 *      excludedTagsIds: // value for 'excludedTagsIds'
 *      includedTagsIds: // value for 'includedTagsIds'
 *      searchTerm: // value for 'searchTerm'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFollowUpsFutureQuery(baseOptions: Apollo.QueryHookOptions<FollowUpsFutureQuery, FollowUpsFutureQueryVariables> & ({ variables: FollowUpsFutureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowUpsFutureQuery, FollowUpsFutureQueryVariables>(FollowUpsFutureDocument, options);
      }
export function useFollowUpsFutureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowUpsFutureQuery, FollowUpsFutureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowUpsFutureQuery, FollowUpsFutureQueryVariables>(FollowUpsFutureDocument, options);
        }
export function useFollowUpsFutureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FollowUpsFutureQuery, FollowUpsFutureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FollowUpsFutureQuery, FollowUpsFutureQueryVariables>(FollowUpsFutureDocument, options);
        }
export type FollowUpsFutureQueryHookResult = ReturnType<typeof useFollowUpsFutureQuery>;
export type FollowUpsFutureLazyQueryHookResult = ReturnType<typeof useFollowUpsFutureLazyQuery>;
export type FollowUpsFutureSuspenseQueryHookResult = ReturnType<typeof useFollowUpsFutureSuspenseQuery>;
export type FollowUpsFutureQueryResult = Apollo.QueryResult<FollowUpsFutureQuery, FollowUpsFutureQueryVariables>;
export const SalesQualifiedDocument = gql`
    query salesQualified($agentId: UUID!, $pageInput: PageInput!, $excludedTagsIds: [UUID!], $includedTagsIds: [UUID!], $searchTerm: String, $sort: ClientViewSortInput) {
  salesQualified(
    agentId: $agentId
    pageInput: $pageInput
    includedTagsIds: $includedTagsIds
    excludedTagsIds: $excludedTagsIds
    searchTerm: $searchTerm
    sort: $sort
  ) {
    totalPages
    totalElements
    data {
      ...ClientListFields
    }
  }
}
    ${ClientListFieldsFragmentDoc}`;

/**
 * __useSalesQualifiedQuery__
 *
 * To run a query within a React component, call `useSalesQualifiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesQualifiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesQualifiedQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      pageInput: // value for 'pageInput'
 *      excludedTagsIds: // value for 'excludedTagsIds'
 *      includedTagsIds: // value for 'includedTagsIds'
 *      searchTerm: // value for 'searchTerm'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSalesQualifiedQuery(baseOptions: Apollo.QueryHookOptions<SalesQualifiedQuery, SalesQualifiedQueryVariables> & ({ variables: SalesQualifiedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesQualifiedQuery, SalesQualifiedQueryVariables>(SalesQualifiedDocument, options);
      }
export function useSalesQualifiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesQualifiedQuery, SalesQualifiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesQualifiedQuery, SalesQualifiedQueryVariables>(SalesQualifiedDocument, options);
        }
export function useSalesQualifiedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SalesQualifiedQuery, SalesQualifiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SalesQualifiedQuery, SalesQualifiedQueryVariables>(SalesQualifiedDocument, options);
        }
export type SalesQualifiedQueryHookResult = ReturnType<typeof useSalesQualifiedQuery>;
export type SalesQualifiedLazyQueryHookResult = ReturnType<typeof useSalesQualifiedLazyQuery>;
export type SalesQualifiedSuspenseQueryHookResult = ReturnType<typeof useSalesQualifiedSuspenseQuery>;
export type SalesQualifiedQueryResult = Apollo.QueryResult<SalesQualifiedQuery, SalesQualifiedQueryVariables>;
export const SalesQualifiedFutureDocument = gql`
    query salesQualifiedFuture($agentId: UUID!, $pageInput: PageInput!, $excludedTagsIds: [UUID!], $includedTagsIds: [UUID!], $searchTerm: String, $sort: ClientViewSortInput) {
  salesQualifiedFuture(
    agentId: $agentId
    pageInput: $pageInput
    includedTagsIds: $includedTagsIds
    excludedTagsIds: $excludedTagsIds
    searchTerm: $searchTerm
    sort: $sort
  ) {
    totalPages
    totalElements
    data {
      ...ClientListFields
    }
  }
}
    ${ClientListFieldsFragmentDoc}`;

/**
 * __useSalesQualifiedFutureQuery__
 *
 * To run a query within a React component, call `useSalesQualifiedFutureQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesQualifiedFutureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesQualifiedFutureQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      pageInput: // value for 'pageInput'
 *      excludedTagsIds: // value for 'excludedTagsIds'
 *      includedTagsIds: // value for 'includedTagsIds'
 *      searchTerm: // value for 'searchTerm'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSalesQualifiedFutureQuery(baseOptions: Apollo.QueryHookOptions<SalesQualifiedFutureQuery, SalesQualifiedFutureQueryVariables> & ({ variables: SalesQualifiedFutureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesQualifiedFutureQuery, SalesQualifiedFutureQueryVariables>(SalesQualifiedFutureDocument, options);
      }
export function useSalesQualifiedFutureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesQualifiedFutureQuery, SalesQualifiedFutureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesQualifiedFutureQuery, SalesQualifiedFutureQueryVariables>(SalesQualifiedFutureDocument, options);
        }
export function useSalesQualifiedFutureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SalesQualifiedFutureQuery, SalesQualifiedFutureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SalesQualifiedFutureQuery, SalesQualifiedFutureQueryVariables>(SalesQualifiedFutureDocument, options);
        }
export type SalesQualifiedFutureQueryHookResult = ReturnType<typeof useSalesQualifiedFutureQuery>;
export type SalesQualifiedFutureLazyQueryHookResult = ReturnType<typeof useSalesQualifiedFutureLazyQuery>;
export type SalesQualifiedFutureSuspenseQueryHookResult = ReturnType<typeof useSalesQualifiedFutureSuspenseQuery>;
export type SalesQualifiedFutureQueryResult = Apollo.QueryResult<SalesQualifiedFutureQuery, SalesQualifiedFutureQueryVariables>;
export const ContactedDocument = gql`
    query contacted($agentId: UUID!, $pageInput: PageInput!, $sort: ClientViewSortInput) {
  contacted(agentId: $agentId, pageInput: $pageInput, sort: $sort) {
    totalPages
    totalElements
    data {
      ...ClientListFields
    }
  }
}
    ${ClientListFieldsFragmentDoc}`;

/**
 * __useContactedQuery__
 *
 * To run a query within a React component, call `useContactedQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactedQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      pageInput: // value for 'pageInput'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useContactedQuery(baseOptions: Apollo.QueryHookOptions<ContactedQuery, ContactedQueryVariables> & ({ variables: ContactedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactedQuery, ContactedQueryVariables>(ContactedDocument, options);
      }
export function useContactedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactedQuery, ContactedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactedQuery, ContactedQueryVariables>(ContactedDocument, options);
        }
export function useContactedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactedQuery, ContactedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactedQuery, ContactedQueryVariables>(ContactedDocument, options);
        }
export type ContactedQueryHookResult = ReturnType<typeof useContactedQuery>;
export type ContactedLazyQueryHookResult = ReturnType<typeof useContactedLazyQuery>;
export type ContactedSuspenseQueryHookResult = ReturnType<typeof useContactedSuspenseQuery>;
export type ContactedQueryResult = Apollo.QueryResult<ContactedQuery, ContactedQueryVariables>;
export const AgentAssignedToClientDocument = gql`
    query agentAssignedToClient($clientId: UUID!) {
  agentAssignedToClient(clientId: $clientId) {
    id
  }
}
    `;

/**
 * __useAgentAssignedToClientQuery__
 *
 * To run a query within a React component, call `useAgentAssignedToClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentAssignedToClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentAssignedToClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useAgentAssignedToClientQuery(baseOptions: Apollo.QueryHookOptions<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables> & ({ variables: AgentAssignedToClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables>(AgentAssignedToClientDocument, options);
      }
export function useAgentAssignedToClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables>(AgentAssignedToClientDocument, options);
        }
export function useAgentAssignedToClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables>(AgentAssignedToClientDocument, options);
        }
export type AgentAssignedToClientQueryHookResult = ReturnType<typeof useAgentAssignedToClientQuery>;
export type AgentAssignedToClientLazyQueryHookResult = ReturnType<typeof useAgentAssignedToClientLazyQuery>;
export type AgentAssignedToClientSuspenseQueryHookResult = ReturnType<typeof useAgentAssignedToClientSuspenseQuery>;
export type AgentAssignedToClientQueryResult = Apollo.QueryResult<AgentAssignedToClientQuery, AgentAssignedToClientQueryVariables>;
export const GmailMessagesByEmailDocument = gql`
    query gmailMessagesByEmail($email: String!) {
  gmailMessagesByEmail(email: $email) {
    id
    agentId
    body
    createdAt
    from
    snippet
    subject
    to
  }
}
    `;

/**
 * __useGmailMessagesByEmailQuery__
 *
 * To run a query within a React component, call `useGmailMessagesByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGmailMessagesByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGmailMessagesByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGmailMessagesByEmailQuery(baseOptions: Apollo.QueryHookOptions<GmailMessagesByEmailQuery, GmailMessagesByEmailQueryVariables> & ({ variables: GmailMessagesByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GmailMessagesByEmailQuery, GmailMessagesByEmailQueryVariables>(GmailMessagesByEmailDocument, options);
      }
export function useGmailMessagesByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GmailMessagesByEmailQuery, GmailMessagesByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GmailMessagesByEmailQuery, GmailMessagesByEmailQueryVariables>(GmailMessagesByEmailDocument, options);
        }
export function useGmailMessagesByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GmailMessagesByEmailQuery, GmailMessagesByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GmailMessagesByEmailQuery, GmailMessagesByEmailQueryVariables>(GmailMessagesByEmailDocument, options);
        }
export type GmailMessagesByEmailQueryHookResult = ReturnType<typeof useGmailMessagesByEmailQuery>;
export type GmailMessagesByEmailLazyQueryHookResult = ReturnType<typeof useGmailMessagesByEmailLazyQuery>;
export type GmailMessagesByEmailSuspenseQueryHookResult = ReturnType<typeof useGmailMessagesByEmailSuspenseQuery>;
export type GmailMessagesByEmailQueryResult = Apollo.QueryResult<GmailMessagesByEmailQuery, GmailMessagesByEmailQueryVariables>;
export const SaveClientWatchersDocument = gql`
    mutation saveClientWatchers($input: ClientWatcherInput!) {
  saveClientWatchers(input: $input)
}
    `;
export type SaveClientWatchersMutationFn = Apollo.MutationFunction<SaveClientWatchersMutation, SaveClientWatchersMutationVariables>;

/**
 * __useSaveClientWatchersMutation__
 *
 * To run a mutation, you first call `useSaveClientWatchersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveClientWatchersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveClientWatchersMutation, { data, loading, error }] = useSaveClientWatchersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveClientWatchersMutation(baseOptions?: Apollo.MutationHookOptions<SaveClientWatchersMutation, SaveClientWatchersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveClientWatchersMutation, SaveClientWatchersMutationVariables>(SaveClientWatchersDocument, options);
      }
export type SaveClientWatchersMutationHookResult = ReturnType<typeof useSaveClientWatchersMutation>;
export type SaveClientWatchersMutationResult = Apollo.MutationResult<SaveClientWatchersMutation>;
export type SaveClientWatchersMutationOptions = Apollo.BaseMutationOptions<SaveClientWatchersMutation, SaveClientWatchersMutationVariables>;
export const AssignmentHistoryDocument = gql`
    query assignmentHistory($clientId: UUID!) {
  assignmentHistory(clientId: $clientId) {
    agentName
    assignmentDate
    assignmentType
  }
}
    `;

/**
 * __useAssignmentHistoryQuery__
 *
 * To run a query within a React component, call `useAssignmentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentHistoryQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useAssignmentHistoryQuery(baseOptions: Apollo.QueryHookOptions<AssignmentHistoryQuery, AssignmentHistoryQueryVariables> & ({ variables: AssignmentHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignmentHistoryQuery, AssignmentHistoryQueryVariables>(AssignmentHistoryDocument, options);
      }
export function useAssignmentHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignmentHistoryQuery, AssignmentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignmentHistoryQuery, AssignmentHistoryQueryVariables>(AssignmentHistoryDocument, options);
        }
export function useAssignmentHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssignmentHistoryQuery, AssignmentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssignmentHistoryQuery, AssignmentHistoryQueryVariables>(AssignmentHistoryDocument, options);
        }
export type AssignmentHistoryQueryHookResult = ReturnType<typeof useAssignmentHistoryQuery>;
export type AssignmentHistoryLazyQueryHookResult = ReturnType<typeof useAssignmentHistoryLazyQuery>;
export type AssignmentHistorySuspenseQueryHookResult = ReturnType<typeof useAssignmentHistorySuspenseQuery>;
export type AssignmentHistoryQueryResult = Apollo.QueryResult<AssignmentHistoryQuery, AssignmentHistoryQueryVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($clientId: UUID!) {
  resetPassword(clientId: $clientId)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const MissingAppTotalDocument = gql`
    query missingAppTotal($missingAppTagId: UUID!) {
  clientViews(
    pageInput: {page: 0, size: 1}
    filterInput: {tags: [$missingAppTagId]}
  ) {
    totalElements
  }
}
    `;

/**
 * __useMissingAppTotalQuery__
 *
 * To run a query within a React component, call `useMissingAppTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMissingAppTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMissingAppTotalQuery({
 *   variables: {
 *      missingAppTagId: // value for 'missingAppTagId'
 *   },
 * });
 */
export function useMissingAppTotalQuery(baseOptions: Apollo.QueryHookOptions<MissingAppTotalQuery, MissingAppTotalQueryVariables> & ({ variables: MissingAppTotalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MissingAppTotalQuery, MissingAppTotalQueryVariables>(MissingAppTotalDocument, options);
      }
export function useMissingAppTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MissingAppTotalQuery, MissingAppTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MissingAppTotalQuery, MissingAppTotalQueryVariables>(MissingAppTotalDocument, options);
        }
export function useMissingAppTotalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MissingAppTotalQuery, MissingAppTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MissingAppTotalQuery, MissingAppTotalQueryVariables>(MissingAppTotalDocument, options);
        }
export type MissingAppTotalQueryHookResult = ReturnType<typeof useMissingAppTotalQuery>;
export type MissingAppTotalLazyQueryHookResult = ReturnType<typeof useMissingAppTotalLazyQuery>;
export type MissingAppTotalSuspenseQueryHookResult = ReturnType<typeof useMissingAppTotalSuspenseQuery>;
export type MissingAppTotalQueryResult = Apollo.QueryResult<MissingAppTotalQuery, MissingAppTotalQueryVariables>;
export const UrgentMissingAppDocument = gql`
    query urgentMissingApp($missingAppTagId: UUID!) {
  clientViews(
    pageInput: {size: 20, page: 0}
    filterInput: {tags: [$missingAppTagId]}
    sort: {direction: asc, field: createdAt}
  ) {
    totalElements
    data {
      ...ClientListFields
    }
  }
}
    ${ClientListFieldsFragmentDoc}`;

/**
 * __useUrgentMissingAppQuery__
 *
 * To run a query within a React component, call `useUrgentMissingAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useUrgentMissingAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUrgentMissingAppQuery({
 *   variables: {
 *      missingAppTagId: // value for 'missingAppTagId'
 *   },
 * });
 */
export function useUrgentMissingAppQuery(baseOptions: Apollo.QueryHookOptions<UrgentMissingAppQuery, UrgentMissingAppQueryVariables> & ({ variables: UrgentMissingAppQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UrgentMissingAppQuery, UrgentMissingAppQueryVariables>(UrgentMissingAppDocument, options);
      }
export function useUrgentMissingAppLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UrgentMissingAppQuery, UrgentMissingAppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UrgentMissingAppQuery, UrgentMissingAppQueryVariables>(UrgentMissingAppDocument, options);
        }
export function useUrgentMissingAppSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UrgentMissingAppQuery, UrgentMissingAppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UrgentMissingAppQuery, UrgentMissingAppQueryVariables>(UrgentMissingAppDocument, options);
        }
export type UrgentMissingAppQueryHookResult = ReturnType<typeof useUrgentMissingAppQuery>;
export type UrgentMissingAppLazyQueryHookResult = ReturnType<typeof useUrgentMissingAppLazyQuery>;
export type UrgentMissingAppSuspenseQueryHookResult = ReturnType<typeof useUrgentMissingAppSuspenseQuery>;
export type UrgentMissingAppQueryResult = Apollo.QueryResult<UrgentMissingAppQuery, UrgentMissingAppQueryVariables>;
export const CalendarEventsDocument = gql`
    query calendarEvents($agentEmail: String, $input: ListCalendarEventsInput!) {
  calendarEvents(agentEmail: $agentEmail, input: $input) {
    events {
      ...CalendarEventFields
    }
    nextPageToken
  }
}
    ${CalendarEventFieldsFragmentDoc}`;

/**
 * __useCalendarEventsQuery__
 *
 * To run a query within a React component, call `useCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventsQuery({
 *   variables: {
 *      agentEmail: // value for 'agentEmail'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarEventsQuery(baseOptions: Apollo.QueryHookOptions<CalendarEventsQuery, CalendarEventsQueryVariables> & ({ variables: CalendarEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, options);
      }
export function useCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventsQuery, CalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, options);
        }
export function useCalendarEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventsQuery, CalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, options);
        }
export type CalendarEventsQueryHookResult = ReturnType<typeof useCalendarEventsQuery>;
export type CalendarEventsLazyQueryHookResult = ReturnType<typeof useCalendarEventsLazyQuery>;
export type CalendarEventsSuspenseQueryHookResult = ReturnType<typeof useCalendarEventsSuspenseQuery>;
export type CalendarEventsQueryResult = Apollo.QueryResult<CalendarEventsQuery, CalendarEventsQueryVariables>;
export const CreateCalendarEventDocument = gql`
    mutation createCalendarEvent($agentEmail: String, $input: CreateCalendarEventInput!) {
  createCalendarEvent(agentEmail: $agentEmail, input: $input) {
    ...CalendarEventFields
  }
}
    ${CalendarEventFieldsFragmentDoc}`;
export type CreateCalendarEventMutationFn = Apollo.MutationFunction<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>;

/**
 * __useCreateCalendarEventMutation__
 *
 * To run a mutation, you first call `useCreateCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalendarEventMutation, { data, loading, error }] = useCreateCalendarEventMutation({
 *   variables: {
 *      agentEmail: // value for 'agentEmail'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>(CreateCalendarEventDocument, options);
      }
export type CreateCalendarEventMutationHookResult = ReturnType<typeof useCreateCalendarEventMutation>;
export type CreateCalendarEventMutationResult = Apollo.MutationResult<CreateCalendarEventMutation>;
export type CreateCalendarEventMutationOptions = Apollo.BaseMutationOptions<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>;
export const UpdateCalendarEventDocument = gql`
    mutation updateCalendarEvent($eventId: String!, $input: UpdateCalendarEventInput!, $agentEmail: String) {
  updateCalendarEvent(eventId: $eventId, input: $input, agentEmail: $agentEmail) {
    ...CalendarEventFields
  }
}
    ${CalendarEventFieldsFragmentDoc}`;
export type UpdateCalendarEventMutationFn = Apollo.MutationFunction<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>;

/**
 * __useUpdateCalendarEventMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarEventMutation, { data, loading, error }] = useUpdateCalendarEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *      agentEmail: // value for 'agentEmail'
 *   },
 * });
 */
export function useUpdateCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>(UpdateCalendarEventDocument, options);
      }
export type UpdateCalendarEventMutationHookResult = ReturnType<typeof useUpdateCalendarEventMutation>;
export type UpdateCalendarEventMutationResult = Apollo.MutationResult<UpdateCalendarEventMutation>;
export type UpdateCalendarEventMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables>;
export const DeleteCalendarEventDocument = gql`
    mutation deleteCalendarEvent($eventId: String!, $agentEmail: String) {
  deleteCalendarEvent(eventId: $eventId, agentEmail: $agentEmail)
}
    `;
export type DeleteCalendarEventMutationFn = Apollo.MutationFunction<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>;

/**
 * __useDeleteCalendarEventMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCalendarEventMutation, { data, loading, error }] = useDeleteCalendarEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      agentEmail: // value for 'agentEmail'
 *   },
 * });
 */
export function useDeleteCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>(DeleteCalendarEventDocument, options);
      }
export type DeleteCalendarEventMutationHookResult = ReturnType<typeof useDeleteCalendarEventMutation>;
export type DeleteCalendarEventMutationResult = Apollo.MutationResult<DeleteCalendarEventMutation>;
export type DeleteCalendarEventMutationOptions = Apollo.BaseMutationOptions<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>;
export const RespondToCalendarEventDocument = gql`
    mutation respondToCalendarEvent($eventId: String!, $response: CalendarEventResponse!, $agentEmail: String) {
  respondToCalendarEvent(
    eventId: $eventId
    response: $response
    agentEmail: $agentEmail
  ) {
    ...CalendarEventFields
  }
}
    ${CalendarEventFieldsFragmentDoc}`;
export type RespondToCalendarEventMutationFn = Apollo.MutationFunction<RespondToCalendarEventMutation, RespondToCalendarEventMutationVariables>;

/**
 * __useRespondToCalendarEventMutation__
 *
 * To run a mutation, you first call `useRespondToCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToCalendarEventMutation, { data, loading, error }] = useRespondToCalendarEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      response: // value for 'response'
 *      agentEmail: // value for 'agentEmail'
 *   },
 * });
 */
export function useRespondToCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<RespondToCalendarEventMutation, RespondToCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondToCalendarEventMutation, RespondToCalendarEventMutationVariables>(RespondToCalendarEventDocument, options);
      }
export type RespondToCalendarEventMutationHookResult = ReturnType<typeof useRespondToCalendarEventMutation>;
export type RespondToCalendarEventMutationResult = Apollo.MutationResult<RespondToCalendarEventMutation>;
export type RespondToCalendarEventMutationOptions = Apollo.BaseMutationOptions<RespondToCalendarEventMutation, RespondToCalendarEventMutationVariables>;
export const CalendarEventUpdatesDocument = gql`
    subscription calendarEventUpdates($agentEmail: String) {
  calendarEventUpdates(agentEmail: $agentEmail) {
    agentEmail
    changeType
    eventId
    event {
      ...CalendarEventFields
    }
  }
}
    ${CalendarEventFieldsFragmentDoc}`;

/**
 * __useCalendarEventUpdatesSubscription__
 *
 * To run a query within a React component, call `useCalendarEventUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventUpdatesSubscription({
 *   variables: {
 *      agentEmail: // value for 'agentEmail'
 *   },
 * });
 */
export function useCalendarEventUpdatesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CalendarEventUpdatesSubscription, CalendarEventUpdatesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CalendarEventUpdatesSubscription, CalendarEventUpdatesSubscriptionVariables>(CalendarEventUpdatesDocument, options);
      }
export type CalendarEventUpdatesSubscriptionHookResult = ReturnType<typeof useCalendarEventUpdatesSubscription>;
export type CalendarEventUpdatesSubscriptionResult = Apollo.SubscriptionResult<CalendarEventUpdatesSubscription>;